





































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Card from '@/components/UI/Card.vue';
import CSelect from '@/components/UI/CoefficientSelect.vue';
import CollapseCard from '@/components/UI/CollapseCard.vue'
import ColumnTitleContent from '@/components/UI/Table/ColumnTitleContent.vue';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import vSelect from '@/components/UI/vSelect.vue';
import ApprovalStatusBadge from '@/components/UI/ApprovalStatusBadge.vue';
import ApprovedByColumn from '@/components/UI/ApprovedByColumn.vue';
import PartialRejectionNote from '@/components/UI/PartialRejectionNote.vue';
import NoteIndicator from '@/components/UI/NoteIndicator.vue';
import {TableHeaders} from '@/interfaces/components-data';
import {SelectBox} from '@/interfaces/global-data';
import {formatPurchasePriceDeviationPercent} from '@/utils/eventTriggerTypes';
import {
    isCalculationDepthValid,
    isCalculationDayValid,
    isDepthToPurchasePriceValid,
    isCalculationDepthInRange,
    isCalculationDayInRange,
} from '@/utils/salesDepthLimits';
import AllSkusTab from '@/components/ResultViewTabs/AllSkusTab.vue';

import {
    ChangesPrices,
    CompetitorsPriceStrategies,
    DetailReportsPricesAndCodes,
    FtpDownloadProgress,
    InternalCodesWithCorrPrices,
    isTaskInBackgroundGeneratableTypesAndStatuses,
    PackageParamsInDetailReportFilters,
    ReportDetailColumnsForAddOrDelete,
    ReportDetailFieldsView,
    ReportDetailParams,
    ReportDetailSegments,
    ResultTableDetailReports,
    ResultTableHeaders,
    SortingField,
    TaskAndFile,
    TaskData,
    UniqSkuData,
    TaskStatus,
    TaskType,
    taskTypesRequiresConfirmation,
    ApprovalStatus,
    PartialRejectionReason,
    PriceImportMode
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import Http from '@/mixins/http';
import {HttpExecutor} from '@/mixins/HttpExecutor';
import Toast from '@/mixins/toast';
import {FormatNumber} from '@/numberFormatter';
import { Formatter } from '@/helpers/formatters';
import {BModal} from 'bootstrap-vue';
import moment from 'moment';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import draggable from 'vuedraggable';
import LocalData from '../mixins/local-data';
import MarketSelect from './MarketSelect.vue';
import MultiSelect from './MultiSelect.vue';
import { isValidNumberValue, numberGteZeroFeedbackKey, numberGteZeroState, formatEventTriggerDisplay as formatEventTriggerDisplayUtil } from "@/utils/utils";
import { Modal } from "ant-design-vue";

interface commonFilters {
    groups: [];
    categories: [];
    subcategories: [];
    storeFormat: [];
    storeRegion: [];
    storeCluster: [];
}

interface IFilterOptions {
    groups: Array<{ id: number | string, name: string }>;
    categories: Array<{ id: number | string, name: string }>;
    subcategories: Array<{ id: number | string, name: string }>;
    storeFormat: Array<{ id: number | string, name: string }>;
    storeRegion: Array<{ id: number | string, name: string }>;
    storeCluster: Array<{ id: number | string, name: string }>;
}

interface IInfoPayloadData {
    groups: string[];
    categories: string[];
    subcategories: string[];
    storeFormat: string[];
    storeRegion: string[];
    storeCluster: string[];
    tradingId: number;
    type: string;
}

interface IColumnLight {
    dataIndex: string;
    title: string;
    customRender?: (value: any, record?: any, index?: number) => any;
    formatter?: (value: any, key?: string, item?: any) => any;
}

@Component({
    components: {
        ColumnTitleContent,
        MultiSelect,
        MarketSelect,
        vSelect,
        LocalData,
        CollapseCard,
        Card,
        CSelect,
        draggable,
        SwitchWithLabel,
        AllSkusTab,
        ApprovalStatusBadge,
        ApprovedByColumn,
        PartialRejectionNote,
        NoteIndicator,
    },
    computed: {
        isValidNumberValue() {
            return isValidNumberValue;
        }
    },
    methods: {
        changeRowColorInDetailReport(item) {
            if (item !== null) {
                if (item.kvi === 'ДА') { // "KVI"
                        if (!item.activeProduct) {
                            return 'blue strikethroughRow'
                        } else {
                            return 'blue';
                        }
                }
                if (item.ctm === 'ДА') { // "CTM"
                    if (!item.activeProduct) {
                        return 'pale-yellow strikethroughRow'
                    } else {
                        return 'pale-yellow';
                    }
                }
                if (item.resultType === 'COMPETITOR') { // this.$t('regular.tooltips.competitivePricingProduct') as string
                    if (!item.activeProduct) {
                        return 'light-pink strikethroughRow'
                    } else {
                        return 'light-pink';
                    }
                }
                if (item.newPrice > item.limitRetailPrice) { // this.$t('regular.tooltips.newPriceAboveMaxAllowed') as string
                    if (!item.activeProduct) {
                        return 'bright-yellow strikethroughRow'
                    } else {
                        return 'bright-yellow';
                    }
                }
                if (item.wasPromoInRotationPeriod) { // this.$t('regular.tooltips.productInPromoRotation') as string
                    if (!item.activeProduct) {
                        return 'aqua strikethroughRow'
                    } else {
                        return 'aqua';
                    }
                }
                if (!item.activeProduct) {
                        return 'strikethroughRow'
                }
                if (item.eventTrigger) { // this.$t('regular.tooltips.eventProduct') as string
                        return 'table eventTriggerColor'
                    }
                }
            },
            replaceCommaFormatter(value) {
                return value.replace(',', '.')
            },

            replaceDecimalFormatter(value) {
                if (value == null) {
                    return null
                } else {
                    return parseFloat(value.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1').replace(',', '.'));
                }
            },

            replaceTxtToNumber(value) {
                if (value == null) {
                    return null
                } else {
                    return value.replace(/[^\d]/g, '').substring(0, 2);
                }
            },
        },
        filters: {
            formatDate: (v: any) => {
                if (v) {
                    return moment(new Date(+v)).format('DD/MM/YYYY');
                }
            },
        },
    })
export default class ResultView extends Mixins(LocalData, Toast, Http) {
        // @ts-ignore
        @Prop() taskData: TaskAndFile | null;
        formatEventTriggerDisplay = formatEventTriggerDisplayUtil;
        correctedPricesFile: File | null = null;
        progressCounter: number = 0;
        loadProgress: boolean = false;
        incorrectPeriodErrorText: string = '';
        marginalErrorText = '';
        marginalSkuErrorText = '';
        findAutomaticallyPriceSegments: boolean = false;
        countPriceSegments: number = 1;
        showDataRange: boolean = false;
        httpExecutor: HttpExecutor = new HttpExecutor();
        showDeleteSingleReportModal: boolean = false;
        taskIdForDelete: number = -1;
        subTaskIdForSendToFTP: number = -1;
        detailUserFields: ReportDetailFieldsView[] = [];
        detailColumnsListForAddFields: ReportDetailFieldsView[] = []
        detailColumnsListForDeleteFields: ReportDetailFieldsView[] = []
        isDownloadAllFiltersName: boolean = false
        showSendToFTPReportModal: boolean = false;
        showSortingModal: boolean = false;
        showSendToFTPSubTaskReportModal: boolean = false;
        resultTableHeadersPerPage: number = 20;
        subtasksListCurrentPage: number = 1;
        subtasksTotalRows: number = 1;
        subtasksListPerPage: number = 25;
        tableIsLoading: boolean = false;
        isAllSkusCommonCheckboxSelectedFunctionally: boolean = true;
        
        // Partial Rejection Note properties
        showPartialRejectionNote: boolean = false;
        partialRejectionReason: string = 'NEW_VERSION';
        partialRejectionDate: Date | null = null;
        partialRejectionMessage: string = '';
        partialRejectionAdditionalInfo: string = '';
        includedSkusProperties: Set<string> = new Set();
        excludedSkusProperties: Set<string> = new Set();
        arrayOfPushedInactiveSkus: UniqSkuData[] = [];
        isFilteredSkusDisplayed: boolean = false;
        tableCheckboxesPrevConfiguration: {
            selectActiveProductsOnly: boolean,
            isAllSkusCommonCheckboxSelectedFunctionally: boolean,
            includedSkusProperties: Set<string>,
            excludedSkusProperties: Set<string>,
        } = {
            selectActiveProductsOnly: true,
            isAllSkusCommonCheckboxSelectedFunctionally: true,
            includedSkusProperties: new Set(),
            excludedSkusProperties: new Set(),
        };
        resultDetailReportPerPage: number = 100;
        detailTableIdName: string = 'resultDetailReport';
        resultTableHeaderCurrentPage: number = 1;
        resultDetailReportCurrentPage: number = 1;
        detailReportTotalRows: number = 0;
        downloadLastExcelDetailByFilters: boolean = false;
        skuListCurrentPage: number = 1;
        downloadLastExcelHeaderByFilters: boolean = false;
        resultTableHeaders: ResultTableHeaders[] = [];
        resultGeneralSubtasksTableHeaders: ResultTableHeaders[] = [];
        resultTableDetailReports: ResultTableDetailReports[] = [];
        tableKey: number = 1;
        reportType: 'regular' | 'promo' | 'sales' | 'price-exp' = 'regular';
        isPackageOrScheduleReport: boolean = false;
        isPackagePromoReport: boolean = false;
        isGeneralRegularPackage: boolean = false;
        showDeletedItems: boolean = false;
        detailTableSkuFilter: string = '';
        refreshHeaderTableId = -1;
        refreshDetailTableId = -1;
        selectActiveProductsOnly: boolean = true;

        sortingField: SortingField | null = null
        defaultFilterValue = {value: -1, label: this.$t('shared.selectBox.all') as string};
        defaultStringFiltersValue = {value: '', label: this.$t('shared.selectBox.all') as string};
        showGeneralComparableBlock: boolean = true;
        showOverlay: boolean = false;
        paramsForDetail: DetailReportsPricesAndCodes = new DetailReportsPricesAndCodes()
        changesPrices: ChangesPrices[] = []
        allFilteredSkusUniqueData: Set<string> = new Set();
        disableSelectedReports: boolean = true
        hasCorrectedPrices: boolean = false
        eventTriggerOptions: Array<SelectBox<number>> = [
            {value: -1, label: this.$t('shared.selectBox.all') as string},
            {value: 1, label: this.$t('shared.boolFilter.yes') as string},
            {value: 0, label: this.$t('shared.boolFilter.no') as string},
        ];
        regularColumnsForManageModal: Array<IColumnLight> = [
            { dataIndex: "internalCode", title: this.$t('results.tableHeaders.internalCode') as string },
            { dataIndex: "skuName", title: this.$t('results.tableHeaders.skuName') as string },
            { dataIndex: "isApproved", title: this.$t('results.tableHeaders.approval') as string },
            { dataIndex: "approvedByFio", title: this.$t('results.tableHeaders.approvedBy') as string },
            { dataIndex: "status", title: this.$t('results.tableHeaders.status') as string },
            { dataIndex: "detailedStatus", title: this.$t('salesMonitorTab.tables.detailColumns.detailedStatus') as string },
            { dataIndex: "uploadFile", title: this.$t('salesMonitorTab.tables.detailColumns.uploadFile') as string },
            { dataIndex: "newPrice", title: this.$t('results.tableHeaders.newPrice') as string },
            { dataIndex: "newPriceHistory", title: this.$t('results.tableHeaders.newPriceHistory') as string },
            { dataIndex: "correctedRegularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.correctedRegularPrice') as string },
            { dataIndex: "newMarginPc", title: this.$t('salesMonitorTab.tables.detailColumns.newMarginPc') as string },
            { dataIndex: "newPI", title: this.$t('salesMonitorTab.tables.detailColumns.newPI') as string },
            { dataIndex: "deltaDiffPrice", title: this.$t('salesMonitorTab.tables.detailColumns.deltaDiffPrice') as string },
            { dataIndex: "priceDiffPc", title: this.$t('salesMonitorTab.tables.detailColumns.priceDiffPc') as string },
            { dataIndex: "marginDiff", title: this.$t('salesMonitorTab.tables.detailColumns.marginDiff') as string },
            { dataIndex: "changedPI", title: this.$t('salesMonitorTab.tables.detailColumns.changedPI') as string },
            { dataIndex: "exitSegment", title: this.$t('salesMonitorTab.tables.detailColumns.exitSegment') as string },
            { dataIndex: "coeffElasticity", title: this.$t('salesMonitorTab.tables.detailColumns.coeffElasticity') as string },
            { dataIndex: "remains", title: this.$t('salesMonitorTab.tables.reportColumns.remains') as string },
            { dataIndex: "salesForecast", title: this.$t('salesMonitorTab.tables.detailColumns.salesForecast') as string },
            { dataIndex: "revenueForecast", title: this.$t('salesMonitorTab.tables.detailColumns.revenueForecast') as string },
            { dataIndex: "marginForecast", title: this.$t('salesMonitorTab.tables.detailColumns.marginForecast') as string },
            { dataIndex: "marginForecastPc", title: this.$t('salesMonitorTab.tables.detailColumns.marginForecastPc') as string },
            { dataIndex: "changeSales", title: this.$t('salesMonitorTab.tables.detailColumns.changeSales') as string },
            { dataIndex: "changeRevenue", title: this.$t('salesMonitorTab.tables.detailColumns.changeRevenue') as string },
            { dataIndex: "changeMargin", title: this.$t('salesMonitorTab.tables.detailColumns.changeMargin') as string },
            { dataIndex: "salesDiffPc", title: this.$t('salesMonitorTab.tables.detailColumns.salesDiffPc') as string },
            { dataIndex: "revenueDiffPc", title: this.$t('salesMonitorTab.tables.detailColumns.revenueDiffPc') as string },
            { dataIndex: "marginDiffPc", title: this.$t('salesMonitorTab.tables.detailColumns.marginDiffPc') as string },
            { dataIndex: "marginDiffSecond", title: this.$t('salesMonitorTab.tables.detailColumns.marginDiff') as string },
            { dataIndex: "salesForecastByRegularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.salesForecastByRegularPrice') as string },
            { dataIndex: "revenueForecastByRegularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.revenueForecastByRegularPrice') as string },
            { dataIndex: "marginForecastByRegularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.marginForecastByRegularPrice') as string },
            { dataIndex: "marginForecastByRegularPricePc", title: this.$t('salesMonitorTab.tables.detailColumns.marginForecastByRegularPricePc') as string },
            { dataIndex: "changeSalesByRegularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.changeSalesByRegularPrice') as string },
            { dataIndex: "changeRevenueByRegularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.changeRevenueByRegularPrice') as string },
            { dataIndex: "changeMarginByRegularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.changeMarginByRegularPrice') as string },
            { dataIndex: "salesDiffPcByRegularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.salesDiffPcByRegularPrice') as string },
            { dataIndex: "revenueDiffPcByRegularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.revenueDiffPcByRegularPrice') as string },
            { dataIndex: "marginDiffPcByRegularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.marginDiffPcByRegularPrice') as string },
            { dataIndex: "marginDiffSecondByRegularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.marginDiffSecondByRegularPrice') as string },
            { dataIndex: "priceTagChangeExpense", title: this.$t('salesMonitorTab.tables.reportColumns.priceTagChangeExpense') as string },
            { dataIndex: "taskId", title: this.$t('results.tableHeaders.taskId') as string },
            { dataIndex: "groupName", title: this.$t('results.tableHeaders.productGroup') as string },
            { dataIndex: "categoryName", title: this.$t('results.tableHeaders.productCategory') as string },
            { dataIndex: "subCategoryName", title: this.$t('results.tableHeaders.productSubcategory') as string },
            { dataIndex: "formatName", title: this.$t('results.tableHeaders.formatChannel') as string },
            { dataIndex: "regionName", title: this.$t('results.tableHeaders.storeRegion') as string },
            { dataIndex: "clusterName", title: this.$t('results.tableHeaders.storeCluster') as string },
            { dataIndex: "productSegmentName", title: this.$t('results.tableHeaders.productSegment') as string },
            { dataIndex: "batchNumber", title: this.$t('results.tableHeaders.batchNumber') as string },
            { dataIndex: "recipeAttribute", title: this.$t('results.tableHeaders.prc') as string },
            { dataIndex: "treatmentAttribute", title: this.$t('results.tableHeaders.pkl') as string },
            { dataIndex: "vitalMedicine", title: this.$t('results.tableHeaders.vitalMedicine') as string },
            { dataIndex: "producerPrice", title: this.$t('results.tableHeaders.producerPrice') as string },
            { dataIndex: "extraChargePc", title: this.$t('results.tableHeaders.extraChargePc') as string },
            { dataIndex: "registrationPrice", title: this.$t('results.tableHeaders.registrationPrice') as string },
            { dataIndex: "eventTrigger", title: this.$t('results.tableHeaders.eventTrigger') as string },
            { dataIndex: "purchasePriceDeviationPercent", title: this.$t('results.tableHeaders.purchasePriceDeviationPercent') as string, customRender: (value: number | null) => formatPurchasePriceDeviationPercent(value)},
            { dataIndex: "kvi", title: "KVI", customRender: (value: string) => value === 'ДА' ? this.$t('shared.boolFilter.yes') as string : value === 'НЕТ' ? this.$t('shared.boolFilter.no') as string : value },
            { dataIndex: "ctm", title: this.$t('results.tableHeaders.ctm') as string, customRender: (value: string) => value === 'ДА' ? this.$t('shared.boolFilter.yes') as string : value === 'НЕТ' ? this.$t('shared.boolFilter.no') as string : value },
            { dataIndex: "ctmBrand", title: this.$t('results.tableHeaders.ctmBrand') as string },
            { dataIndex: "ctmPriceGap", title: this.$t('results.tableHeaders.ctmPriceGap') as string },
            { dataIndex: "minRetailPrice", title: this.$t('results.tableHeaders.minRetailPrice') as string },
            { dataIndex: "maxRetailPrice", title: this.$t('results.tableHeaders.maxRetailPrice') as string },
            { dataIndex: "omnichannelStrategy", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelStrategy') as string },
            { dataIndex: "omnichannelFixedGapType", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelFixedGapType') as string },
            { dataIndex: "omnichannelGap", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelGap') as string },
            { dataIndex: "omnichannelApplyCompetitorPrices", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelApplyCompetitorPrices') as string },
            { dataIndex: "omnichannelMinProfitabilityLimit", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelMinProfitabilityLimit') as string },
            { dataIndex: "omnichannelBaseChannelPrice", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelBaseChannelPrice') as string },
            { dataIndex: "keyProduct1", title: this.$t('results.tableHeaders.kht1') as string },
            { dataIndex: "keyProduct2", title: this.$t('results.tableHeaders.kht2') as string },
            { dataIndex: "keyProduct3", title: this.$t('results.tableHeaders.keyProduct3') as string },
            { dataIndex: "keyProduct4", title: this.$t('results.tableHeaders.keyProduct4') as string },
            { dataIndex: "keyProduct5", title: this.$t('results.tableHeaders.keyProduct5') as string },
            { dataIndex: "segment", title: this.$t('results.tableHeaders.segment') as string },
            { dataIndex: "skuLine", title: this.$t('results.tableHeaders.skuLine') as string },
            { dataIndex: "purchasePrice", title: this.$t('salesMonitorTab.tables.detailColumns.purchasePrice') as string },
            { dataIndex: "avgRegularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.avgRegularPrice') as string },
            { dataIndex: "avgCashPrice", title: this.$t('salesMonitorTab.tables.detailColumns.avgCashPrice') as string },
            { dataIndex: "avgCheckPrice", title: this.$t('salesMonitorTab.tables.detailColumns.avgCheckPrice') as string },
            { dataIndex: "regularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.regularPrice') as string },
            { dataIndex: "marginLastPrice", title: this.$t('salesMonitorTab.tables.detailColumns.marginLastPrice') as string },
            { dataIndex: "minCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorPrice') as string },
            { dataIndex: "minCompetitorName", title: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorName') as string },
            { dataIndex: "minCompetitorCode", title: this.$t('competitorsPricesList.tableHeaders.competitorCode') as string },
            { dataIndex: "maxCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.maxCompetitorPrice') as string },
            { dataIndex: "maxCompetitorName", title: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorName') as string },
            { dataIndex: "maxCompetitorCode", title: this.$t('competitorsPricesList.tableHeaders.competitorCode') as string },
            { dataIndex: "avgCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.avgCompetitorPrice') as string },
            { dataIndex: "lastCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.lastCompetitorPrice') as string },
            { dataIndex: "pi", title: "PI" },
            { dataIndex: "actualSales", title: this.$t('salesMonitorTab.tables.detailColumns.actualSales') as string },
            { dataIndex: "actualRevenue", title: this.$t('salesMonitorTab.tables.detailColumns.actualRevenue') as string },
            { dataIndex: "actualMargin", title: this.$t('salesMonitorTab.tables.detailColumns.actualMargin') as string },
            { dataIndex: "actualMarginPercent", title: this.$t('salesMonitorTab.tables.detailColumns.actualMarginPercent') as string },
            { dataIndex: "comparableSales", title: this.$t('salesMonitorTab.tables.detailColumns.comparableSales') as string },
            { dataIndex: "comparableRevenue", title: this.$t('salesMonitorTab.tables.detailColumns.comparableRevenue') as string },
            { dataIndex: "comparableMargin", title: this.$t('salesMonitorTab.tables.detailColumns.comparableMargin') as string },
            { dataIndex: "comparableMarginPc", title: this.$t('salesMonitorTab.tables.detailColumns.comparableMarginPc') as string },
            { dataIndex: "logisticCostsPercentage", title: this.$t('salesMonitorTab.tables.detailColumns.logisticCostsPercentage') as string },
            { dataIndex: "logisticCostsAmount", title: this.$t('salesMonitorTab.tables.detailColumns.logisticCostsAmount') as string },
            { dataIndex: "marketingPaymentsPercentage", title: this.$t('competitorsPricesList.tableHeaders.marketingPayments') as string },
            { dataIndex: "limitRetailPrice", title: this.$t('salesMonitorTab.tables.detailColumns.limitRetailPrice') as string },
            { dataIndex: "markupPercentage", title: this.$t('salesMonitorTab.tables.detailColumns.markupPercentage') as string },
            { dataIndex: "vatPercentage", title: this.$t('salesMonitorTab.tables.detailColumns.vatPercentage') as string },
            { dataIndex: "basePrice", title: this.$t('salesMonitorTab.tables.detailColumns.basePrice') as string },
            { dataIndex: "individualPriceOptStrategy", title: this.$t('salesMonitorTab.tables.detailColumns.individualPriceOptStrategy') as string },
            { dataIndex: "individualPriceIncreaseLimit", title: this.$t('salesMonitorTab.tables.detailColumns.individualPriceIncreaseLimit') as string },
            { dataIndex: "individualPeriodPriceIncreaseLimit", title: this.$t('salesMonitorTab.tables.detailColumns.individualPeriodPriceIncreaseLimit') as string },
            { dataIndex: "individualPeriod", title: this.$t('salesMonitorTab.tables.detailColumns.individualPeriod') as string },
            { dataIndex: "individualMarginalProfit", title: this.$t('salesMonitorTab.tables.detailColumns.individualMarginalProfit') as string },
            { dataIndex: "individualKviStrategy", title: this.$t('salesMonitorTab.tables.detailColumns.individualKviStrategy') as string },
            { dataIndex: "individualPercentCorrection", title: this.$t('salesMonitorTab.tables.detailColumns.individualPercentCorrection') as string },
            { dataIndex: "individualNewProductPriceStrategy", title: this.$t('salesMonitorTab.tables.detailColumns.individualNewProductPriceStrategy') as string },
            { dataIndex: "individualPriceGapPercent", title: this.$t('salesMonitorTab.tables.detailColumns.individualPriceGapPercent') as string },
            { dataIndex: "productVerticalLine", title: this.$t('competitorsPricesList.tableHeaders.vlName') as string },
            { dataIndex: "productVolume", title: this.$t('competitorsPricesList.tableHeaders.vgh') as string },
            { dataIndex: "measurementUnit", title: this.$t('competitorsPricesList.tableHeaders.ei') as string },
            { dataIndex: "isVerticalLineBase", title: this.$t('competitorsPricesList.tableHeaders.base') as string },
            { dataIndex: "vlStrategyStr", title: this.$t('competitorsPricesList.tableHeaders.vlStrategy') as string },
            { dataIndex: "vlGapPc", title: this.$t('competitorsPricesList.tableHeaders.vlGap') as string,
              customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType) },
            { dataIndex: "comment", title: this.$t('results.tableHeaders.comment') as string },
            { dataIndex: "priceExperimentSampleSize", title: this.$t('results.tableHeaders.priceExperimentSampleSize') as string },
            { dataIndex: "priceExperimentDiscountRangeFrom", title: this.$t('results.tableHeaders.priceExperimentDiscountRangeFrom') as string },
            { dataIndex: "priceExperimentDiscountRangeTo", title: this.$t('results.tableHeaders.priceExperimentDiscountRangeTo') as string },
            { dataIndex: "priceExperimentStep", title: this.$t('results.tableHeaders.priceExperimentStep') as string },
            { dataIndex: "priceExperimentStartDate", title: this.$t('results.tableHeaders.priceExperimentStartDate') as string },
            { dataIndex: "priceExperimentEndDate", title: this.$t('results.tableHeaders.priceExperimentEndDate') as string },
        ];

        promoColumnsForManageModal: Array<IColumnLight> = [
            { dataIndex: "internalCode", title: this.$t('results.tableHeaders.internalCode') as string },
            { dataIndex: "skuName", title: this.$t('results.tableHeaders.skuName') as string },
            { dataIndex: "salePointCode", title: this.$t('results.tableHeaders.salePointCode') as string },
            { dataIndex: "taskId", title: this.$t('results.tableHeaders.taskId') as string },
            { dataIndex: "status", title: this.$t('results.tableHeaders.status') as string },
            { dataIndex: "detailedStatus", title: this.$t('salesMonitorTab.tables.detailColumns.detailedStatus') as string },
            { dataIndex: "isApproved", title: this.$t('results.tableHeaders.approval') as string },
            { dataIndex: "approvedByFio", title: this.$t('results.tableHeaders.approvedBy') as string },
            { dataIndex: "newPrice", title: this.$t('results.tableHeaders.newPrice') as string },
            { dataIndex: "newPriceHistory", title: this.$t('results.tableHeaders.newPriceHistory') as string },
            { dataIndex: "optimalNewPromoPrice", title: this.$t('results.tableHeaders.optimalNewPromoPrice') as string },
            { dataIndex: "optimalDiscountDepth", title: this.$t('results.tableHeaders.optimalDiscountDepth') as string },
            { dataIndex: "firstDiscountForPromotion", title: this.$t('results.tableHeaders.firstDiscountForPromotion') as string },
            { dataIndex: "minPriceForPromotion", title: this.$t('results.tableHeaders.minPriceForPromotion') as string },
            { dataIndex: "maxPriceForPromotion", title: this.$t('results.tableHeaders.maxPriceForPromotion') as string },
            { dataIndex: "minDiscountForPromotion", title: this.$t('results.tableHeaders.minDiscountForPromotion') as string },
            { dataIndex: "maxDiscountForPromotion", title: this.$t('results.tableHeaders.maxDiscountForPromotion') as string },
            { dataIndex: "minMarginForPromotion", title: this.$t('results.tableHeaders.minMarginForPromotion') as string },
            { dataIndex: "marginLoss", title: this.$t('results.tableHeaders.marginLoss') as string },
            { dataIndex: "marginLossPc", title: this.$t('results.tableHeaders.marginLossPc') as string },
            { dataIndex: "remains", title: this.$t('salesMonitorTab.tables.reportColumns.remains') as string },
            { dataIndex: "groupName", title: this.$t('results.tableHeaders.productGroup') as string },
            { dataIndex: "categoryName", title: this.$t('results.tableHeaders.productCategory') as string },
            { dataIndex: "subCategoryName", title: this.$t('results.tableHeaders.productSubcategory') as string },
            { dataIndex: "formatName", title: this.$t('results.tableHeaders.formatChannel') as string },
            { dataIndex: "regionName", title: this.$t('results.tableHeaders.storeRegion') as string },
            { dataIndex: "clusterName", title: this.$t('results.tableHeaders.storeCluster') as string },
            { dataIndex: "productSegmentName", title: this.$t('results.tableHeaders.productSegment') as string },
            { dataIndex: "recipeAttribute", title: this.$t('results.tableHeaders.prc') as string },
            { dataIndex: "treatmentAttribute", title: this.$t('results.tableHeaders.pkl') as string },
            { dataIndex: "vitalMedicine", title: this.$t('results.tableHeaders.vitalMedicine') as string },
            { dataIndex: "producerPrice", title: this.$t('results.tableHeaders.producerPrice') as string },
            { dataIndex: "extraChargePc", title: this.$t('results.tableHeaders.extraChargePc') as string },
            { dataIndex: "registrationPrice", title: this.$t('results.tableHeaders.registrationPrice') as string },
            { dataIndex: "eventTrigger", title: this.$t('results.tableHeaders.eventTrigger') as string },
            { dataIndex: "purchasePriceDeviationPercent", title: this.$t('results.tableHeaders.purchasePriceDeviationPercent') as string, customRender: (value: number | null) => formatPurchasePriceDeviationPercent(value)},
            { dataIndex: "kvi", title: "KVI", customRender: (value: string) => value === 'ДА' ? this.$t('shared.boolFilter.yes') as string : value === 'НЕТ' ? this.$t('shared.boolFilter.no') as string : value },
            { dataIndex: "ctm", title: this.$t('results.tableHeaders.ctm') as string, customRender: (value: string) => value === 'ДА' ? this.$t('shared.boolFilter.yes') as string : value === 'НЕТ' ? this.$t('shared.boolFilter.no') as string : value },
            { dataIndex: "ctmBrand", title: this.$t('results.tableHeaders.ctmBrand') as string },
            { dataIndex: "ctmPriceGap", title: this.$t('results.tableHeaders.ctmPriceGap') as string },
            { dataIndex: "minRetailPrice", title: this.$t('results.tableHeaders.minRetailPrice') as string },
            { dataIndex: "maxRetailPrice", title: this.$t('results.tableHeaders.maxRetailPrice') as string },
            { dataIndex: "omnichannelStrategy", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelStrategy') as string },
            { dataIndex: "omnichannelFixedGapType", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelFixedGapType') as string },
            { dataIndex: "omnichannelGap", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelGap') as string },
            { dataIndex: "omnichannelApplyCompetitorPrices", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelApplyCompetitorPrices') as string },
            { dataIndex: "omnichannelMinProfitabilityLimit", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelMinProfitabilityLimit') as string },
            { dataIndex: "omnichannelBaseChannelPrice", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelBaseChannelPrice') as string },
            { dataIndex: "keyProduct1", title: this.$t('results.tableHeaders.kht1') as string },
            { dataIndex: "keyProduct2", title: this.$t('results.tableHeaders.kht2') as string },
            { dataIndex: "keyProduct3", title: this.$t('results.tableHeaders.keyProduct3') as string },
            { dataIndex: "keyProduct4", title: this.$t('results.tableHeaders.keyProduct4') as string },
            { dataIndex: "keyProduct5", title: this.$t('results.tableHeaders.keyProduct5') as string },
            { dataIndex: "segment", title: this.$t('results.tableHeaders.segment') as string },
            { dataIndex: "skuLine", title: this.$t('results.tableHeaders.skuLine') as string },
            { dataIndex: "purchasePrice", title: this.$t('salesMonitorTab.tables.detailColumns.purchasePrice') as string },
            { dataIndex: "promoPurchasePrice", title: this.$t('salesMonitorTab.tables.detailColumns.promoPurchasePrice') as string },
            { dataIndex: "avgRegularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.avgRegularPrice') as string },
            { dataIndex: "avgCashPrice", title: this.$t('salesMonitorTab.tables.detailColumns.avgCashPrice') as string },
            { dataIndex: "avgCheckPrice", title: this.$t('salesMonitorTab.tables.detailColumns.avgCheckPrice') as string },
            { dataIndex: "regularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.regularPrice') as string },
            { dataIndex: "marginLastPrice", title: this.$t('salesMonitorTab.tables.detailColumns.marginLastPrice') as string },
            { dataIndex: "minCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorPrice') as string },
            { dataIndex: "minCompetitorName", title: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorName') as string },
            { dataIndex: "minCompetitorCode", title: this.$t('competitorsPricesList.tableHeaders.competitorCode') as string },
            { dataIndex: "maxCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.maxCompetitorPrice') as string },
            { dataIndex: "maxCompetitorName", title: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorName') as string },
            { dataIndex: "maxCompetitorCode", title: this.$t('competitorsPricesList.tableHeaders.competitorCode') as string },
            { dataIndex: "avgCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.avgCompetitorPrice') as string },
            { dataIndex: "lastCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.lastCompetitorPrice') as string },
            { dataIndex: "minPromoCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.minPromoCompetitorPrice') as string },
            { dataIndex: "minPromoCompetitorName", title: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorName') as string },
            { dataIndex: "minPromoCompetitorCode", title: this.$t('competitorsPricesList.tableHeaders.competitorCode') as string },
            { dataIndex: "maxPromoCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.maxPromoCompetitorPrice') as string },
            { dataIndex: "maxPromoCompetitorName", title: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorName') as string },
            { dataIndex: "maxPromoCompetitorCode", title: this.$t('competitorsPricesList.tableHeaders.competitorCode') as string },
            { dataIndex: "medianPromoCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.medianPromoCompetitorPrice') as string },
            { dataIndex: "lastPromoCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.lastPromoCompetitorPrice') as string },
            { dataIndex: "pi", title: "PI" },
            { dataIndex: "promoPi", title: this.$t('results.tableHeaders.promoPi') as string },
            { dataIndex: "actualSales", title: this.$t('salesMonitorTab.tables.detailColumns.actualSales') as string },
            { dataIndex: "actualRevenue", title: this.$t('salesMonitorTab.tables.detailColumns.actualRevenue') as string },
            { dataIndex: "actualMargin", title: this.$t('salesMonitorTab.tables.detailColumns.actualMargin') as string },
            { dataIndex: "actualMarginPercent", title: this.$t('salesMonitorTab.tables.detailColumns.actualMarginPercent') as string },
            { dataIndex: "comparableSales", title: this.$t('salesMonitorTab.tables.detailColumns.comparableSales') as string },
            { dataIndex: "comparableRevenue", title: this.$t('salesMonitorTab.tables.detailColumns.comparableRevenue') as string },
            { dataIndex: "comparableMargin", title: this.$t('salesMonitorTab.tables.detailColumns.comparableMargin') as string },
            { dataIndex: "comparableMarginPc", title: this.$t('salesMonitorTab.tables.detailColumns.comparableMarginPc') as string },
            { dataIndex: "newPromoPrice", title: this.$t('results.tableHeaders.newPromoPriceWithCompetitors') as string },
            { dataIndex: "correctedPromoPrice", title: this.$t('salesMonitorTab.tables.detailColumns.correctedPromoPrice') as string },
            { dataIndex: "newMarginPc", title: this.$t('salesMonitorTab.tables.detailColumns.newMarginPc') as string },
            { dataIndex: "newPI", title: this.$t('salesMonitorTab.tables.detailColumns.newPI') as string },
            { dataIndex: "deltaDiffPrice", title: this.$t('salesMonitorTab.tables.detailColumns.deltaDiffPrice') as string },
            { dataIndex: "priceDiffPc", title: this.$t('salesMonitorTab.tables.detailColumns.priceDiffPc') as string },
            { dataIndex: "marginDiff", title: this.$t('salesMonitorTab.tables.detailColumns.marginDiff') as string },
            { dataIndex: "changedPI", title: this.$t('salesMonitorTab.tables.detailColumns.changedPI') as string },
            { dataIndex: "discountDepth", title: this.$t('results.tableHeaders.discountDepthWithCompetitors') as string },
            { dataIndex: "discountDuration", title: this.$t('salesMonitorTab.tables.detailColumns.discountDuration') as string },
            { dataIndex: "exitSegment", title: this.$t('salesMonitorTab.tables.detailColumns.exitSegment') as string },
            { dataIndex: "coeffElasticity", title: this.$t('salesMonitorTab.tables.detailColumns.coeffElasticity') as string },
            { dataIndex: "promoCoeffElasticity", title: this.$t('salesMonitorTab.tables.detailColumns.promoCoeffElasticity') as string },
            { dataIndex: "salesForecast", title: this.$t('salesMonitorTab.tables.detailColumns.salesForecast') as string },
            { dataIndex: "revenueForecast", title: this.$t('salesMonitorTab.tables.detailColumns.revenueForecast') as string },
            { dataIndex: "marginForecast", title: this.$t('salesMonitorTab.tables.detailColumns.marginForecast') as string },
            { dataIndex: "marginForecastPc", title: this.$t('salesMonitorTab.tables.detailColumns.marginForecastPc') as string },
            { dataIndex: "changeSales", title: this.$t('salesMonitorTab.tables.detailColumns.changeSales') as string },
            { dataIndex: "changeRevenue", title: this.$t('salesMonitorTab.tables.detailColumns.changeRevenue') as string },
            { dataIndex: "changeMargin", title: this.$t('salesMonitorTab.tables.detailColumns.changeMargin') as string },
            { dataIndex: "salesDiffPc", title: this.$t('salesMonitorTab.tables.detailColumns.salesDiffPc') as string },
            { dataIndex: "revenueDiffPc", title: this.$t('salesMonitorTab.tables.detailColumns.revenueDiffPc') as string },
            { dataIndex: "marginDiffPc", title: this.$t('salesMonitorTab.tables.detailColumns.marginDiffPc') as string },
            { dataIndex: "marginDiffSecond", title: this.$t('salesMonitorTab.tables.detailColumns.marginDiff') as string },
            { dataIndex: "individualPromoType", title: this.$t('salesMonitorTab.tables.detailColumns.individualPromoType') as string },
            { dataIndex: "individualPromoLift", title: this.$t('salesMonitorTab.tables.detailColumns.individualPromoLift') as string },
            { dataIndex: "individualPriceOptStrategy", title: this.$t('salesMonitorTab.tables.detailColumns.individualPriceOptStrategy') as string },
            { dataIndex: "individualPriceIncreaseLimit", title: this.$t('salesMonitorTab.tables.detailColumns.individualPriceIncreaseLimit') as string },
            { dataIndex: "individualPeriodPriceIncreaseLimit", title: this.$t('salesMonitorTab.tables.detailColumns.individualPeriodPriceIncreaseLimit') as string },
            { dataIndex: "individualPeriod", title: this.$t('salesMonitorTab.tables.detailColumns.individualPeriod') as string },
            { dataIndex: "individualMarginalProfit", title: this.$t('salesMonitorTab.tables.detailColumns.individualMarginalProfit') as string },
            { dataIndex: "individualKviStrategy", title: this.$t('salesMonitorTab.tables.detailColumns.individualKviStrategy') as string },
            { dataIndex: "individualPercentCorrection", title: this.$t('salesMonitorTab.tables.detailColumns.individualPercentCorrection') as string },
            { dataIndex: "individualNewProductPriceStrategy", title: this.$t('salesMonitorTab.tables.detailColumns.individualNewProductPriceStrategy') as string },
            { dataIndex: "individualPriceGapPercent", title: this.$t('salesMonitorTab.tables.detailColumns.individualPriceGapPercent') as string },
            { dataIndex: "comment", title: this.$t('results.tableHeaders.comment') as string },
            { dataIndex: "logisticCostsPercentage", title: this.$t('salesMonitorTab.tables.detailColumns.logisticCostsPercentage') as string },
            { dataIndex: "logisticCostsAmount", title: this.$t('salesMonitorTab.tables.detailColumns.logisticCostsAmount') as string },
            { dataIndex: "marketingPaymentsPercentage", title: this.$t('competitorsPricesList.tableHeaders.marketingPayments') as string },
            { dataIndex: "basePrice", title: this.$t('salesMonitorTab.tables.detailColumns.basePrice') as string },
            { dataIndex: "vatPercentage", title: this.$t('salesMonitorTab.tables.detailColumns.vatPercentage') as string },
            { dataIndex: "markupPercentage", title: this.$t('salesMonitorTab.tables.detailColumns.markupPercentage') as string },
        ];

        salesColumnsForManageModal: Array<IColumnLight> = [
            { dataIndex: "internalCode", title: this.$t('results.tableHeaders.internalCode') as string },
            { dataIndex: "skuName", title: this.$t('results.tableHeaders.skuName') as string },
            { dataIndex: "salePointCode", title: this.$t('results.tableHeaders.salePointCode') as string },
            { dataIndex: "taskId", title: this.$t('results.tableHeaders.taskId') as string },
            { dataIndex: "status", title: this.$t('results.tableHeaders.status') as string },
            { dataIndex: "detailedStatus", title: this.$t('salesMonitorTab.tables.detailColumns.detailedStatus') as string },
            { dataIndex: "isApproved", title: this.$t('results.tableHeaders.approval') as string },
            { dataIndex: "approvedByFio", title: this.$t('results.tableHeaders.approvedBy') as string },
            { dataIndex: "newPrice", title: this.$t('results.tableHeaders.regularPrice') as string },
            { dataIndex: "newPriceHistory", title: this.$t('results.tableHeaders.newPriceHistory') as string },
            { dataIndex: "optimalNewPromoPrice", title: this.$t('results.tableHeaders.optimalNewPromoPrice') as string },
            { dataIndex: "optimalDiscountDepth", title: this.$t('results.tableHeaders.optimalDiscountDepth') as string },
            { dataIndex: "firstDiscountForSale", title: this.$t('results.tableHeaders.firstDiscountForSale') as string },
            { dataIndex: "secondDiscountForSale", title: this.$t('results.tableHeaders.secondDiscountForSale') as string },
            { dataIndex: "thirdDiscountForSale", title: this.$t('results.tableHeaders.thirdDiscountForSale') as string },
            { dataIndex: "fourthDiscountForSale", title: this.$t('results.tableHeaders.fourthDiscountForSale') as string },
            { dataIndex: "minPriceForSale", title: this.$t('results.tableHeaders.minPriceForSale') as string },
            { dataIndex: "maxPriceForSale", title: this.$t('results.tableHeaders.maxPriceForSale') as string },
            { dataIndex: "minDiscountForSale", title: this.$t('results.tableHeaders.minDiscountForSale') as string },
            { dataIndex: "maxDiscountForSale", title: this.$t('results.tableHeaders.minDiscountForSale') as string },
            { dataIndex: "minMarginForSale", title: this.$t('results.tableHeaders.minMarginForSale') as string },
            { dataIndex: "marginLoss", title: this.$t('results.tableHeaders.marginLoss') as string },
            { dataIndex: "marginLossPc", title: this.$t('results.tableHeaders.marginLossPc') as string },
            { dataIndex: "remains", title: this.$t('salesMonitorTab.tables.reportColumns.remains') as string },
            { dataIndex: "initialRemains", title: this.$t('regular.columns.initialRemains') as string },
            { dataIndex: "realizationPercent", title: this.$t('regular.columns.realizationPercent') as string },
            { dataIndex: "groupName", title: this.$t('results.tableHeaders.productGroup') as string },
            { dataIndex: "categoryName", title: this.$t('results.tableHeaders.productCategory') as string },
            { dataIndex: "subCategoryName", title: this.$t('results.tableHeaders.productSubcategory') as string },
            { dataIndex: "formatName", title: this.$t('results.tableHeaders.formatChannel') as string },
            { dataIndex: "regionName", title: this.$t('results.tableHeaders.storeRegion') as string },
            { dataIndex: "clusterName", title: this.$t('results.tableHeaders.storeCluster') as string },
            { dataIndex: "productSegmentName", title: this.$t('results.tableHeaders.productSegment') as string },
            { dataIndex: "recipeAttribute", title: this.$t('results.tableHeaders.prc') as string },
            { dataIndex: "treatmentAttribute", title: this.$t('results.tableHeaders.pkl') as string },
            { dataIndex: "vitalMedicine", title: this.$t('results.tableHeaders.vitalMedicine') as string },
            { dataIndex: "producerPrice", title: this.$t('results.tableHeaders.producerPrice') as string },
            { dataIndex: "extraChargePc", title: this.$t('results.tableHeaders.extraChargePc') as string },
            { dataIndex: "registrationPrice", title: this.$t('results.tableHeaders.registrationPrice') as string },
            { dataIndex: "eventTrigger", title: this.$t('results.tableHeaders.eventTrigger') as string },
            { dataIndex: "purchasePriceDeviationPercent", title: this.$t('results.tableHeaders.purchasePriceDeviationPercent') as string, customRender: (value: number | null) => formatPurchasePriceDeviationPercent(value)},
            { dataIndex: "kvi", title: "KVI", customRender: (value: string) => value === 'ДА' ? this.$t('shared.boolFilter.yes') as string : value === 'НЕТ' ? this.$t('shared.boolFilter.no') as string : value },
            { dataIndex: "ctm", title: this.$t('results.tableHeaders.ctm') as string, customRender: (value: string) => value === 'ДА' ? this.$t('shared.boolFilter.yes') as string : value === 'НЕТ' ? this.$t('shared.boolFilter.no') as string : value },
            { dataIndex: "ctmBrand", title: this.$t('results.tableHeaders.ctmBrand') as string },
            { dataIndex: "ctmPriceGap", title: this.$t('results.tableHeaders.ctmPriceGap') as string },
            { dataIndex: "minRetailPrice", title: this.$t('results.tableHeaders.minRetailPrice') as string },
            { dataIndex: "maxRetailPrice", title: this.$t('results.tableHeaders.maxRetailPrice') as string },
            { dataIndex: "omnichannelStrategy", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelStrategy') as string },
            { dataIndex: "omnichannelFixedGapType", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelFixedGapType') as string },
            { dataIndex: "omnichannelGap", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelGap') as string },
            { dataIndex: "omnichannelApplyCompetitorPrices", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelApplyCompetitorPrices') as string },
            { dataIndex: "omnichannelMinProfitabilityLimit", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelMinProfitabilityLimit') as string },
            { dataIndex: "omnichannelBaseChannelPrice", title: this.$t('salesMonitorTab.tables.detailColumns.omnichannelBaseChannelPrice') as string },
            { dataIndex: "keyProduct1", title: this.$t('results.tableHeaders.kht1') as string },
            { dataIndex: "keyProduct2", title: this.$t('results.tableHeaders.kht2') as string },
            { dataIndex: "keyProduct3", title: this.$t('results.tableHeaders.keyProduct3') as string },
            { dataIndex: "keyProduct4", title: this.$t('results.tableHeaders.keyProduct4') as string },
            { dataIndex: "keyProduct5", title: this.$t('results.tableHeaders.keyProduct5') as string },
            { dataIndex: "segment", title: this.$t('results.tableHeaders.segment') as string },
            { dataIndex: "skuLine", title: this.$t('results.tableHeaders.skuLine') as string },
            { dataIndex: "purchasePrice", title: this.$t('salesMonitorTab.tables.detailColumns.purchasePrice') as string },
            { dataIndex: "promoPurchasePrice", title: this.$t('salesMonitorTab.tables.detailColumns.promoPurchasePrice') as string },
            { dataIndex: "avgRegularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.avgRegularPrice') as string },
            { dataIndex: "avgCashPrice", title: this.$t('salesMonitorTab.tables.detailColumns.avgCashPrice') as string },
            { dataIndex: "avgCheckPrice", title: this.$t('salesMonitorTab.tables.detailColumns.avgCheckPrice') as string },
            { dataIndex: "regularPrice", title: this.$t('salesMonitorTab.tables.detailColumns.regularPrice') as string },
            { dataIndex: "marginLastPrice", title: this.$t('salesMonitorTab.tables.detailColumns.marginLastPrice') as string },
            { dataIndex: "minCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorPrice') as string },
            { dataIndex: "minCompetitorName", title: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorName') as string },
            { dataIndex: "minCompetitorCode", title: this.$t('competitorsPricesList.tableHeaders.competitorCode') as string },
            { dataIndex: "maxCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.maxCompetitorPrice') as string },
            { dataIndex: "maxCompetitorName", title: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorName') as string },
            { dataIndex: "maxCompetitorCode", title: this.$t('competitorsPricesList.tableHeaders.competitorCode') as string },
            { dataIndex: "avgCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.avgCompetitorPrice') as string },
            { dataIndex: "lastCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.lastCompetitorPrice') as string },
            { dataIndex: "minPromoCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.minPromoCompetitorPrice') as string },
            { dataIndex: "minPromoCompetitorName", title: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorName') as string },
            { dataIndex: "minPromoCompetitorCode", title: this.$t('competitorsPricesList.tableHeaders.competitorCode') as string },
            { dataIndex: "maxPromoCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.maxPromoCompetitorPrice') as string },
            { dataIndex: "maxPromoCompetitorName", title: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorName') as string },
            { dataIndex: "maxPromoCompetitorCode", title: this.$t('competitorsPricesList.tableHeaders.competitorCode') as string },
            { dataIndex: "medianPromoCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.medianPromoCompetitorPrice') as string },
            { dataIndex: "lastPromoCompetitorPrice", title: this.$t('salesMonitorTab.tables.detailColumns.lastPromoCompetitorPrice') as string },
            { dataIndex: "pi", title: "PI" },
            { dataIndex: "promoPi", title: this.$t('results.tableHeaders.promoPi') as string },
            { dataIndex: "actualSales", title: this.$t('salesMonitorTab.tables.detailColumns.actualSales') as string },
            { dataIndex: "actualRevenue", title: this.$t('salesMonitorTab.tables.detailColumns.actualRevenue') as string },
            { dataIndex: "actualMargin", title: this.$t('salesMonitorTab.tables.detailColumns.actualMargin') as string },
            { dataIndex: "actualMarginPercent", title: this.$t('salesMonitorTab.tables.detailColumns.actualMarginPercent') as string },
            { dataIndex: "comparableSales", title: this.$t('salesMonitorTab.tables.detailColumns.comparableSales') as string },
            { dataIndex: "comparableRevenue", title: this.$t('salesMonitorTab.tables.detailColumns.comparableRevenue') as string },
            { dataIndex: "comparableMargin", title: this.$t('salesMonitorTab.tables.detailColumns.comparableMargin') as string },
            { dataIndex: "comparableMarginPc", title: this.$t('salesMonitorTab.tables.detailColumns.comparableMarginPc') as string },
            { dataIndex: "newPromoPrice", title: this.$t('results.tableHeaders.newPromoPriceWithCompetitors') as string },
            { dataIndex: "correctedPromoPrice", title: this.$t('salesMonitorTab.tables.detailColumns.correctedPromoPrice') as string },
            { dataIndex: "newMarginPc", title: this.$t('salesMonitorTab.tables.detailColumns.newMarginPc') as string },
            { dataIndex: "newPI", title: this.$t('salesMonitorTab.tables.detailColumns.newPI') as string },
            { dataIndex: "deltaDiffPrice", title: this.$t('salesMonitorTab.tables.detailColumns.deltaDiffPrice') as string },
            { dataIndex: "priceDiffPc", title: this.$t('salesMonitorTab.tables.detailColumns.priceDiffPc') as string },
            { dataIndex: "marginDiff", title: this.$t('salesMonitorTab.tables.detailColumns.marginDiff') as string },
            { dataIndex: "changedPI", title: this.$t('salesMonitorTab.tables.detailColumns.changedPI') as string },
            { dataIndex: "discountDepth", title: this.$t('results.tableHeaders.discountDepthWithCompetitors') as string },
            { dataIndex: "discountDuration", title: this.$t('salesMonitorTab.tables.detailColumns.discountDuration') as string },
            { dataIndex: "exitSegment", title: this.$t('salesMonitorTab.tables.detailColumns.exitSegment') as string },
            { dataIndex: "coeffElasticity", title: this.$t('salesMonitorTab.tables.detailColumns.coeffElasticity') as string },
            { dataIndex: "promoCoeffElasticity", title: this.$t('salesMonitorTab.tables.detailColumns.promoCoeffElasticity') as string },
            { dataIndex: "salesForecast", title: this.$t('salesMonitorTab.tables.detailColumns.salesForecast') as string },
            { dataIndex: "revenueForecast", title: this.$t('salesMonitorTab.tables.detailColumns.revenueForecast') as string },
            { dataIndex: "marginForecast", title: this.$t('salesMonitorTab.tables.detailColumns.marginForecast') as string },
            { dataIndex: "marginForecastPc", title: this.$t('salesMonitorTab.tables.detailColumns.marginForecastPc') as string },
            { dataIndex: "changeSales", title: this.$t('salesMonitorTab.tables.detailColumns.changeSales') as string },
            { dataIndex: "changeRevenue", title: this.$t('salesMonitorTab.tables.detailColumns.changeRevenue') as string },
            { dataIndex: "changeMargin", title: this.$t('salesMonitorTab.tables.detailColumns.changeMargin') as string },
            { dataIndex: "salesDiffPc", title: this.$t('salesMonitorTab.tables.detailColumns.salesDiffPc') as string },
            { dataIndex: "revenueDiffPc", title: this.$t('salesMonitorTab.tables.detailColumns.revenueDiffPc') as string },
            { dataIndex: "marginDiffPc", title: this.$t('salesMonitorTab.tables.detailColumns.marginDiffPc') as string },
            { dataIndex: "marginDiffSecond", title: this.$t('salesMonitorTab.tables.detailColumns.marginDiff') as string },
            { dataIndex: "individualPromoType", title: this.$t('salesMonitorTab.tables.detailColumns.individualPromoType') as string },
            { dataIndex: "individualPromoLift", title: this.$t('salesMonitorTab.tables.detailColumns.individualPromoLift') as string },
            { dataIndex: "individualPriceOptStrategy", title: this.$t('salesMonitorTab.tables.detailColumns.individualPriceOptStrategy') as string },
            { dataIndex: "individualPriceIncreaseLimit", title: this.$t('salesMonitorTab.tables.detailColumns.individualPriceIncreaseLimit') as string },
            { dataIndex: "individualPeriodPriceIncreaseLimit", title: this.$t('salesMonitorTab.tables.detailColumns.individualPeriodPriceIncreaseLimit') as string },
            { dataIndex: "individualPeriod", title: this.$t('salesMonitorTab.tables.detailColumns.individualPeriod') as string },
            { dataIndex: "individualMarginalProfit", title: this.$t('salesMonitorTab.tables.detailColumns.individualMarginalProfit') as string },
            { dataIndex: "individualKviStrategy", title: this.$t('salesMonitorTab.tables.detailColumns.individualKviStrategy') as string },
            { dataIndex: "individualPercentCorrection", title: this.$t('salesMonitorTab.tables.detailColumns.individualPercentCorrection') as string },
            { dataIndex: "individualNewProductPriceStrategy", title: this.$t('salesMonitorTab.tables.detailColumns.individualNewProductPriceStrategy') as string },
            { dataIndex: "individualPriceGapPercent", title: this.$t('salesMonitorTab.tables.detailColumns.individualPriceGapPercent') as string },
            { dataIndex: "comment", title: this.$t('results.tableHeaders.comment') as string },
        ];

        sortedColumns: any[] = [];
        tableColumnsOrder: string[] = [];

        promoResultTableHeader1: TableHeaders[] = [
            {key: 'promoSkuCountInGroup', label: this.$t('results.tableHeaders.promoSkuCountInGroup') as string},
            {key: 'promoAvgPcDiscount', label: this.$t('results.tableHeaders.promoAvgPcDiscount') as string},
            {key: 'promoAvgDiscountDuration', label: this.$t('results.tableHeaders.promoAvgDiscountDuration') as string},
            {key: 'promoPartRevenue', label: this.$t('results.tableHeaders.promoPartRevenue') as string},
            {key: 'promoPartSalesAmount', label: this.$t('results.tableHeaders.promoPartSalesAmount') as string},
            {key: 'promoPartGrossMargin', label: this.$t('results.tableHeaders.promoPartGrossMargin') as string},
            {key: 'promoPartSKU', label: this.$t('results.tableHeaders.promoPartSKU') as string},
        ];

        promoResultTableHeader2: TableHeaders[] = [
            {key: 'promoRealSales', label: this.$t('results.tableHeaders.promoRealSales') as string},
            {key: 'promoForecastRealSales', label: this.$t('results.tableHeaders.promoForecastRealSales') as string},
            {key: 'promoRealSalesChange', label: this.$t('results.tableHeaders.promoRealSalesChange') as string},
            {key: 'promoPcRealSalesChange', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
        ];
        promoResultTableHeader3: TableHeaders[] = [
            {key: 'promoRealRevenue', label: this.$t('results.tableHeaders.promoRealRevenue') as string},
            {key: 'promoForecastRealRevenue', label: this.$t('results.tableHeaders.promoForecastRealRevenue') as string},
            {key: 'promoRealRevenueChange', label: this.$t('results.tableHeaders.promoRealRevenueChange') as string},
            {key: 'promoPcRealRevenueChange', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
        ];
        promoResultTableHeader4: TableHeaders[] = [
            {key: 'promoRealMargin', label: this.$t('results.tableHeaders.promoRealMargin') as string},
            {key: 'promoForecastRealMargin', label: this.$t('results.tableHeaders.promoForecastRealMargin') as string},
            {key: 'promoRealMarginChange', label: this.$t('results.tableHeaders.promoRealRevenueChange') as string},
            {key: 'promoPcRealMarginChange', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
            {key: 'promoRealMarginPc', label: this.$t('results.tableHeaders.promoRealMarginPc') as string},
            {key: 'promoForecastRealMarginPc', label: this.$t('results.tableHeaders.promoForecastRealMarginPc') as string},
            {key: 'promoMarginChangePp', label: this.$t('results.tableHeaders.promoMarginChangePp') as string},
            {key: 'marginLoss', label: this.$t('results.tableHeaders.marginLoss') as string},
        ];

        selectTaskIdForDetailTable: number[] = [];
        taskIdOptionsForDetailTable: Array<SelectBox<number>> = [];

        filterValues = {
            groups: ["all"],
            categories: ["all"],
            subcategories: ["all"],
            storeFormat: ["all"],
            storeRegion: ["all"],
            storeCluster: ["all"],
        };

        filterOptions: IFilterOptions = {
            groups: [],
            categories: [],
            subcategories: [],
            storeFormat: [],
            storeRegion: [],
            storeCluster: [],
        };

        historyItemsClasses: any = {
            'price-gray': [
                this.$t('regular.tooltips.mrcEqualsMinRetailNoRound') as string,
                this.$t('regular.tooltips.mrcEqualsMaxRetailNoRound') as string,
                this.$t('regular.tooltips.mrcUnfixedAfterProfMinNoRound') as string,
                this.$t('regular.tooltips.mrcUnfixedAfterProfMaxNoRound') as string,
                this.$t('regular.tooltips.mrcAfterProfCheckMinNoRound') as string,
                this.$t('regular.tooltips.mrcAfterProfCheckMaxNoRound') as string,
                this.$t('regular.tooltips.mrcEqualsMinRetail') as string,
                this.$t('regular.tooltips.mrcEqualsMaxRetail') as string,
                this.$t('regular.tooltips.mrcUnfixedAfterProfMin') as string,
                this.$t('regular.tooltips.mrcUnfixedAfterProfMax') as string,
            ],
            'price-orange': [
                this.$t('regular.tooltips.cpoPriceAfterLimit') as string,
                this.$t('regular.tooltips.priceInLineCheckAfterLimit') as string,
                this.$t('regular.tooltips.priceInXyzAfterLimit') as string,
                this.$t('regular.tooltips.priceAfterIncreaseLimit') as string,
            ],
            'price-violet': [
                this.$t('regular.tooltips.priceAfterPeriodLimitAndMinProfit') as string,
                this.$t('regular.tooltips.priceExceedsPeriodLimit') as string,
            ],
            'price-light-green': [
                this.$t('regular.tooltips.correlatedPriceRounded') as string,
            ],
        }

        selectGroupNameForDetailTable: string[] = [];
        groupNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectCategoryNameForDetailTable: string[] = [];
        categoryNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectSubcategoryNamesForDetailTable: string[] = [];
        subcategoryNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectFormatNameForDetailTable: string[] = [];
        formatNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectRegionNameForDetailTable: string[] = [];
        regionNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectClusterNameForDetailTable: string[] = [];
        clusterNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectSegmentNameForDetailTable: string[] = [];
        segmentNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectInternalCodeForDetailTable: string[] = [];
        internalCodesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectSkuNameForDetailTable: string[] = [];
        skuNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectEventTriggerForDetailTable: SelectBox<number> = this.defaultFilterValue;
        selectKVIForDetailTable: SelectBox<number> = this.defaultFilterValue;
        kviOptions: Array<SelectBox<number>> = [
            {value: -1, label: this.$t('shared.selectBox.all') as string},
            {value: 1, label: 'KVI'},
            {value: 0, label: this.$t('shared.kviFilter.notKvi') as string},
        ];
        selectCTMForDetailTable: SelectBox<number> = this.defaultFilterValue;
        ctmOptionsForDetailTable: Array<SelectBox<number>> = [
            {value: -1, label: this.$t('shared.selectBox.all') as string},
            {value: 1, label: 'CTM'},
            {value: 0, label: this.$t('shared.ctmFilter.notCtm') as string},
        ];
        selectCtmBrandForDetailTable: string[] = [];
        ctmBrandsOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectCtmPriceGapForDetailTable: number[] = [];
        ctmPriceGapOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMinRetailPriceForDetailTable: number[] = [];
        minRetailPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMaxRetailPriceForDetailTable: number[] = [];
        maxRetailPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectKeyProduct1ForDetailTable: string[] = [];
        keyProduct1OptionsForDetailTable: Array<SelectBox<string>> = [];

        selectKeyProduct2ForDetailTable: string[] = [];
        keyProduct2OptionsForDetailTable: Array<SelectBox<string>> = [];

        selectRecipeAttributeForDetailTable: string[] = [];
        recipeAttributeOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectTreatmentAttributeForDetailTable: number[] = [];
        treatmentAttributeOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectVitalMedicineForDetailTable: SelectBox<number> = this.defaultFilterValue;
        vitalMedicinesOptionsForDetailTable: Array<SelectBox<number>> = [
            {value: -1, label: this.$t('shared.selectBox.all') as string},
            {value: 1, label: this.$t('shared.boolFilter.yes') as string},
            {value: 0, label: this.$t('shared.boolFilter.no') as string},
        ];

        selectProducerPriceForDetailTable: number[] = [];
        producerPricesOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectExtraChargePcForDetailTable: number[] = [];
        extraChargePcsOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectRegistrationPriceForDetailTable: number[] = [];
        registrationPricesOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectSegmentPriceForDetailTable: ReportDetailSegments[] = [];
        segmentPriceOptionsForDetailTable: Array<SelectBox<ReportDetailSegments>> = [];

        selectSkuLineForDetailTable: string[] = [];
        skuLineOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectPurchasePriceForDetailTable: number[] = [];
        purchasePriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectPromoPurchasePriceForDetailTable: number[] = [];
        promoPurchasePriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectAvgRegularPriceForDetailTable: number[] = [];
        avgRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectAvgCashPriceForDetailTable: number[] = [];
        avgCashPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectAvgCheckPriceForDetailTable: number[] = [];
        avgCheckPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectRegularPriceForDetailTable: number[] = [];
        regularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginLastPriceForDetailTable: number[] = [];
        marginLastPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMinCompetitorPriceForDetailTable: number[] = [];
        minCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMinCompetitorNameForDetailTable: string[] = [];
        minCompetitorNameOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectMinCompetitorCodeForDetailTable: string[] = [];
        minCompetitorCodeOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectMaxCompetitorPriceForDetailTable: number[] = [];
        maxCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMaxCompetitorNameForDetailTable: string[] = [];
        maxCompetitorNameOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectMaxCompetitorCodeForDetailTable: string[] = [];
        maxCompetitorCodeOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectAvgCompetitorPriceForDetailTable: number[] = [];
        avgCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectLastCompetitorPriceForDetailTable: number[] = [];
        lastCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMinPromoCompetitorPriceForDetailTable: number[] = [];
        minPromoCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMinPromoCompetitorNameForDetailTable: string[] = [];
        minPromoCompetitorNameOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectMinPromoCompetitorCodeForDetailTable: string[] = [];
        minPromoCompetitorCodeOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectMaxPromoCompetitorPriceForDetailTable: number[] = [];
        maxPromoCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMaxPromoCompetitorNameForDetailTable: string[] = [];
        maxPromoCompetitorNameOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectMaxPromoCompetitorCodeForDetailTable: string[] = [];
        maxPromoCompetitorCodeOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectMedianPromoCompetitorPriceForDetailTable: number[] = [];
        medianPromoCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectLastPromoCompetitorPriceForDetailTable: number[] = [];
        lastPromoCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectPiForDetailTable: number[] = [];
        piOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectActualSalesForDetailTable: number[] = [];
        actualSalesOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectActualRevenueForDetailTable: number[] = [];
        actualRevenueOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectActualMarginForDetailTable: number[] = [];
        actualMarginOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectActualMarginPercentForDetailTable: number[] = [];
        actualMarginPercentOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectComparableSalesForDetailTable: number[] = [];
        comparableSalesOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectComparableRevenueForDetailTable: number[] = [];
        comparableRevenueOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectComparableMarginForDetailTable: number[] = [];
        comparableMarginOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectComparableMarginPcForDetailTable: number[] = [];
        comparableMarginPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectNewPriceForDetailTable: number[] = [];
        newPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectNewPromoPriceForDetailTable: number[] = [];
        newPromoPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectCorrectedRegularPriceForDetailTable: number[] = [];
        correctedRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectCorrectedPromoPriceForDetailTable: number[] = [];
        correctedPromoPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectNewMarginPcForDetailTable: number[] = [];
        newMarginPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectNewPIForDetailTable: number[] = [];
        newPIOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectDeltaDiffPriceForDetailTable: Array<number | string> = [];
        deltaDiffPriceOptionsForDetailTable: Array<SelectBox<number | string>> = [];

        selectPriceDiffPcForDetailTable: number[] = [];
        priceDiffPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginDiffForDetailTable: number[] = [];
        marginDiffOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectChangedPIForDetailTable: number[] = [];
        changedPIPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectDiscountDepthForDetailTable: number[] = [];
        discountDepthOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectDiscountDurationForDetailTable: number[] = [];
        discountDurationOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectExitSegmentForDetailTable: string[] = [];
        exitSegmentOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectCoeffElasticityForDetailTable: number[] = [];
        coeffElasticityPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectPromoCoeffElasticityForDetailTable: number[] = [];
        promoCoeffElasticityPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectSalesForecastForDetailTable: number[] = [];
        salesForecastOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectRevenueForecastForDetailTable: number[] = [];
        revenueForecastOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginForecastForDetailTable: number[] = [];
        marginForecastOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginForecastPcForDetailTable: number[] = [];
        marginForecastPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectChangeSalesForDetailTable: number[] = [];
        changeSalesOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectChangeRevenueForDetailTable: number[] = [];
        changeRevenueOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectChangeMarginForDetailTable: number[] = [];
        changeMarginOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectSalesDiffPcForDetailTable: number[] = [];
        salesDiffPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectRevenueDiffPcForDetailTable: number[] = [];
        revenueDiffPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginDiffPcForDetailTable: number[] = [];
        marginDiffPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginDiffSecondForDetailTable: number[] = [];
        marginDiffSecondOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectIndividualPromoTypeForDetailTable: string[] = [];
        individualPromoTypeOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectIndividualPromoLiftForDetailTable: number[] = [];
        individualPromoLiftOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectSalesForecastByRegularPriceForDetailTable: number[] = [];
        salesForecastByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectRevenueForecastByRegularPriceForDetailTable: number[] = [];
        revenueForecastByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginForecastByRegularPriceForDetailTable: number[] = [];
        marginForecastByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginForecastByRegularPricePcForDetailTable: number[] = [];
        marginForecastByRegularPricePcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectChangeSalesByRegularPriceForDetailTable: number[] = [];
        changeSalesByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectChangeRevenueByRegularPriceForDetailTable: number[] = [];
        changeRevenueByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectChangeMarginByRegularPriceForDetailTable: number[] = [];
        changeMarginByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectSalesDiffPcByRegularPriceForDetailTable: number[] = [];
        salesDiffPcByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectRevenueDiffPcByRegularPriceForDetailTable: number[] = [];
        revenueDiffPcByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginDiffPcByRegularPriceForDetailTable: number[] = [];
        marginDiffPcByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginDiffSecondByRegularPriceForDetailTable: number[] = [];
        marginDiffSecondByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectIndividualPriceOptStrategyForDetailTable: string[] = [];
        individualPriceOptStrategyOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectIndividualPriceIncreaseLimitForDetailTable: number[] = [];
        individualPriceIncreaseLimitOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectIndividualPeriodPriceIncreaseLimitForDetailTable: number[] = [];
        individualPeriodPriceIncreaseLimitOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectIndividualPeriodForDetailTable: string[] = [];
        individualPeriodOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectIndividualMarginalProfitForDetailTable: number[] = [];
        individualMarginalProfitOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectIndividualKviStrategyForDetailTable: string[] = [];
        individualKviStrategyOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectIndividualPercentCorrectionForDetailTable: string[] = [];
        individualPercentCorrectionOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectIndividualNewProductPriceStrategyForDetailTable: string[] = [];
        individualNewProductPriceStrategyOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectIndividualPriceGapPercentForDetailTable: number[] = [];
        individualPriceGapPercentOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectBatchNumberForDetailTable: string[] = [];
        batchNumberOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectApprovedByFioForDetailTable: string[] = [];
        approvedByFioOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectIsApprovedForDetailTable: string[] = [];
        isApprovedOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectPriceExperimentForDetailTable: SelectBox<string> = {value: 'all', label: this.$t('shared.selectBox.all') as string};
        priceExperimentOptionsForDetailTable: Array<SelectBox<string>> = [
            {value: 'all', label: this.$t('shared.selectBox.all') as string},
            {value: 'true', label: this.$t('shared.boolFilter.yes') as string},
            {value: 'false', label: this.$t('shared.boolFilter.no') as string}
        ];

        selectProductVerticalLineForDetailTable: string[] = [];
        selectDetailedStatusForDetailTable: string[] = [];
        productVerticalLineOptionsForDetailTable: Array<SelectBox<string>> = [];
        detailedStatusOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectSalePointCodesForDetailTable: string[] = [];
        salePointCodeOptionsForDetailTable: Array<SelectBox<string>> = [];

        grossIncomeByLastPriceTableHeader: TableHeaders[] = [
            {key: 'sumMarginForecastByRegularPrice', label: this.$t('results.tableHeaders.sumMarginForecastByRegularPrice') as string},
            {key: 'forecastMargin', label: this.$t('results.tableHeaders.forecastMargin') as string},
            {key: 'changeForecastMarginByRegularPrice', label: this.$t('results.tableHeaders.changeForecastMarginByRegularPrice') as string},
            {key: 'changeForecastMarginPcByRegularPrice', label: this.$t('results.tableHeaders.changeForecastMarginPcByRegularPrice') as string},
            {key: 'sumMarginForecastPcByRegularPrice', label: this.$t('results.tableHeaders.sumMarginForecastPcByRegularPrice') as string},
            {key: 'forecastMarginPc', label: this.$t('results.tableHeaders.forecastMarginPc') as string},
            {key: 'changeMarginByRegularPricePp', label: this.$t('results.tableHeaders.changeMarginByRegularPricePp') as string},
        ];

        salesByLastPriceTableHeader: TableHeaders[] = [
            {key: 'sumSalesForecastByRegularPrice', label: this.$t('results.tableHeaders.sumSalesForecastByRegularPrice') as string},
            {key: 'forecastAmount', label: this.$t('results.tableHeaders.forecastAmount') as string},
            {key: 'changeForecastSalesByRegularPrice', label: this.$t('results.tableHeaders.changeForecastSalesByRegularPrice') as string},
            {key: 'changeForecastSalesPcByRegularPrice', label: this.$t('results.tableHeaders.changeForecastMarginPcByRegularPrice') as string},
        ];

        revenueByLastPriceTableHeader: TableHeaders[] = [
            {key: 'sumRevenueForecastByRegularPrice', label: this.$t('results.tableHeaders.sumRevenueForecastByRegularPrice') as string},
            {key: 'forecastRevenue', label: this.$t('results.tableHeaders.forecastRevenue') as string},
            {key: 'changeForecastRevenueByRegularPrice', label: this.$t('results.tableHeaders.changeForecastMarginByRegularPrice') as string},
            {key: 'changeForecastRevenuePcByRegularPrice', label: this.$t('results.tableHeaders.changeForecastMarginPcByRegularPrice') as string},
        ];
        generalPromoResultTableHeader2: TableHeaders[] = [
            {key: 'realSalesAmount', label: this.$t('results.tableHeaders.promoRealSales') as string},
            {key: 'forecastAmount', label: this.$t('results.tableHeaders.promoForecastRealSales') as string},
            {key: 'amountChange', label: this.$t('results.tableHeaders.promoRealSalesChange') as string},
            {key: 'amountChangePc', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
        ];
        generalPromoResultTableHeader3: TableHeaders[] = [
            {key: 'revenueReal', label: this.$t('results.tableHeaders.promoRealRevenue') as string},
            {key: 'forecastRevenue', label: this.$t('results.tableHeaders.promoForecastRealRevenue') as string},
            {key: 'revenueChange', label: this.$t('results.tableHeaders.promoRealRevenueChange') as string},
            {key: 'revenueChangePc', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
        ];
        generalPromoResultTableHeader4: TableHeaders[] = [
            {key: 'marginReal', label: this.$t('results.tableHeaders.promoRealMargin') as string},
            {key: 'forecastMargin', label: this.$t('results.tableHeaders.promoForecastRealMargin') as string},
            {key: 'marginChange', label: this.$t('results.tableHeaders.promoRealRevenueChange') as string},
            {key: 'marginChangePc', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
            {key: 'marginRealPc', label: this.$t('results.tableHeaders.promoRealMarginPc') as string},
            {key: 'forecastMarginPc', label: this.$t('results.tableHeaders.promoForecastRealMarginPc') as string},
            {key: 'marginChangePp', label: this.$t('results.tableHeaders.promoMarginChangePp') as string},
        ];
        generalResultChanges1: TableHeaders[] = [
            {key: 'skuCountInGroup', label: this.$t('results.tableHeaders.skuCountInGroup') as string},
            {key: 'priceChangedCount', label: this.$t('results.tableHeaders.priceChangedCount') as string},
            {key: 'avgPcPriceChange', label: this.$t('results.tableHeaders.avgPcPriceChange') as string},
            {key: 'realizationPercent', label: this.$t('regular.columns.realizationPercent') as string},
            {key: 'priceTagChangeExpense', label: this.$t('salesMonitorTab.tables.reportColumns.priceTagChangeExpense') as string}
        ];
        generalResultChanges2: TableHeaders[] = [
            {key: 'priceIncreaseCount', label: this.$t('results.tableHeaders.priceIncreaseCount') as string},
            {key: 'avgPcIncreasePrice', label: this.$t('results.tableHeaders.avgPcIncreasePrice') as string},
            {key: 'priceDecreaseCount', label: this.$t('results.tableHeaders.priceDecreaseCount') as string},
        ];
        generalResultChanges3: TableHeaders[] = [
            {key: 'avgPcPriceDecrease', label: this.$t('results.tableHeaders.avgPcPriceDecrease') as string},
            {key: 'settlementDate', label: this.$t('results.tableHeaders.settlementDate') as string},
            {key: 'forecastDate', label: this.$t('results.tableHeaders.forecastDate') as string},
        ];
        generalPromoResultChanges1: TableHeaders[] = [
            {key: 'skuCountInGroup', label: this.$t('results.tableHeaders.skuCountInGroup') as string},
            {key: 'priceChangedCount', label: this.$t('results.tableHeaders.priceChangedCount') as string},
            {key: 'avgPcPriceChange', label: this.$t('results.tableHeaders.avgPcPriceChange') as string},
        ];
        generalPromoResultChanges2: TableHeaders[] = [
            {key: 'priceIncreaseCount', label: this.$t('results.tableHeaders.priceIncreaseCount') as string},
            {key: 'avgPcIncreasePrice', label: this.$t('results.tableHeaders.avgPcIncreasePrice') as string},
            {key: 'priceDecreaseCount', label: this.$t('results.tableHeaders.priceDecreaseCount') as string},
        ];
        generalPromoResultChanges3: TableHeaders[] = [
            {key: 'avgPcPriceDecrease', label: this.$t('results.tableHeaders.avgPcPriceDecrease') as string},
            {key: 'settlementDate', label: this.$t('results.tableHeaders.settlementDate') as string},
            {key: 'forecastDate', label: this.$t('results.tableHeaders.forecastDate') as string},
        ];
        generalResultTableHeader2: TableHeaders[] = [
            {key: 'comparableSalesAmount', label: this.$t('results.tableHeaders.comparableSalesAmount') as string},
            {key: 'forecastAmount', label: this.$t('results.tableHeaders.forecastAmount') as string},
            {key: 'amountChange', label: this.$t('results.tableHeaders.promoRealSalesChange') as string},
            {key: 'amountChangePc', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
        ];

        generalResultTableHeader3: TableHeaders[] = [
            {key: 'revenueComparable', label: this.$t('results.tableHeaders.revenueComparable') as string},
            {key: 'forecastRevenue', label: this.$t('results.tableHeaders.forecastRevenue') as string},
            {key: 'revenueChange', label: this.$t('results.tableHeaders.promoRealRevenueChange') as string},
            {key: 'revenueChangePc', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
        ];

        generalResultTableHeader4: TableHeaders[] = [
            {key: 'marginComparable', label: this.$t('results.tableHeaders.marginComparable') as string},
            {key: 'forecastMargin', label: this.$t('results.tableHeaders.forecastMargin') as string},
            {key: 'marginChange', label: this.$t('results.tableHeaders.promoRealRevenueChange') as string},
            {key: 'marginChangePc', label: this.$t('results.tableHeaders.promoPcRealSalesChange') as string},
            {key: 'marginComparablePc', label: this.$t('results.tableHeaders.marginComparablePc') as string},
            {key: 'forecastMarginPc', label: this.$t('results.tableHeaders.forecastMarginPc') as string},
            {key: 'marginChangePp', label: this.$t('results.tableHeaders.promoMarginChangePp') as string},
        ];

        regularDetailReport: any[] = []; // all columns will be added dynamically

        promoDetailReport: any[] = [];

        promoDetailReportStaticFields: any[] = [
            {
                key: 'checkboxes',
                dataIndex: 'checkboxes',
                scopedSlots: {
                    title: 'commonCheckbox',
                    customRender: 'rowCheckbox',
                },
                fixed: 'left',
                width: 50,
                align: 'center',
            },
            {
                dataIndex: 'internalCode',
                slots: { title: 'internalCodeColumnTitle' }, // dataIndex + 'ColumnTitle'
                slotColumnTitleData: {
                    text: this.$t('results.tableHeaders.internalCode') as string,
                },
                fixed: 'left',
                sorter: true,
                filterOptionsKey: 'internalCode',
                filterModel: 'internalCode',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('internalCode') },
                scopedSlots: {
                    customRender: 'internalCode',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 170,
                ellipsis: true,
            },
            {
                dataIndex: 'skuName',
                slots: { title: 'skuNameColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('results.tableHeaders.skuName') as string,
                },
                stickyColumn: true,
                sorter: true,
                fixed: 'left',
                filterOptionsKey: 'skuName',
                filterModel: 'skuName',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('skuName') },
                scopedSlots: {
                    customRender: 'skuName',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 340,
            },
            {
                dataIndex: 'taskId',
                slots: { title: 'taskIdColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('results.tableHeaders.taskId') as string,
                },
                sorter: true,
                filterOptionsKey: 'taskId',
                filterModel: 'taskId',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('taskId') },
                scopedSlots: {
                    customRender: 'taskId',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 156,
                ellipsis: true,
            },
            {
                dataIndex: 'isApproved',
                title: this.$t('results.tableHeaders.approval') as string,
                filterOptionsKey: 'isApproved',
                filterModel: 'isApproved',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('isApproved') },
                scopedSlots: {
                  customRender: 'isApproved',
                  filterDropdown: "filterCheckboxes",
                  filterIcon: "filterIcon",
                },
                width: 150,
            },
            {
                dataIndex: 'approvedByFio',
                title: this.$t('results.tableHeaders.approvedBy') as string,
                filterOptionsKey: 'approvedByFio',
                filterModel: 'approvedByFio',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('approvedByFio') },
                scopedSlots: {
                    customRender: 'approvedByFio',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 150,
                ellipsis: true,
            },
            {
                dataIndex: 'groupName',
                slots: { title: 'groupNameColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('results.tableHeaders.productGroup') as string,
                },
                sorter: true,
                filterOptionsKey: 'groupName',
                filterModel: 'groupName',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('groupName') },
                scopedSlots: {
                    customRender: 'groupName',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'categoryName',
                slots: { title: 'categoryNameColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('results.tableHeaders.productCategory') as string,
                },
                sorter: true,
                filterOptionsKey: 'categoryName',
                filterModel: 'categoryName',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('categoryName') },
                scopedSlots: {
                    customRender: 'categoryName',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'subCategoryName',
                slots: { title: 'subCategoryNameColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('results.tableHeaders.productSubcategory') as string,
                },
                sorter: true,
                filterOptionsKey: 'subCategoryName',
                filterModel: 'subCategoryName',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('subCategoryName') },
                scopedSlots: {
                    customRender: 'subCategoryName',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 200,
                onFilter: () => true,
                ellipsis: true,
            },
            {
                dataIndex: 'formatName',
                slots: { title: 'formatNameColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('results.tableHeaders.formatChannel') as string,
                },
                sorter: true,
                filterOptionsKey: 'formatName',
                filterModel: 'formatName',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('formatName') },
                scopedSlots: {
                    customRender: 'formatName',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'regionName',
                slots: { title: 'regionNameColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('results.tableHeaders.storeRegion') as string,
                },
                sorter: true,
                filterOptionsKey: 'regionName',
                filterModel: 'regionName',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('regionName') },
                scopedSlots: {
                    customRender: 'regionName',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'clusterName',
                slots: { title: 'clusterNameColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('results.tableHeaders.storeCluster') as string,
                },
                sorter: true,
                filterOptionsKey: 'clusterName',
                filterModel: 'clusterName',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('clusterName') },
                scopedSlots: {
                    customRender: 'clusterName',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'productSegmentName',
                slots: { title: 'productSegmentNameColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('results.tableHeaders.productSegment') as string,
                },
                sorter: true,
                filterOptionsKey: 'productSegmentName',
                filterModel: 'productSegmentName',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('productSegmentName') },
                scopedSlots: {
                    customRender: 'productSegmentName',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 200,
                ellipsis: true,
            },
        ];

        salesDetailReport: any = [];

        salesDetailReportStaticFields: any[] = [
        {
            key: 'checkboxes',
            scopedSlots: {
                title: 'commonCheckbox',
                customRender: 'rowCheckbox',
            },
            fixed: 'left',
            width: 50,
            align: 'center',
        },
        {
            dataIndex: 'internalCode',
            slots: { title: 'internalCodeColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('results.tableHeaders.internalCode') as string,
            },
            fixed: 'left',
            sorter: true,
            filterOptionsKey: 'internalCode',
            filterModel: 'internalCode',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('internalCode') },
            scopedSlots: {
                customRender: 'internalCode',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 170,
            ellipsis: true,
        },
        {
            dataIndex: 'skuName',
            slots: { title: 'skuNameColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('results.tableHeaders.skuName') as string,
            },
            stickyColumn: true,
            sorter: true,
            fixed: 'left',
            filterOptionsKey: 'skuName',
            filterModel: 'skuName',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('skuName') },
            scopedSlots: {
                customRender: 'skuName',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 340,
        },
        {
            dataIndex: 'taskId',
            slots: { title: 'taskIdColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('results.tableHeaders.taskId') as string,
            },
            sorter: true,
            filterOptionsKey: 'taskId',
            filterModel: 'taskId',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('taskId') },
            scopedSlots: {
                customRender: 'taskId',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 156,
            ellipsis: true,
        },
        {
            dataIndex: 'isApproved',
            title: this.$t('results.tableHeaders.approval') as string,
            filterOptionsKey: 'isApproved',
            filterModel: 'isApproved',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('isApproved') },
            scopedSlots: {
                customRender: 'isApproved',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 150,
        },
        {
            dataIndex: 'approvedByFio',
            title: this.$t('results.tableHeaders.approvedBy') as string,
            filterOptionsKey: 'approvedByFio',
            filterModel: 'approvedByFio',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('approvedByFio') },
            scopedSlots: {
                customRender: 'approvedByFio',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'groupName',
            slots: { title: 'groupNameColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('results.tableHeaders.productGroup') as string,
            },
            sorter: true,
            filterOptionsKey: 'groupName',
            filterModel: 'groupName',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('groupName') },
            scopedSlots: {
                customRender: 'groupName',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'categoryName',
            slots: { title: 'categoryNameColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('results.tableHeaders.productCategory') as string,
            },
            sorter: true,
            filterOptionsKey: 'categoryName',
            filterModel: 'categoryName',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('categoryName') },
            scopedSlots: {
                customRender: 'categoryName',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'subCategoryName',
            slots: { title: 'subCategoryNameColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('results.tableHeaders.productSubcategory') as string,
            },
            sorter: true,
            filterOptionsKey: 'subCategoryName',
            filterModel: 'subCategoryName',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('subCategoryName') },
            scopedSlots: {
                customRender: 'subCategoryName',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 200,
            onFilter: () => true,
            ellipsis: true,
        },
        {
            dataIndex: 'formatName',
            slots: { title: 'formatNameColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('results.tableHeaders.formatChannel') as string,
            },
            sorter: true,
            filterOptionsKey: 'formatName',
            filterModel: 'formatName',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('formatName') },
            scopedSlots: {
                customRender: 'formatName',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'regionName',
            slots: { title: 'regionNameColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('results.tableHeaders.storeRegion') as string,
            },
            sorter: true,
            filterOptionsKey: 'regionName',
            filterModel: 'regionName',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('regionName') },
            scopedSlots: {
                customRender: 'regionName',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'clusterName',
            slots: { title: 'clusterNameColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('results.tableHeaders.storeCluster') as string,
            },
            sorter: true,
            filterOptionsKey: 'clusterName',
            filterModel: 'clusterName',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('clusterName') },
            scopedSlots: {
                customRender: 'clusterName',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'productSegmentName',
            slots: { title: 'productSegmentNameColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('results.tableHeaders.productSegment') as string,
            },
            sorter: true,
            filterOptionsKey: 'productSegmentName',
            filterModel: 'productSegmentName',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('productSegmentName') },
            scopedSlots: {
                customRender: 'productSegmentName',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
    ];

        filterDropdownsState: any = {};
        filterDropdownsRange: any = {
            from: {},
            to: {},
        };
        tableFilterOptions: any = {};
        filterAllCheckboxCheckedState: any = {};

        pagination: any = {
            current: 1,
            pageSize: 20,
            total: 0,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '40', '50'],
        }

        packageRegularFullHeaderReport: any[] = [
            {dataIndex: 'taskId', title: this.$t('results.tableHeaders.numberSign') as string, fixed: 'left', stickyColumn: true, width: 100},
            {dataIndex: 'fileResult', title: this.$t('results.tableHeaders.actions') as string, scopedSlots: { customRender: 'fileResult' }, fixed: 'left', stickyColumn: true, ellipsis: true, width: 200},
            {dataIndex: 'groupName', title: this.$t('results.tableHeaders.productGroup') as string, scopedSlots: { customRender: 'groupName' }, width: 200, ellipsis: true},
            {dataIndex: 'categoryName', title: this.$t('results.tableHeaders.productCategory') as string, scopedSlots: { customRender: 'categoryName' }, width: 200, ellipsis: true},
            {dataIndex: 'subCategoryName', title: this.$t('results.tableHeaders.productSubcategory') as string, scopedSlots: { customRender: 'subCategoryName' }, width: 200, ellipsis: true},
            {dataIndex: 'formatName', title: this.$t('results.tableHeaders.formatChannel') as string, scopedSlots: { customRender: 'formatName' }, width: 200, ellipsis: true},
            {dataIndex: 'regionName', title: this.$t('results.tableHeaders.storeRegion') as string, scopedSlots: { customRender: 'regionName' }, width: 200, ellipsis: true},
            {dataIndex: 'clusterName', title: this.$t('results.tableHeaders.storeCluster') as string, scopedSlots: { customRender: 'clusterName' }, width: 200, ellipsis: true},
            {dataIndex: 'scenarioName', title: this.$t('results.tableHeaders.scenarioName') as string, scopedSlots: { customRender: 'scenarioName' }, width: 200, ellipsis: true},
            {dataIndex: 'sumSalesForecastByRegularPrice', title: this.$t('results.tableHeaders.sumSalesForecastByRegularPrice') as string, scopedSlots: { customRender: 'sumSalesForecastByRegularPrice' }, width: 100},
            {dataIndex: 'forecastAmount', title: this.$t('results.tableHeaders.forecastSalesByNewPrices') as string, scopedSlots: { customRender: 'forecastAmount' }, width: 100},
            {dataIndex: 'changeForecastSalesByRegularPrice', title: this.$t('results.tableHeaders.changeForecastSalesByRegularPrice') as string, scopedSlots: { customRender: 'changeForecastSalesByRegularPrice' }, width: 100},
            {dataIndex: 'changeForecastSalesPcByRegularPrice', title: this.$t('results.tableHeaders.changeForecastSalesPcByRegularPrice') as string, scopedSlots: { customRender: 'changeForecastSalesPcByRegularPrice' }, width: 100},
            {dataIndex: 'sumRevenueForecastByRegularPrice', title: this.$t('results.tableHeaders.sumRevenueForecastByRegularPrice') as string, scopedSlots: { customRender: 'sumRevenueForecastByRegularPrice' }, width: 100},
            {dataIndex: 'forecastRevenue', title: this.$t('results.tableHeaders.forecastRevenueByNewPrices') as string, scopedSlots: { customRender: 'forecastRevenue' }, width: 100},
            {dataIndex: 'changeForecastRevenueByRegularPrice', title: this.$t('results.tableHeaders.changeForecastRevenueByRegularPrice') as string, scopedSlots: { customRender: 'changeForecastRevenueByRegularPrice' }, width: 100},
            {dataIndex: 'changeForecastRevenuePcByRegularPrice', title: this.$t('results.tableHeaders.changeForecastRevenuePcByRegularPrice') as string, scopedSlots: { customRender: 'changeForecastRevenuePcByRegularPrice' }, width: 100},
            {dataIndex: 'sumMarginForecastByRegularPrice', title: this.$t('results.tableHeaders.sumMarginForecastByRegularPrice') as string, scopedSlots: { customRender: 'sumMarginForecastByRegularPrice' }, width: 100},
            {dataIndex: 'forecastMargin', title: this.$t('results.tableHeaders.forecastMarginByNewPrices') as string, scopedSlots: { customRender: 'forecastMargin' }, width: 100},
            {dataIndex: 'changeForecastMarginByRegularPrice', title: this.$t('results.tableHeaders.changeForecastMarginByRegularPrice') as string, scopedSlots: { customRender: 'changeForecastMarginByRegularPrice' }, width: 100},
            {dataIndex: 'changeForecastMarginPcByRegularPrice', title: this.$t('results.tableHeaders.changeForecastMarginPcByRegularPrice') as string, scopedSlots: { customRender: 'changeForecastMarginPcByRegularPrice' }, width: 100},
            {dataIndex: 'sumMarginForecastPcByRegularPrice', title: this.$t('results.tableHeaders.marginPcByCurrentPrices') as string, scopedSlots: { customRender: 'sumMarginForecastPcByRegularPrice' }, width: 100},
            {dataIndex: 'forecastMarginPc', title: this.$t('results.tableHeaders.forecastMarginPcByNewPrices') as string, scopedSlots: { customRender: 'forecastMarginPc' }, width: 100},
            {dataIndex: 'changeMarginByRegularPricePp', title: this.$t('results.tableHeaders.changeMarginByRegularPricePp') as string, scopedSlots: { customRender: 'changeMarginByRegularPricePp' }, width: 100},
            {dataIndex: 'ftpSendingStatus', title: '', scopedSlots: { customRender: 'ftpSendingStatus' }, width: 50},
        ];

    allDetailReportFields: TableHeaders[] = [
        {key: 'recipeAttribute', label: this.$t('salesMonitorTab.tables.detailColumns.recipeAttribute') as string},
        {key: 'treatmentAttribute', label: this.$t('salesMonitorTab.tables.detailColumns.treatmentAttribute') as string},
        {key: 'vitalMedicine', label: this.$t('salesMonitorTab.tables.detailColumns.vitalMedicine') as string},
        {key: 'producerPrice', label: this.$t('salesMonitorTab.tables.detailColumns.producerPrice') as string},
        {key: 'extraChargePc', label: this.$t('salesMonitorTab.tables.detailColumns.extraChargePc') as string},
        {key: 'registrationPrice', label: this.$t('salesMonitorTab.tables.detailColumns.registrationPrice') as string},
        {key: 'eventTrigger', label: this.$t('salesMonitorTab.tables.detailColumns.eventTrigger') as string},
        {key: 'purchasePriceDeviationPercent', label: this.$t('salesMonitorTab.tables.detailColumns.purchasePriceDeviationPercent') as string, formatter: (v: number | null) => formatPurchasePriceDeviationPercent(v)},
        {key: 'kvi', label: this.$t('salesMonitorTab.tables.detailColumns.kvi') as string, formatter: (value: string) => value === 'ДА' ? this.$t('shared.boolFilter.yes') as string : value === 'НЕТ' ? this.$t('shared.boolFilter.no') as string : value},
        {key: 'ctm', label: this.$t('salesMonitorTab.tables.detailColumns.ctm') as string, formatter: (value: string) => value === 'ДА' ? this.$t('shared.boolFilter.yes') as string : value === 'НЕТ' ? this.$t('shared.boolFilter.no') as string : value},
        {key: 'ctmBrand', label: this.$t('salesMonitorTab.tables.detailColumns.ctmBrand') as string},
        {key: 'ctmPriceGap', label: this.$t('salesMonitorTab.tables.detailColumns.ctmPriceGap') as string},
        {key: 'minRetailPrice', label: this.$t('salesMonitorTab.tables.detailColumns.minRetailPrice') as string},
        {key: 'maxRetailPrice', label: this.$t('salesMonitorTab.tables.detailColumns.maxRetailPrice') as string},
        {key: 'omnichannelStrategy', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelStrategy') as string},
        {key: 'omnichannelFixedGapType', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelFixedGapType') as string},
        {key: 'omnichannelGap', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelGap') as string},
        {key: 'omnichannelApplyCompetitorPrices', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelApplyCompetitorPrices') as string},
        {key: 'omnichannelMinProfitabilityLimit', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelMinProfitabilityLimit') as string},
        {key: 'omnichannelBaseChannelPrice', label: this.$t('salesMonitorTab.tables.detailColumns.omnichannelBaseChannelPrice') as string},
        {key: 'keyProduct1', label: this.$t('salesMonitorTab.tables.detailColumns.keyProduct1') as string},
        {key: 'keyProduct2', label: this.$t('salesMonitorTab.tables.detailColumns.keyProduct2') as string},
        {key: 'keyProduct3', label: this.$t('salesMonitorTab.tables.detailColumns.keyProduct3') as string},
        {key: 'keyProduct4', label: this.$t('salesMonitorTab.tables.detailColumns.keyProduct4') as string},
        {key: 'keyProduct5', label: this.$t('salesMonitorTab.tables.detailColumns.keyProduct5') as string},
        {key: 'segment', label: this.$t('salesMonitorTab.tables.detailColumns.segment') as string},
        {key: 'skuLine', label: this.$t('salesMonitorTab.tables.detailColumns.skuLine') as string},
        {key: 'productVerticalLine', label: this.$t('salesMonitorTab.tables.detailColumns.productVerticalLine') as string},
        {key: 'productVolume', label: this.$t('salesMonitorTab.tables.detailColumns.productVolume') as string},
        {key: 'measurementUnit', label: this.$t('salesMonitorTab.tables.detailColumns.measurementUnit') as string},
        {key: 'isVerticalLineBase', label: this.$t('salesMonitorTab.tables.detailColumns.isVerticalLineBase') as string, formatter: (v, key, item) => "HHFHF" },
        {key: 'vlStrategyStr', label: this.$t('salesMonitorTab.tables.detailColumns.vlStrategyStr') as string},
        {key: 'vlGapPc', label: this.$t('salesMonitorTab.tables.detailColumns.vlGapPc') as string,
          formatter: (_value: any, _key: any, item: any) => Formatter.vlGap(item && item.vlGapPc, item && item.vlGapType)},
        {key: 'purchasePrice', label: this.$t('salesMonitorTab.tables.detailColumns.purchasePrice') as string},
        {key: 'avgRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.avgRegularPrice') as string},
        {key: 'avgCashPrice', label: this.$t('salesMonitorTab.tables.detailColumns.avgCashPrice') as string},
        {key: 'avgCheckPrice', label: this.$t('salesMonitorTab.tables.detailColumns.avgCheckPrice') as string},
        {key: 'regularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.regularPrice') as string},
        {key: 'marginLastPrice', label: this.$t('salesMonitorTab.tables.detailColumns.marginLastPrice') as string},
        {key: 'minCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorPrice') as string},
        {key: 'minCompetitorName', label: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorName') as string},
        {key: 'minCompetitorCode', label: this.$t('salesMonitorTab.tables.detailColumns.minCompetitorCode') as string},
        {key: 'maxCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.maxCompetitorPrice') as string},
        {key: 'maxCompetitorName', label: this.$t('salesMonitorTab.tables.detailColumns.maxCompetitorName') as string},
        {key: 'maxCompetitorCode', label: this.$t('salesMonitorTab.tables.detailColumns.maxCompetitorCode') as string},
        {key: 'avgCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.avgCompetitorPrice') as string},
        {key: 'lastCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.lastCompetitorPrice') as string},
        {key: 'pi', label: this.$t('salesMonitorTab.tables.detailColumns.pi') as string},
        {key: 'promoPi', label: this.$t('salesMonitorTab.tables.detailColumns.promoPi') as string},
        {key: 'actualSales', label: this.$t('salesMonitorTab.tables.detailColumns.actualSales') as string},
        {key: 'actualRevenue', label: this.$t('salesMonitorTab.tables.detailColumns.actualRevenue') as string},
        {key: 'actualMargin', label: this.$t('salesMonitorTab.tables.detailColumns.actualMargin') as string},
        {key: 'actualMarginPercent', label: this.$t('salesMonitorTab.tables.detailColumns.actualMarginPercent') as string},
        {key: 'comparableSales', label: this.$t('salesMonitorTab.tables.detailColumns.comparableSales') as string},
        {key: 'comparableRevenue', label: this.$t('salesMonitorTab.tables.detailColumns.comparableRevenue') as string},
        {key: 'comparableMargin', label: this.$t('salesMonitorTab.tables.detailColumns.comparableMargin') as string},
        {key: 'comparableMarginPc', label: this.$t('salesMonitorTab.tables.detailColumns.comparableMarginPc') as string},
        {key: 'newPrice', label: this.$t('salesMonitorTab.tables.detailColumns.newPrice') as string},
        {key: 'correctedRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.correctedRegularPrice') as string},
        {key: 'priceExperiment', label: this.$t('salesMonitorTab.tables.detailColumns.priceExperiment') as string},
        {key: 'priceExperimentSampleSize', label: this.$t('salesMonitorTab.tables.detailColumns.priceExperimentSampleSize') as string},
        {key: 'priceExperimentDiscountRangeFrom', label: this.$t('salesMonitorTab.tables.detailColumns.priceExperimentDiscountRangeFrom') as string},
        {key: 'priceExperimentDiscountRangeTo', label: this.$t('salesMonitorTab.tables.detailColumns.priceExperimentDiscountRangeTo') as string},
        {key: 'priceExperimentStep', label: this.$t('salesMonitorTab.tables.detailColumns.priceExperimentStep') as string},
        {key: 'priceExperimentStartDate', label: this.$t('salesMonitorTab.tables.detailColumns.priceExperimentStartDate') as string},
        {key: 'priceExperimentEndDate', label: this.$t('salesMonitorTab.tables.detailColumns.priceExperimentEndDate') as string},
        {key: 'newMarginPc', label: this.$t('salesMonitorTab.tables.detailColumns.newMarginPc') as string},
        {key: 'newPI', label: this.$t('salesMonitorTab.tables.detailColumns.newPI') as string},
        {key: 'deltaDiffPrice', label: this.$t('salesMonitorTab.tables.detailColumns.deltaDiffPrice') as string},
        {key: 'priceDiffPc', label: this.$t('salesMonitorTab.tables.detailColumns.priceDiffPc') as string},
        {key: 'marginDiff', label: this.$t('salesMonitorTab.tables.detailColumns.marginDiff') as string},
        {key: 'changedPI', label: this.$t('salesMonitorTab.tables.detailColumns.changedPI') as string},
        {key: 'exitSegment', label: this.$t('salesMonitorTab.tables.detailColumns.exitSegment') as string},
        {key: 'coeffElasticity', label: this.$t('salesMonitorTab.tables.detailColumns.coeffElasticity') as string},
        {key: 'remains', label: this.$t('salesMonitorTab.tables.detailColumns.remains') as string},
        {key: 'initialRemains', label: this.$t('regular.columns.initialRemains') as string},
        {key: 'realizationPercent', label: this.$t('regular.columns.realizationPercent') as string},
        {key: 'salesForecast', label: this.$t('salesMonitorTab.tables.detailColumns.salesForecast') as string},
        {key: 'revenueForecast', label: this.$t('salesMonitorTab.tables.detailColumns.revenueForecast') as string},
        {key: 'marginForecast', label: this.$t('salesMonitorTab.tables.detailColumns.marginForecast') as string},
        {key: 'marginForecastPc', label: this.$t('salesMonitorTab.tables.detailColumns.marginForecastPc') as string},
        {key: 'changeSales', label: this.$t('salesMonitorTab.tables.detailColumns.changeSales') as string},
        {key: 'changeRevenue', label: this.$t('salesMonitorTab.tables.detailColumns.changeRevenue') as string},
        {key: 'changeMargin', label: this.$t('salesMonitorTab.tables.detailColumns.changeMargin') as string},
        {key: 'salesDiffPc', label: this.$t('salesMonitorTab.tables.detailColumns.salesDiffPc') as string},
        {key: 'revenueDiffPc', label: this.$t('salesMonitorTab.tables.detailColumns.revenueDiffPc') as string},
        {key: 'marginDiffPc', label: this.$t('salesMonitorTab.tables.detailColumns.marginDiffPc') as string},
        {key: 'marginDiffSecond', label: this.$t('salesMonitorTab.tables.detailColumns.marginDiffSecond') as string},
        {key: 'salesForecastByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.salesForecastByRegularPrice') as string},
        {key: 'revenueForecastByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.revenueForecastByRegularPrice') as string},
        {key: 'marginForecastByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.marginForecastByRegularPrice') as string},
        {key: 'marginForecastByRegularPricePc', label: this.$t('salesMonitorTab.tables.detailColumns.marginForecastByRegularPricePc') as string},
        {key: 'changeSalesByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.changeSalesByRegularPrice') as string},
        {key: 'changeRevenueByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.changeRevenueByRegularPrice') as string},
        {key: 'changeMarginByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.changeMarginByRegularPrice') as string},
        {key: 'salesDiffPcByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.salesDiffPcByRegularPrice') as string},
        {key: 'revenueDiffPcByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.revenueDiffPcByRegularPrice') as string},
        {key: 'marginDiffPcByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.marginDiffPcByRegularPrice') as string},
        {key: 'marginDiffSecondByRegularPrice', label: this.$t('salesMonitorTab.tables.detailColumns.marginDiffSecondByRegularPrice') as string},
        {key: 'priceTagChangeExpense', label: this.$t('salesMonitorTab.tables.detailColumns.priceTagChangeExpense') as string},
        {key: 'individualPriceOptStrategy', label: this.$t('salesMonitorTab.tables.detailColumns.individualPriceOptStrategy') as string},
        {key: 'individualPriceIncreaseLimit', label: this.$t('salesMonitorTab.tables.detailColumns.individualPriceIncreaseLimit') as string},
        {key: 'individualPeriodPriceIncreaseLimit', label: this.$t('salesMonitorTab.tables.detailColumns.individualPeriodPriceIncreaseLimit') as string},
        {key: 'individualPeriod', label: this.$t('salesMonitorTab.tables.detailColumns.individualPeriod') as string},
        {key: 'individualMarginalProfit', label: this.$t('salesMonitorTab.tables.detailColumns.individualMarginalProfit') as string},
        {key: 'individualKviStrategy', label: this.$t('salesMonitorTab.tables.detailColumns.individualKviStrategy') as string},
        {key: 'individualPercentCorrection', label: this.$t('salesMonitorTab.tables.detailColumns.individualPercentCorrection') as string},
        {key: 'individualNewProductPriceStrategy', label: this.$t('salesMonitorTab.tables.detailColumns.individualNewProductPriceStrategy') as string},
        {key: 'individualPriceGapPercent', label: this.$t('salesMonitorTab.tables.detailColumns.individualPriceGapPercent') as string},
        {key: 'newPriceHistory', label: this.$t('salesMonitorTab.tables.detailColumns.newPriceHistory') as string},
        {key: 'promoPurchasePrice', label: this.$t('salesMonitorTab.tables.detailColumns.promoPurchasePrice') as string},
        {key: 'minPromoCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.minPromoCompetitorPrice') as string},
        {key: 'minPromoCompetitorName', label: this.$t('salesMonitorTab.tables.detailColumns.minPromoCompetitorName') as string},
        {key: 'minPromoCompetitorCode', label: this.$t('salesMonitorTab.tables.detailColumns.minPromoCompetitorCode') as string},
        {key: 'maxPromoCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.maxPromoCompetitorPrice') as string},
        {key: 'maxPromoCompetitorName', label: this.$t('salesMonitorTab.tables.detailColumns.maxPromoCompetitorName') as string},
        {key: 'maxPromoCompetitorCode', label: this.$t('salesMonitorTab.tables.detailColumns.maxPromoCompetitorCode') as string},
        {key: 'medianPromoCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.medianPromoCompetitorPrice') as string},
        {key: 'lastPromoCompetitorPrice', label: this.$t('salesMonitorTab.tables.detailColumns.lastPromoCompetitorPrice') as string},
        {key: 'newPromoPrice', label: this.$t('salesMonitorTab.tables.detailColumns.newPromoPrice') as string},
        {key: 'optimalNewPromoPrice', label: this.$t('salesMonitorTab.tables.detailColumns.optimalNewPromoPrice') as string},
        {key: 'correctedPromoPrice', label: this.$t('salesMonitorTab.tables.detailColumns.correctedPromoPrice') as string},
        {key: 'discountDepth', label: this.$t('salesMonitorTab.tables.detailColumns.discountDepth') as string},
        {key: 'optimalDiscountDepth', label: this.$t('salesMonitorTab.tables.detailColumns.optimalDiscountDepth') as string},
        {key: 'discountDuration', label: this.$t('salesMonitorTab.tables.detailColumns.discountDuration') as string},
        {key: 'promoCoeffElasticity', label: this.$t('salesMonitorTab.tables.detailColumns.promoCoeffElasticity') as string},
        {key: 'individualPromoType', label: this.$t('salesMonitorTab.tables.detailColumns.individualPromoType') as string},
        {key: 'individualPromoLift', label: this.$t('salesMonitorTab.tables.detailColumns.individualPromoLift') as string},
        {key: 'basePrice', label: this.$t('salesMonitorTab.tables.detailColumns.basePrice') as string},
        {key: 'vatPercentage', label: this.$t('salesMonitorTab.tables.detailColumns.vatPercentage') as string},
        {key: 'markupPercentage', label: this.$t('salesMonitorTab.tables.detailColumns.markupPercentage') as string},
        {key: 'marketingPaymentsPercentage', label: this.$t('salesMonitorTab.tables.detailColumns.marketingPaymentsPercentage') as string},
        {key: 'logisticCostsAmount', label: this.$t('salesMonitorTab.tables.detailColumns.logisticCostsAmount') as string},
        {key: 'logisticCostsPercentage', label: this.$t('salesMonitorTab.tables.detailColumns.logisticCostsPercentage') as string},
        {key: 'minPriceForSale', label: this.$t('salesMonitorTab.tables.detailColumns.minPriceForSale') as string},
        {key: 'maxPriceForSale', label: this.$t('salesMonitorTab.tables.detailColumns.maxPriceForSale') as string},
        {key: 'minDiscountForSale', label: this.$t('salesMonitorTab.tables.detailColumns.minDiscountForSale') as string},
        {key: 'maxDiscountForSale', label: this.$t('salesMonitorTab.tables.detailColumns.maxDiscountForSale') as string},
        {key: 'minMarginForSale', label: this.$t('salesMonitorTab.tables.detailColumns.minMarginForSale') as string},
        {key: 'firstDiscountForSale', label: this.$t('salesMonitorTab.tables.detailColumns.firstDiscountForSale') as string},
        {key: 'secondDiscountForSale', label: this.$t('salesMonitorTab.tables.detailColumns.secondDiscountForSale') as string},
        {key: 'thirdDiscountForSale', label: this.$t('salesMonitorTab.tables.detailColumns.thirdDiscountForSale') as string},
        {key: 'fourthDiscountForSale', label: this.$t('salesMonitorTab.tables.detailColumns.fourthDiscountForSale') as string},
        {key: 'salePointCode', label: this.$t('salesMonitorTab.tables.detailColumns.salePointCode') as string},
        {key: 'marginLoss', label: this.$t('salesMonitorTab.tables.detailColumns.marginLoss') as string},
        {key: 'marginLossPc', label: this.$t('salesMonitorTab.tables.detailColumns.marginLossPc') as string},
        {key: 'status', label: this.$t('salesMonitorTab.tables.detailColumns.status') as string},
        {key: 'detailedStatus', label: this.$t('salesMonitorTab.tables.detailColumns.detailedStatus') as string},
        {key: 'uploadFile', label: this.$t('salesMonitorTab.tables.detailColumns.uploadFile') as string},
        {key: 'comment', label: this.$t('salesMonitorTab.tables.detailColumns.comment') as string},
        {key: 'minPriceForPromotion', label: this.$t('salesMonitorTab.tables.detailColumns.minPriceForPromotion') as string},
        {key: 'maxPriceForPromotion', label: this.$t('salesMonitorTab.tables.detailColumns.maxPriceForPromotion') as string},
        {key: 'minDiscountForPromotion', label: this.$t('salesMonitorTab.tables.detailColumns.minDiscountForPromotion') as string},
        {key: 'maxDiscountForPromotion', label: this.$t('salesMonitorTab.tables.detailColumns.maxDiscountForPromotion') as string},
        {key: 'minMarginForPromotion', label: this.$t('salesMonitorTab.tables.detailColumns.minMarginForPromotion') as string},
        {key: 'firstDiscountForPromotion', label: this.$t('salesMonitorTab.tables.detailColumns.firstDiscountForPromotion') as string},
    ]

    private hasUnsavedRegularPrices: boolean = false;
    private hasUnsavedPromoPrices: boolean = false;
    numberFormatter = (v: any): string => FormatNumber.format(v);

    thAttrTitle(value: any, key: string) {
        const fieldDef = this.resultDetailColumns.find((value, index) => value.dataIndex === key);

        if (fieldDef != null) {
            return {title: fieldDef.label}
        } else {
            return {}
        }
    }

    onTableChange(pagination: any, filters: any, sorter: any) {
        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;

        // custom management sorting state of table
        this.resultDetailColumns.forEach(column => {
            if (column.sorter && column.sortOrder) {
                column.sortOrder = false;
            }
        })

        if (sorter.field && sorter.order) {
            this.resultDetailColumns.find(column => column.dataIndex === sorter.field).sortOrder = sorter.order;
        }

        if (sorter.field && sorter.order) {
            this.sortingField = {fieldName: sorter.field, sortValue: sorter.order === 'ascend' ? 0 : 1}
        } else if (this.sortingField) {
            this.sortingField = null;
        }

        this.fetchResultTableDetailReports();
    }

    private getIncludedSkusPropertiesArray(): UniqSkuData[] {
        return Array.from(this.includedSkusProperties).map(key => {
            const [id, taskId, internalCode] = key.split('::');

            return { id: Number(id), taskId: Number(taskId), internalCode };
        });
    }

    private getExcludedSkusPropertiesArray(): UniqSkuData[] {
        return Array.from(this.excludedSkusProperties).map(key => {
            const [id, taskId, internalCode] = key.split('::');

            return { id: Number(id), taskId: Number(taskId), internalCode };
        });
    }

    private addToIncludedSkusProperties(key: string): void {
        this.includedSkusProperties = new Set([...this.includedSkusProperties, key]);
    }

    private removeFromIncludedSkusProperties(key: string): void {
        const newSet = new Set(this.includedSkusProperties);

        newSet.delete(key);

        this.includedSkusProperties = newSet;
    }

    private addToExcludedSkusProperties(key: string): void {
        this.excludedSkusProperties = new Set([...this.excludedSkusProperties, key]);
    }

    private removeFromExcludedSkusProperties(key: string): void {
        const newSet = new Set(this.excludedSkusProperties);

        newSet.delete(key);

        this.excludedSkusProperties = newSet;
    }

    private clearIncludedSkusProperties(): void {
        this.includedSkusProperties = new Set();
    }

    private clearExcludedSkusProperties(): void {
        this.excludedSkusProperties = new Set();
    }

    get isAllSkusCommonCheckboxChecked() {
        return (this.isAllSkusCommonCheckboxSelectedFunctionally && this.excludedSkusProperties.size === 0)
            || (!this.isAllSkusCommonCheckboxSelectedFunctionally && this.includedSkusProperties.size === this.pagination.total);
    }

    handleAllSkusCommonCheckboxChanged(value: boolean) {
        this.isAllSkusCommonCheckboxSelectedFunctionally = value;

        this.clearIncludedSkusProperties();
        this.clearExcludedSkusProperties();
    }

    get isFilteredSkusCommonCheckboxChecked() {
        if (this.isAllSkusCommonCheckboxSelectedFunctionally) {
            for (const key of this.allFilteredSkusUniqueData) {
                if (this.excludedSkusProperties.has(key)) {
                    return false;
                }
            }

            return true;
        } else {
            for (const key of this.allFilteredSkusUniqueData) {
                if (!this.includedSkusProperties.has(key)) {
                    return false;
                }
            }

            return true;
        }
    }

    handleFilteredSkusCommonCheckboxChanged (value: boolean) {
        if (this.isAllSkusCommonCheckboxSelectedFunctionally) {
            if (value) {
                const newExcludedSet = new Set(this.excludedSkusProperties);

                for (const key of this.allFilteredSkusUniqueData) {
                    newExcludedSet.delete(key);
                }

                this.excludedSkusProperties = newExcludedSet;
            } else {
                this.excludedSkusProperties = new Set([...this.excludedSkusProperties, ...this.allFilteredSkusUniqueData]);
            }
        } else {
            if (value) {
                this.includedSkusProperties = new Set([...this.includedSkusProperties, ...this.allFilteredSkusUniqueData]);
            } else {
                const newIncludedSet = new Set(this.includedSkusProperties);

                for (const key of this.allFilteredSkusUniqueData) {
                    newIncludedSet.delete(key);
                }

                this.includedSkusProperties = newIncludedSet;
            }
        }
    }

    get isTableHasSelectedRows () {
        return (this.isAllSkusCommonCheckboxSelectedFunctionally && (this.excludedSkusProperties.size < this.pagination.total))
            || (!this.isAllSkusCommonCheckboxSelectedFunctionally && (this.includedSkusProperties.size > 0));
    }

    getFilters(dataIndex: string) {
        let key = dataIndex;

        if (key === 'subCategoryName') key = 'subcategoryName'
        if (key === 'productSegmentName') key = 'segmentName'
        if (key === 'segment') key = 'segmentPrice'
        if (key === 'changedPI') key = 'changedPIPc'
        if (key === 'coeffElasticity') key = 'coeffElasticityPc'
        if (key === 'promoCoeffElasticity') key = 'promoCoeffElasticityPc'
        // @ts-ignore
        const filters = this[`${key}sOptionsForDetailTable`] || this[`${key}OptionsForDetailTable`] || this[`${key}Options`]
        if (dataIndex == 'approvedByFio') {
          console.log('filtersCustom', filters)
        }

        return (filters || []);
    }

    beforeDeleteFileDialog(taskId: number) {
        this.showDeleteSingleReportModal = true
        this.taskIdForDelete = taskId;
    }

    showDeleteFileDialog(taskId: number) {
        this.deleteTask([taskId]);
    }

        deleteTask(taskIds: number[]) {
            this.$http.post('/api/task/delete', taskIds)
                .then(() => {
                    (this.$refs.resultGeneralSubReportsRef as any).refresh();
                    this.refreshDetailTable();
                })
                .catch((err) => {
                    this.showError(this.$t('results.messages.errorDeleteReport') as string);
                });
        }

        selectResult(subTask: ResultTableHeaders) {
            // Вызов компонента Reports.vue и его метода selectPackageResult
            EventBus.$emit('packageSubTaskView', subTask)
        }

        clearCalcAllData() {
            this.clearDetailTableFilter();
            this.detailReportTotalRows = -1;
            this.segmentPriceOptionsForDetailTable = [];
            this.isDownloadAllFiltersName = false
            this.resultTableHeaders = [];
            this.resultTableDetailReports = [];
            this.tableKey = Math.random();
            this.changesPrices = [];
            this.hasUnsavedRegularPrices = false;
            this.isGeneralRegularPackage = false;
            this.showGeneralComparableBlock = true;
            this.downloadLastExcelHeaderByFilters = false;
            this.downloadLastExcelDetailByFilters = false;
        }

        clearPromoAllData() {
            this.clearDetailTableFilter();
            this.detailReportTotalRows = -1;
            this.segmentPriceOptionsForDetailTable = [];
            this.isDownloadAllFiltersName = false
            this.resultTableHeaders = [];
            this.resultTableDetailReports = [];
            this.tableKey = Math.random();
            this.changesPrices = [];
            this.hasUnsavedPromoPrices = false;
            this.isGeneralRegularPackage = false;
            this.showGeneralComparableBlock = true;
        }

        moveFiltersToTableFilters(taskId: number) {
            this.showAction(
                this.$t('results.messages.confirmSetDefaults') as string,
                {
                    position: 'top-center',
                    type: 'info',
                    singleton: true,
                    duration: 10000,
                    icon: 'filter',
                    theme: 'bubble',
                    action: [{
                        text: this.$t('shared.buttons.yes') as string,
                        onClick: () => {
                            const taskIds: number[] = []
                            taskIds.push(taskId)
                            this.httpMoveTaskFilter(taskIds)
                                .then(() => {
                                    this.showInfo(this.$t('results.messages.successSetDefaults') as string);

                                })
                                .catch(() => {
                                    this.showError(this.$t('results.messages.errorSetFilter') as string + ' #' + taskId);
                                });
                        }}]});
        }

        saveCorrectedPrices() {
            // Для типа расчетов 'sales', 'promo' и 'price-exp' используем новую логику переформирования
            if (this.reportType === 'sales' || this.reportType === 'promo' || this.reportType === 'price-exp') {
                this.recalculateTypeReportFromDetail();
                return;
            }

            const changesPricesToProcess = Object.assign([], this.changesPrices) as ChangesPrices[];

            const includedSkusPropertiesArray = this.getIncludedSkusPropertiesArray();
            const excludedSkusPropertiesArray = this.getExcludedSkusPropertiesArray();

            const taskIds = [
                ...new Set([
                    ...changesPricesToProcess.map(el => el.taskId),
                    ...includedSkusPropertiesArray.map(el => el.taskId),
                    ...excludedSkusPropertiesArray.map(el => el.taskId),
                ])
            ];

            taskIds.forEach(taskId => {
                const record = changesPricesToProcess.find(el => el.taskId === taskId);

                if (record) {
                    record.includedSkus = includedSkusPropertiesArray.filter(item => item.taskId === taskId).map(item => item.internalCode);
                    record.excludedSkus = excludedSkusPropertiesArray.filter(item => item.taskId === taskId).map(item => item.internalCode);
                } else {
                    const chPrice = new ChangesPrices();

                    chPrice.taskId = taskId;
                    chPrice.includedSkus = includedSkusPropertiesArray.filter(item => item.taskId === taskId).map(item => item.internalCode);
                    chPrice.excludedSkus = excludedSkusPropertiesArray.filter(item => item.taskId === taskId).map(item => item.internalCode);

                    changesPricesToProcess.push(chPrice);
                }
            });

            // закомментил, т.к. это условие никогда не выполнится, возможно совсем удалить нужно будет
            // if (this.reportType === 'promo') {
            //     if (this.taskData != null) {
            //         this.showActiveStatusMessage();
            //
            //         this.paramsForDetail.changesPrices = changesPricesToProcess;
            //         this.paramsForDetail.isAllSkusSelected = this.isAllSkusCommonCheckboxSelectedFunctionally;
            //         this.paramsForDetail.selectActiveProductsOnly = this.selectActiveProductsOnly;
            //         this.paramsForDetail.filterParams = this.getReportDetailParams();
            //
            //         // tslint:disable-next-line: no-non-null-assertion
            //         this.httpSaveCorrectedPromoPrices(this.taskData!!.id, this.taskData.type, this.paramsForDetail)
            //             .then((resp) => {
            //                 if (resp.status === 409) {
            //                     this.showError(this.$t('resultView.errors.calculationInProgress') as string);
            //                 }
            //                 this.refreshDetailTable();
            //                 this.hideActiveStatusMessage();
            //                 this.updateTableCheckboxesPrevConfiguration();
            //             })
            //             .catch((e) => {
            //                 this.refreshDetailTable();
            //                 this.hideActiveStatusMessage();
            //             })
            //     }
            // } else {
                if (this.taskData != null) {
                    this.showActiveStatusMessage();

                    this.paramsForDetail.changesPrices = changesPricesToProcess;
                    this.paramsForDetail.isAllSkusSelected = this.isAllSkusCommonCheckboxSelectedFunctionally;
                    this.paramsForDetail.selectActiveProductsOnly = this.selectActiveProductsOnly;
                    this.paramsForDetail.filterParams = this.getReportDetailParams();

                    // tslint:disable-next-line: no-non-null-assertion
                    this.httpSaveCorrectedRegularPrices(this.taskData!!.id, this.taskData.type, this.paramsForDetail)
                        .then((resp) => {
                            if (resp.status === 409) {
                                this.showError(this.$t('results.messages.errorCalcInProgress') as string);
                            }
                            this.refreshDetailTable();
                            this.hideActiveStatusMessage();
                            this.updateTableCheckboxesPrevConfiguration();
                            (this.$refs.resultHeaderTableRef as any).refresh();
                        })
                        .catch((e) => {
                            this.refreshDetailTable();
                            this.hideActiveStatusMessage();
                        });
                }
            // }
        }

        fullRecalculatePackageTask() {
            if (!this.competitorsCorrectionsValidate()) {
                return;
            }
            if (this.taskData != null) {
                this.showActiveStatusMessage();

                const packageDetailParamFilters = this.getPackageParamsDetailFilter()
                this.httpRestartPackageTaskFromDetailParams(this.taskData.id, packageDetailParamFilters)
                    .then((resp) => {
                        this.loadHeaders();
                        this.loadDetails();
                        this.getReportDetailFieldsByUserId();
                        this.hideActiveStatusMessage();
                    })
                    .catch((e) => {
                        this.hideActiveStatusMessage()
                    })
            }
        }

        recalculateTypeReportFromDetail() {
            if (!this.taskData) return;

            this.showActiveStatusMessage();

            const generalTaskId = this.taskData.id;

            // Collect selection similar to saveCorrected prices flow
            const selectedSkuSalePoints: Array<{ internalCode: string, codeSalesPoint: string }> = [];

            // When not all SKUs are selected: include only explicitly selected
            if (!this.isAllSkusCommonCheckboxSelectedFunctionally) {
                const includedSkusPropertiesArray = this.getIncludedSkusPropertiesArray();

                includedSkusPropertiesArray.forEach(({ internalCode, taskId }) => {
                    // Find any row matching this pair to grab salePointCode
                    const row = this.resultTableDetailReports.find((r: any) => r.internalCode === internalCode && r.taskId === taskId);
                    if (row && row.salePointCode) {
                        selectedSkuSalePoints.push({ internalCode, codeSalesPoint: row.salePointCode });
                    }
                });
            } else {
                // All selected: exclude items explicitly unchecked
                // this.allTaskIdWithInternalCodesByFilters.forEach(({ taskId, internalCode }: any) => {
                //     if (!this.excludedSkusProperties.has(`${taskId}::${internalCode}`)) {
                //         const row = this.resultTableDetailReports.find((r: any) => r.internalCode === internalCode && r.taskId === taskId);
                //         if (row && row.salePointCode) {
                //             selectedSkuSalePoints.push({ internalCode, codeSalesPoint: row.salePointCode });
                //         }
                //     }
                // });

                // переписал то, что закомментил выше, по сути не изменив логику (т.к. allTaskIdWithInternalCodesByFilters всегда были записи,
                // которые подходили под условие this.resultTableDetailReports.find((r: any) => r.internalCode === internalCode && r.taskId === taskId)),
                // а необходимо избавиться от allTaskIdWithInternalCodesByFilters, чтобы не перегружать фронтенд, когда записей десятки и сотни тысяч.
                // теперь разница будет лишь в том, что если в результатах (вообще, не только на текущей странице) есть несколько записей на других страницах, с одинаковыми taskId и internalCode,
                // то ранее отправлялся массив с несколькими одинаковыми объектами с saleCode из первой записи, подпадающей под условие с текущей странице,
                // а теперь число этих одинаковых записей будет столько, сколько таких записей именно на текущей странице, а не вообще среди всех записей
                this.resultTableDetailReports.forEach(({ id, taskId, internalCode, salePointCode }: any) => {
                    if (!this.excludedSkusProperties.has(`${id}::${taskId}::${internalCode}`)) {
                        if (salePointCode) {
                            selectedSkuSalePoints.push({ internalCode, codeSalesPoint: salePointCode });
                        }
                    }
                });
            }

            const requestBody: any = {
                generalTaskId,
                isAllSkusSelected: this.isAllSkusCommonCheckboxSelectedFunctionally,
                selectedSkuSalePoints,
                // Filters object mirrors current detail filters
                filters: this.getReportDetailParams(),
                salePointsFilter: this.selectSalePointCodesForDetailTable,
            };

            let moveToReportsList: boolean = false;

            let recalculateMethod;
            if (this.reportType === 'promo') {
                recalculateMethod = this.httpRecalculatePromotions;
            } else if (this.reportType === 'price-exp') {
                recalculateMethod = this.httpRecalculatePriceExp;
            } else {
                recalculateMethod = this.httpRecalculateSales;
            }

            recalculateMethod(requestBody)
                .then(() => {
                    this.loadHeaders();
                    this.loadDetails();
                    this.getReportDetailFieldsByUserId();

                    moveToReportsList = true;
                })
                .catch(() => {})
                .finally(() => {
                    this.hideActiveStatusMessage();

                    if (moveToReportsList) {
                        this.$emit('to-report-list');
                    }
                });
        }

        updateTableCheckboxesPrevConfiguration(): void {
            this.tableCheckboxesPrevConfiguration = {
                selectActiveProductsOnly: this.selectActiveProductsOnly,
                isAllSkusCommonCheckboxSelectedFunctionally: this.isAllSkusCommonCheckboxSelectedFunctionally,
                includedSkusProperties: new Set(this.includedSkusProperties),
                excludedSkusProperties: new Set(this.excludedSkusProperties),
            };
        }

        private areSetsEqual(set1: Set<string>, set2: Set<string>): boolean {
            if (set1.size !== set2.size) {
                return false;
            }

            for (const item of set1) {
                if (!set2.has(item)) {
                    return false;
                }
            }

            return true;
        }

        get resultsSubTabsNames(): {
            shortReportName: string,
            shortReportKey: string,
            detailedReportName: string,
            detailedReportKey: string,
        } {
            return this.reportType === 'promo' ? {
                shortReportName: this.$t('results.tabs.revaluation') as string,
                shortReportKey: 'revaluation',
                detailedReportName: this.$t('results.tabs.detailBySku') as string,
                detailedReportKey: 'detailSKU',
            } : {
                shortReportName: this.$t('results.tabs.detailBySku') as string,
                shortReportKey: 'detailSKU',
                detailedReportName: this.$t('results.tabs.allSkus') as string,
                detailedReportKey: 'allSkus',
            };
        }

        get isRecalculateButtonActive(): boolean {
          return this.tableCheckboxesPrevConfiguration.selectActiveProductsOnly !== this.selectActiveProductsOnly
              || this.tableCheckboxesPrevConfiguration.isAllSkusCommonCheckboxSelectedFunctionally !== this.isAllSkusCommonCheckboxSelectedFunctionally
              || !this.areSetsEqual(this.tableCheckboxesPrevConfiguration.includedSkusProperties, this.includedSkusProperties)
              || !this.areSetsEqual(this.tableCheckboxesPrevConfiguration.excludedSkusProperties, this.excludedSkusProperties);
        }

        get disabledRecalculateButton(): boolean {
            if (this.reportType === 'promo' || this.reportType === 'sales' || this.reportType === 'price-exp') {
                return (!this.hasUnsavedPromoPrices && !this.isRecalculateButtonActive) || this.disableEdit;
            } else {
              return (
                  ((!this.hasUnsavedRegularPrices && !this.isRecalculateButtonActive) || this.disableEdit)
                  && !this.hasCorrectedPrices
              );
            }
        }

        showDownloadFileButton(): boolean {
          return this.taskData != null && this.taskData.fileResult != null && this.taskData.fileResult.length > 0
        }

        handleSendForApprovalError(error: any, reason: string) {
          if (error.response && error.response.status === 403) {
            this.showError(this.$t('regular.errors.sendForApprovalForbidden') as string);
            return;
          }
          this.showError(this.$t('results.messages.errorSendForApproval', { reason }) as string);
        }

        showDownloadPriceButton(task: TaskAndFile): boolean {
          const isTaskReadyToBeGenerated =
              isTaskInBackgroundGeneratableTypesAndStatuses(task.type, task.status ? task.status : '')

          return this.canSubmitRevaluationForApproval()
              && taskTypesRequiresConfirmation.map((entry) => entry.value).includes(task.type)
              && (task.status !== TaskStatus.APPROVED && task.status !== TaskStatus.ONAPPROVAL)
              && ((task.fileResult != null && task.fileResult.length > 0) || isTaskReadyToBeGenerated)
        }

        showGenerateReportButton(): boolean {
          if (this.taskData == null || this.taskData.status == null) {
            return false
          }

          const isTaskReadyToBeGenerated =
              isTaskInBackgroundGeneratableTypesAndStatuses(this.taskData.type, this.taskData.status)

          return (this.taskData.fileResult == null || !this.taskData.fileResult.length)
              && isTaskReadyToBeGenerated
        }

        generateReport() {
          const task = this.taskData
          if (task != null) {
            this.httpStartGeneratingReport(task.id)
          } else {
            this.showError(this.$t('results.messages.errorGenerateReport') as string)
          }
        }

        beforeSendToFTPDialog() {
            this.showSendToFTPReportModal = true
            console.log("showSendToFTPReportModal, ", this.showSendToFTPReportModal)
        }

        beforeSendToFTPDialogForSubTask(taskId: number) {
            this.showSendToFTPSubTaskReportModal = true
            this.subTaskIdForSendToFTP = taskId;
        }

        existsUnsavedPrices(): boolean {
            if (this.reportType === 'promo' || this.reportType === 'sales') {
                return this.hasUnsavedPromoPrices;
            } else {
                return this.hasUnsavedRegularPrices;
            }
        }

        mounted() {
            this.calcTaskData(this.taskData, null);
            EventBus.$on('calc', this.onTaskEventReceived);
            EventBus.$on('ftpDownloadProgress', this.onFtpDownloadProgressReceived);

            this.fetchResultTableDetailReports();

            this.fetchHasCorrectedPricesFlag()

            this.fetchCommonFilterOptions();

            this.getDetailTableColumnsOrder();

            // temporary - to remove after deploy to all clients and after opening this page on each client
            if (this.reportType === 'sales') {
                const isSkipResetSalesColumnsOrder = localStorage.getItem('isSkipResetSalesColumnsOrder');

                if (!isSkipResetSalesColumnsOrder || isSkipResetSalesColumnsOrder !== 'version_01_09_2025') {
                    localStorage.removeItem('skuDetailSalesColumnsOrder');
                    localStorage.setItem('isSkipResetSalesColumnsOrder', 'version_01_09_2025');

                    this.$router.go(this.$router.currentRoute as any);
                }
            } else if (this.reportType === 'promo') {
                const isSkipResetPromoColumnsOrder = localStorage.getItem('isSkipResetPromoColumnsOrder');

                if (!isSkipResetPromoColumnsOrder || isSkipResetPromoColumnsOrder !== 'version_22_10_2025_3') {
                    localStorage.removeItem('skuDetailPromoColumnsOrder');
                    localStorage.setItem('isSkipResetPromoColumnsOrder', 'version_22_10_2025_3');

                    this.$router.go(this.$router.currentRoute as any);
                }
            } else {
                const isSkipResetRegularColumnsOrder = localStorage.getItem('isSkipResetRegularColumnsOrder');

                if (!isSkipResetRegularColumnsOrder || isSkipResetRegularColumnsOrder !== 'version_01_09_2025') {
                    localStorage.removeItem('skuDetailRegularColumnsOrder');
                    localStorage.setItem('isSkipResetRegularColumnsOrder', 'version_01_09_2025');

                    this.$router.go(this.$router.currentRoute as any);
                }
            }
            // /temporary
        }

        @Watch('$route.params.id')
        onRouteIdChanged(newId: string) {
          this.handleRouteChange(newId)
        }

        handleRouteChange(id: string) {
          this.fetchHasCorrectedPricesFlag()
        }

        onFtpDownloadProgressReceived(ftpSendProgress: FtpDownloadProgress) {
            this.updateSendToFtpProgress(ftpSendProgress);
        }

        updateSendToFtpProgress(ftpSendProgress: FtpDownloadProgress) {
            const index = this.resultGeneralSubtasksTableHeaders.findIndex((item) => {
                return item.taskId === ftpSendProgress.taskId;
            });
            if (index !== -1) {
                this.resultGeneralSubtasksTableHeaders[index].ftpSendingStatus = ftpSendProgress.ftpSendStatus;
            }
        }

        disableCalcPurchasePriceByClustersCheckbox() {
            if (!this.$packageParamsInDetailReport.countByAvgPurchasePrice) {
                this.$packageParamsInDetailReport.calcPurchasePriceByClusters = false;
                this.$packageParamsInDetailReport.useArrivalDate = false;
            }
            if (this.$packageParamsInDetailReport.countByAvgPurchasePrice) {
                this.$packageParamsInDetailReport.countAtFuturePurchasePrice = false;
            }
        }

        getColumnWidth(dataIndex: string): number {
            const commonWidthOfColumns: {[key: string]: number} = {
                omnichannelStrategy: 220,
                omnichannelFixedGapType: 160,
                omnichannelGap: 100,
                omnichannelApplyCompetitorPrices: 200,
                omnichannelMinProfitabilityLimit: 260,
                omnichannelBaseChannelPrice: 160,
                newPrice: 140,
                newPriceHistory: 300,
                correctedRegularPrice: 230,
                newMarginPc: 160,
                newPI: 140,
                deltaDiffPrice: 150,
                priceDiffPc: 150,
                marginDiff: 160,
                changedPI: 140,
                exitSegment: 160,
                coeffElasticity: 140,
                remains: 120,
                salesForecast: 156,
                revenueForecast: 160,
                marginForecast: 160,
                marginForecastPc: 160,
                changeSales: 176,
                changeRevenue: 180,
                changeMargin: 176,
                salesDiffPc: 160,
                revenueDiffPc: 160,
                marginDiffPc: 160,
                marginDiffSecond: 160,
                salesForecastByRegularPrice: 210,
                revenueForecastByRegularPrice: 210,
                marginForecastByRegularPrice: 200,
                marginForecastByRegularPricePc: 210,
                changeSalesByRegularPrice: 220,
                changeRevenueByRegularPrice: 226,
                changeMarginByRegularPrice: 216,
                salesDiffPcByRegularPrice: 200,
                revenueDiffPcByRegularPrice: 206,
                marginDiffPcByRegularPrice: 190,
                marginDiffSecondByRegularPrice: 180,
                priceTagChangeExpense: 150,
                recipeAttribute: 80,
                treatmentAttribute: 80,
                vitalMedicine: 110,
                producerPrice: 160,
                extraChargePc: 140,
                registrationPrice: 150,
                eventTrigger: 166,
                purchasePriceDeviationPercent: 140,
                kvi: 92,
                ctm: 92,
                ctmBrand: 150,
                ctmPriceGap: 156,
                minRetailPrice: 140,
                maxRetailPrice: 146,
                keyProduct1: 200,
                keyProduct2: 160,
                keyProduct3: 170,
                keyProduct4: 170,
                keyProduct5: 170,
                segment: 130,
                skuLine: 200,
                purchasePrice: 180,
                avgRegularPrice: 194,
                avgCashPrice: 180,
                avgCheckPrice: 162,
                regularPrice: 130,
                marginLastPrice: 200,
                minCompetitorPrice: 176,
                minCompetitorName: 200,
                maxCompetitorPrice: 180,
                maxCompetitorName: 200,
                avgCompetitorPrice: 180,
                lastCompetitorPrice: 234,
                pi: 80,
                actualSales: 176,
                actualRevenue: 170,
                actualMargin: 160,
                actualMarginPercent: 172,
                comparableSales: 190,
                comparableRevenue: 190,
                comparableMargin: 176,
                comparableMarginPc: 190,
                logisticCostsPercentage: 196,
                logisticCostsAmount: 196,
                marketingPaymentsPercentage: 210,
                limitRetailPrice: 196,
                markupPercentage: 170,
                vatPercentage: 90,
                basePrice: 166,
                individualPriceOptStrategy: 190,
                individualPriceIncreaseLimit: 160,
                individualPeriodPriceIncreaseLimit: 162,
                individualPeriod: 120,
                individualMarginalProfit: 206,
                individualKviStrategy: 160,
                individualPercentCorrection: 160,
                individualNewProductPriceStrategy: 186,
                individualPriceGapPercent: 160,
                productVerticalLine: 140,
                detailedStatus: 140,
                uploadFile: 180,
                productVolume: 80,
                measurementUnit: 70,
                isVerticalLineBase: 110,
                vlStrategyStr: 140,
                vlGapPc: 176,
                comment: 240,
                // next - only promo fields
                minPriceForPromotion: 180,
                maxPriceForPromotion: 180,
                minDiscountForPromotion: 200,
                maxDiscountForPromotion: 200,
                minMarginForPromotion: 190,
                firstDiscountForPromotion: 170,
                promoPurchasePrice: 200,
                minPromoCompetitorPrice: 220,
                minPromoCompetitorName: 200,
                maxPromoCompetitorPrice: 230,
                maxPromoCompetitorName: 200,
                medianPromoCompetitorPrice: 246,
                lastPromoCompetitorPrice: 266,
                newPromoPrice: 186,
                correctedPromoPrice: 236,
                discountDepth: 210,
                discountDuration: 150,
                promoCoeffElasticity: 150,
                individualPromoType: 120,
                individualPromoLift: 200,
                promoPi: 116,
                status: 170,
                // next - only sales fields
                minPriceForSale: 194,
                maxPriceForSale: 200,
                minDiscountForSale: 206,
                maxDiscountForSale: 206,
                minMarginForSale: 200,
                firstDiscountForSale: 190,
                secondDiscountForSale: 190,
                thirdDiscountForSale: 190,
                fourthDiscountForSale: 190,
            }

            const widthOfColumns: Record<'regular' | 'promo' | 'sales' | 'price-exp', Record<string, number>> = {
                sales: {
                    newPrice: 190,
                },
                regular: {},
                promo: {},
                'price-exp': {},
            };

            return (widthOfColumns[this.reportType] && widthOfColumns[this.reportType][dataIndex] ? widthOfColumns[this.reportType][dataIndex] : commonWidthOfColumns[dataIndex]) || 200;
        }

        getReportDetailFieldsByUserId() {
            if (!this.taskData || !this.taskData.id) {
                this.showError(this.$t('results.messages.errorReportDataNotReceived') as string);
                return;
            }

            this.httpGetReportDetailFieldsByUserId(this.reportType, { taskId: this.taskData!.id })
                .then((r) => {
                        this.detailUserFields = r.data;

                        if (this.detailUserFields.length) {
                            const singleFilters = ['kvi', 'ctm'];
                            const columnsWithFiltersArray = [ // not included fields, that have added props in manually created column arrays
                                'newPrice', 'newMarginPc', 'deltaDiffPrice', 'newPI', 'priceDiffPc', 'marginDiff', 'changedPI', 'salesDiffPc', 'revenueDiffPc',
                                'marginDiffPc', 'marginDiffSecond', 'marginForecastByRegularPricePc', 'salesDiffPcByRegularPrice',
                                'revenueDiffPcByRegularPrice', 'marginDiffPcByRegularPrice', 'marginDiffSecondByRegularPrice', 'kvi', 'ctm', 'purchasePrice',
                                'regularPrice', 'marginLastPrice', 'lastCompetitorPrice', 'pi', 'actualMarginPercent', 'comparableMarginPc', 'keyProduct1',
                                'keyProduct2', 'skuLine', 'minCompetitorName', 'maxCompetitorName', 'minCompetitorCode', 'maxCompetitorCode', 'minPromoCompetitorName', 'maxPromoCompetitorName', 'minPromoCompetitorCode', 'maxPromoCompetitorCode', 'productVerticalLine', 'detailedStatus', 'uploadFile', 'salePointCode',
                            ];
                            const columnsWithRangeInFilter = [ // not included fields, that have added props in manually created column arrays
                                'newPrice', 'newMarginPc', 'deltaDiffPrice', 'newPI', 'priceDiffPc', 'changedPI', 'salesDiffPc', 'revenueDiffPc',
                                'marginDiffPc', 'marginDiffSecond', 'marginForecastByRegularPricePc', 'salesDiffPcByRegularPrice',
                                'revenueDiffPcByRegularPrice', 'marginDiffPcByRegularPrice', 'marginDiffSecondByRegularPrice', 'marginLastPrice'
                            ];

                            if (this.reportType === 'promo') {
                                const promoDetailReportColumns = [...this.promoDetailReportStaticFields];

                                this.detailUserFields.forEach((detailField) => {
                                    if (detailField.permanentlyHidden) {
                                        return;
                                    }

                                    const reportField = this.allDetailReportFields.find((v) => v.key === detailField.key)
                                    if (reportField == null) {
                                        this.$log.debug('notFound', detailField.key);
                                    } else {
                                        const promoColumn: any = {
                                            dataIndex: detailField.key,
                                            slots: { title: `${detailField.key}ColumnTitle` }, // dataIndex + 'ColumnTitle'
                                            slotColumnTitleData: {
                                                text: reportField.label,
                                            },
                                            sorter: true,
                                            scopedSlots: {
                                                customRender: detailField.key
                                            },
                                            width: this.getColumnWidth(detailField.key),
                                            ellipsis: true,
                                        }

                                        if (columnsWithFiltersArray.includes(detailField.key)) {
                                            promoColumn.filterOptionsKey = detailField.key;
                                            promoColumn.filterModel = detailField.key;
                                            promoColumn.showRange = columnsWithRangeInFilter.includes(detailField.key);
                                            promoColumn.onFilterDropdownVisibleChange = () => { this.filterDropdownVisibleChange(detailField.key) };
                                            promoColumn.scopedSlots = {
                                                customRender: detailField.key,
                                                filterDropdown: singleFilters.includes(detailField.key) ? "filterRadioButtons" : "filterCheckboxes",
                                                filterIcon: "filterIcon",
                                            };
                                        }

                                        promoDetailReportColumns.push(promoColumn);
                                    }
                                });

                                // ordering columns for promo report
                                const orderOfFieldsPromo = [
                                    "checkboxes", "internalCode", "skuName", "salePointCode", "taskId", "status", "detailedStatus", "isApproved", "approvedByFio",
                                    "newPrice", "newPriceHistory",  "optimalNewPromoPrice",
                                    "optimalDiscountDepth", "firstDiscountForPromotion", "minPriceForPromotion", "maxPriceForPromotion", "minDiscountForPromotion", "maxDiscountForPromotion",
                                    "minMarginForPromotion","marginLoss", "marginLossPc", "remains", "groupName", "categoryName", "subCategoryName",
                                    "formatName", "regionName", "clusterName", "productSegmentName", "recipeAttribute", "treatmentAttribute", "vitalMedicine",
                                    "producerPrice", "extraChargePc", "registrationPrice", "eventTrigger", "purchasePriceDeviationPercent", "kvi", "ctm", "ctmBrand", "ctmPriceGap", "minRetailPrice",
                                    "maxRetailPrice",
                                    "omnichannelStrategy", "omnichannelFixedGapType", "omnichannelGap",
                                    "omnichannelApplyCompetitorPrices", "omnichannelMinProfitabilityLimit", "omnichannelBaseChannelPrice",
                                    "keyProduct1", "keyProduct2", "keyProduct3", "keyProduct4", "keyProduct5", "segment", "skuLine", "purchasePrice", "promoPurchasePrice",
                                    "avgRegularPrice", "avgCashPrice", "avgCheckPrice", "regularPrice", "marginLastPrice", "minCompetitorPrice",
                                    "minCompetitorName", "minCompetitorCode", "maxCompetitorPrice", "maxCompetitorName", "maxCompetitorCode", "avgCompetitorPrice", "lastCompetitorPrice",
                                    "minPromoCompetitorPrice", "minPromoCompetitorName", "minPromoCompetitorCode", "maxPromoCompetitorPrice", "maxPromoCompetitorName", "maxPromoCompetitorCode",
                                    "medianPromoCompetitorPrice", "lastPromoCompetitorPrice", "pi", "promoPi", "actualSales", "actualRevenue", "actualMargin",
                                    "actualMarginPercent", "comparableSales", "comparableRevenue", "comparableMargin", "comparableMarginPc",
                                    "newPromoPrice", "correctedPromoPrice", "newMarginPc", "newPI", "deltaDiffPrice", "priceDiffPc", "marginDiff", "changedPI",
                                    "discountDepth", "discountDuration", "exitSegment", "coeffElasticity", "promoCoeffElasticity", "salesForecast",
                                    "revenueForecast", "marginForecast", "marginForecastPc", "changeSales", "changeRevenue", "changeMargin", "salesDiffPc",
                                    "revenueDiffPc", "marginDiffPc", "marginDiffSecond", "individualPromoType", "individualPromoLift", "individualPriceOptStrategy",
                                    "individualPriceIncreaseLimit", "individualPeriodPriceIncreaseLimit", "individualPeriod", "individualMarginalProfit",
                                    "individualKviStrategy", "individualPercentCorrection", "individualNewProductPriceStrategy", "individualPriceGapPercent",
                                    "comment", "logisticCostsPercentage", "logisticCostsAmount", "marketingPaymentsPercentage", "basePrice", "vatPercentage", "markupPercentage",
                                ];

                                const orderedPromoDetailReportColumns: any[] = [];
                                const notOrderedPromoDetailReportColumns = [...promoDetailReportColumns];

                                orderOfFieldsPromo.forEach(dataIndex => {
                                    const index = notOrderedPromoDetailReportColumns.findIndex(column => column.dataIndex === dataIndex);

                                    if (index !== -1) {
                                        orderedPromoDetailReportColumns.push(notOrderedPromoDetailReportColumns.splice(index, 1)[0]);
                                    }
                                });

                                this.promoDetailReport = [...orderedPromoDetailReportColumns, ...notOrderedPromoDetailReportColumns];
                            } else if (this.reportType === 'sales') {
                                const salesOnlyDetailReportFields: TableHeaders[] = [
                                    {key: 'newPrice', label: this.$t('results.detailColumns.regularPrice') as string},
                                ];

                                const salesDetailReportColumns = [...this.salesDetailReportStaticFields];

                                this.detailUserFields.forEach((detailField) => {
                                    if (detailField.permanentlyHidden) {
                                        return;
                                    }

                                    if (!this.isSalesRealizationReport && ['initialRemains', 'realizationPercent'].includes(detailField.key)) {
                                        return;
                                    }

                                    const reportField = ['newPrice'].includes(detailField.key)
                                        ? salesOnlyDetailReportFields.find((v) => v.key === detailField.key)
                                        : this.allDetailReportFields.find((v) => v.key === detailField.key);

                                    if (reportField) {
                                        const salesColumn: any = {
                                            dataIndex: detailField.key,
                                            slots: { title: `${detailField.key}ColumnTitle` },
                                            slotColumnTitleData: {
                                                text: this.getSalesDetailFieldLabel(detailField.key, reportField.label),
                                            },
                                            sorter: true,
                                            scopedSlots: {
                                                customRender: detailField.key
                                            },
                                            width: this.getColumnWidth(detailField.key),
                                            ellipsis: true,
                                        }

                                        if (columnsWithFiltersArray.includes(detailField.key)) {
                                            salesColumn.filterOptionsKey = detailField.key;
                                            salesColumn.filterModel = detailField.key;
                                            salesColumn.showRange = columnsWithRangeInFilter.includes(detailField.key);
                                            salesColumn.onFilterDropdownVisibleChange = () => { this.filterDropdownVisibleChange(detailField.key) };
                                            salesColumn.scopedSlots = {
                                                customRender: detailField.key,
                                                filterDropdown: singleFilters.includes(detailField.key) ? "filterRadioButtons" : "filterCheckboxes",
                                                filterIcon: "filterIcon",
                                            };
                                        }

                                        salesDetailReportColumns.push(salesColumn);
                                    }
                                });

                                // ordering columns
                                const orderOfFields = [
                                    "checkboxes", "internalCode", "skuName", "salePointCode", "taskId", "status", "detailedStatus", "isApproved", "approvedByFio",
                                    "newPrice", "newPriceHistory",  "optimalNewPromoPrice",
                                    "optimalDiscountDepth", "firstDiscountForSale", "secondDiscountForSale", "thirdDiscountForSale", "fourthDiscountForSale", "minPriceForSale", "maxPriceForSale",
                                    "minDiscountForSale", "maxDiscountForSale", "minMarginForSale", "marginLoss", "marginLossPc", "remains", "initialRemains", "realizationPercent", "groupName", "categoryName", "subCategoryName",
                                    "formatName", "regionName", "clusterName", "productSegmentName", "recipeAttribute", "treatmentAttribute", "vitalMedicine",
                                    "producerPrice", "extraChargePc", "registrationPrice", "eventTrigger", "purchasePriceDeviationPercent", "kvi", "ctm", "ctmBrand", "ctmPriceGap", "minRetailPrice",
                                    "maxRetailPrice",
                                    "omnichannelStrategy", "omnichannelFixedGapType", "omnichannelGap",
                                    "omnichannelApplyCompetitorPrices", "omnichannelMinProfitabilityLimit", "omnichannelBaseChannelPrice",
                                    "keyProduct1", "keyProduct2", "keyProduct3", "keyProduct4", "keyProduct5", "segment", "skuLine", "purchasePrice", "promoPurchasePrice",
                                    "avgRegularPrice", "avgCashPrice", "avgCheckPrice", "regularPrice", "marginLastPrice", "minCompetitorPrice",
                                    "minCompetitorName", "minCompetitorCode", "maxCompetitorPrice", "maxCompetitorName", "maxCompetitorCode", "avgCompetitorPrice", "lastCompetitorPrice",
                                    "minPromoCompetitorPrice", "minPromoCompetitorName", "minPromoCompetitorCode", "maxPromoCompetitorPrice", "maxPromoCompetitorName", "maxPromoCompetitorCode",
                                    "medianPromoCompetitorPrice", "lastPromoCompetitorPrice", "pi", "promoPi", "actualSales", "actualRevenue", "actualMargin",
                                    "actualMarginPercent", "comparableSales", "comparableRevenue", "comparableMargin", "comparableMarginPc",
                                    "newPromoPrice", "correctedPromoPrice", "newMarginPc", "newPI", "deltaDiffPrice", "priceDiffPc", "marginDiff", "changedPI",
                                    "discountDepth", "discountDuration", "exitSegment", "coeffElasticity", "promoCoeffElasticity", "salesForecast",
                                    "revenueForecast", "marginForecast", "marginForecastPc", "changeSales", "changeRevenue", "changeMargin", "salesDiffPc",
                                    "revenueDiffPc", "marginDiffPc", "marginDiffSecond", "individualPromoType", "individualPromoLift", "individualPriceOptStrategy",
                                    "individualPriceIncreaseLimit", "individualPeriodPriceIncreaseLimit", "individualPeriod", "individualMarginalProfit",
                                    "individualKviStrategy", "individualPercentCorrection", "individualNewProductPriceStrategy", "individualPriceGapPercent",
                                    "comment",
                                ];

                                const orderedSalesDetailReportColumns: any[] = [salesDetailReportColumns.splice(0, 1)[0]]; // add "checkboxes" column

                                const notOrderedSalesDetailReportColumns = [...salesDetailReportColumns];

                                orderOfFields.forEach(dataIndex => {
                                    const index = notOrderedSalesDetailReportColumns.findIndex(column => column.dataIndex === dataIndex);

                                    if (index !== -1) {
                                        orderedSalesDetailReportColumns.push(notOrderedSalesDetailReportColumns.splice(index, 1)[0]);
                                    }
                                })

                                this.salesDetailReport = [...orderedSalesDetailReportColumns, ...notOrderedSalesDetailReportColumns];
                            } else {
                                const orderOfFields = [ // by dataIndexes, not include dataIndexes from correctOrderedStaticRegularDetailReportColumns
                                    'status', 'detailedStatus', 'uploadFile',
                                    'newPrice', 'newPriceHistory', 'correctedRegularPrice', 'priceExperimentSampleSize', 'priceExperimentDiscountRangeFrom', 'priceExperimentDiscountRangeTo', 'priceExperimentStep', 'priceExperimentStartDate', 'priceExperimentEndDate', 'newMarginPc', 'newPI', 'deltaDiffPrice', 'priceDiffPc', 'marginDiff',
                                    'changedPI', 'exitSegment', 'coeffElasticity', 'remains', 'salesForecast', 'revenueForecast', 'marginForecast', 'marginForecastPc', 'changeSales',
                                    'changeRevenue', 'changeMargin', 'salesDiffPc', 'revenueDiffPc', 'marginDiffPc', 'marginDiffSecond', 'salesForecastByRegularPrice',
                                    'revenueForecastByRegularPrice', 'marginForecastByRegularPrice',
                                    'marginForecastByRegularPricePc', 'changeSalesByRegularPrice', 'changeRevenueByRegularPrice', 'changeMarginByRegularPrice',
                                    'salesDiffPcByRegularPrice', 'revenueDiffPcByRegularPrice', 'marginDiffPcByRegularPrice', 'marginDiffSecondByRegularPrice', 'priceTagChangeExpense', 'taskId',
                                    'groupName', 'categoryName', 'subCategoryName', 'formatName', 'regionName', 'clusterName', 'productSegmentName', 'batchNumber', 'recipeAttribute',
                                    'treatmentAttribute', 'vitalMedicine', 'producerPrice', 'extraChargePc', 'registrationPrice', 'eventTrigger', 'eventTriggerTypes', 'purchasePriceDeviationPercent', 'kvi', 'ctm',
                                    'ctmBrand', 'ctmPriceGap', 'minRetailPrice', 'maxRetailPrice',
                                    "omnichannelStrategy", "omnichannelFixedGapType", "omnichannelGap",
                                    "omnichannelApplyCompetitorPrices", "omnichannelMinProfitabilityLimit", "omnichannelBaseChannelPrice",
                                    'keyProduct1', 'keyProduct2', 'keyProduct3', 'keyProduct4', 'keyProduct5', 'segment', 'skuLine', 'purchasePrice',
                                    'avgRegularPrice', 'avgCashPrice', 'avgCheckPrice', 'regularPrice', 'marginLastPrice',
                                    'minCompetitorPrice', 'minCompetitorName', 'minCompetitorCode', 'maxCompetitorPrice', 'maxCompetitorName', 'maxCompetitorCode', 'avgCompetitorPrice', 'lastCompetitorPrice',
                                    'pi', 'actualSales', 'actualRevenue', 'actualMargin', 'actualMarginPercent', 'comparableSales', 'comparableRevenue',
                                    'comparableMargin', 'comparableMarginPc', 'logisticCostsPercentage', 'logisticCostsAmount', 'marketingPaymentsPercentage',
                                    'limitRetailPrice', 'markupPercentage', 'vatPercentage', 'basePrice', 'individualPriceOptStrategy', 'individualPriceIncreaseLimit',
                                    'individualPeriodPriceIncreaseLimit', 'individualPeriod', 'individualMarginalProfit', 'individualKviStrategy', 'individualPercentCorrection',
                                    'individualNewProductPriceStrategy', 'individualPriceGapPercent', 'productVerticalLine', 'productVolume', 'measurementUnit',
                                    'isVerticalLineBase', 'vlStrategyStr', 'vlGapPc', 'comment',
                                ];

                                const correctOrderedStaticRegularDetailReportColumns = [
                                    {
                                        key: 'checkboxes',
                                        scopedSlots: {
                                            title: 'commonCheckbox',
                                            customRender: 'rowCheckbox',
                                        },
                                        fixed: 'left',
                                        width: 50,
                                        align: 'center',
                                    },
                                    {
                                        dataIndex: 'internalCode',
                                        slots: { title: 'internalCodeColumnTitle' }, // dataIndex + 'ColumnTitle'
                                        slotColumnTitleData: {
                                            text: this.$t('results.tableHeaders.internalCode') as string,
                                        },
                                        sorter: true,
                                        fixed: 'left',
                                        filterOptionsKey: 'internalCode',
                                        filterModel: 'internalCode',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('internalCode') },
                                        scopedSlots: {
                                            customRender: 'internalCode',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 170,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'skuName',
                                        slots: { title: 'skuNameColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('results.tableHeaders.skuName') as string,
                                        },
                                        stickyColumn: true,
                                        sorter: true,
                                        fixed: 'left',
                                        filterOptionsKey: 'skuName',
                                        filterModel: 'skuName',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('skuName') },
                                        scopedSlots: {
                                            customRender: 'skuName',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 340,
                                        // ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'priceExperiment',
                                        slots: { title: 'priceExperimentColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('salesMonitorTab.tables.detailColumns.priceExperiment') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'priceExperiment',
                                        filterModel: 'priceExperiment',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('priceExperiment') },
                                        scopedSlots: {
                                            customRender: 'priceExperiment',
                                            filterDropdown: "filterRadioButtons",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 100,
                                    },
                                    {
                                        dataIndex: 'priceExperimentSampleSize',
                                        slots: { title: 'priceExperimentSampleSizeColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('salesMonitorTab.tables.detailColumns.priceExperimentSampleSize') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'priceExperimentSampleSize',
                                        filterModel: 'priceExperimentSampleSize',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('priceExperimentSampleSize') },
                                        scopedSlots: {
                                            customRender: 'priceExperimentSampleSize',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 150,
                                    },
                                    {
                                        dataIndex: 'priceExperimentDiscountRangeFrom',
                                        slots: { title: 'priceExperimentDiscountRangeFromColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('salesMonitorTab.tables.detailColumns.priceExperimentDiscountRangeFrom') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'priceExperimentDiscountRangeFrom',
                                        filterModel: 'priceExperimentDiscountRangeFrom',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('priceExperimentDiscountRangeFrom') },
                                        scopedSlots: {
                                            customRender: 'priceExperimentDiscountRangeFrom',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 150,
                                    },
                                    {
                                        dataIndex: 'priceExperimentDiscountRangeTo',
                                        slots: { title: 'priceExperimentDiscountRangeToColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('salesMonitorTab.tables.detailColumns.priceExperimentDiscountRangeTo') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'priceExperimentDiscountRangeTo',
                                        filterModel: 'priceExperimentDiscountRangeTo',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('priceExperimentDiscountRangeTo') },
                                        scopedSlots: {
                                            customRender: 'priceExperimentDiscountRangeTo',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 150,
                                    },
                                    {
                                        dataIndex: 'priceExperimentStep',
                                        slots: { title: 'priceExperimentStepColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('salesMonitorTab.tables.detailColumns.priceExperimentStep') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'priceExperimentStep',
                                        filterModel: 'priceExperimentStep',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('priceExperimentStep') },
                                        scopedSlots: {
                                            customRender: 'priceExperimentStep',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 120,
                                    },
                                    {
                                        dataIndex: 'priceTagChangeExpense',
                                        slots: { title: 'priceTagChangeExpenseColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('salesMonitorTab.tables.detailColumns.priceTagChangeExpense') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'priceTagChangeExpense',
                                        filterModel: 'priceTagChangeExpense',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('priceTagChangeExpense') },
                                        scopedSlots: {
                                            customRender: 'priceTagChangeExpense',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 180,
                                    },
                                    {
                                        dataIndex: 'salePointCode',
                                        slots: { title: 'salePointCodeColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('results.tableHeaders.salePointCode') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'salePointCode',
                                        filterModel: 'salePointCode',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('salePointCode') },
                                        scopedSlots: {
                                            customRender: 'salePointCode',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 150,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'isApproved',
                                        title: this.$t('results.detailColumns.approval') as string,
                                        filterOptionsKey: 'isApproved',
                                        filterModel: 'isApproved',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('isApproved') },
                                        scopedSlots: {
                                            customRender: 'isApproved',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 150,
                                    },
                                    {
                                        dataIndex: 'approvedByFio',
                                        title: this.$t('results.detailColumns.approvedBy') as string,
                                        filterOptionsKey: 'approvedByFio',
                                        filterModel: 'approvedByFio',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('approvedByFio') },
                                        scopedSlots: {
                                            customRender: 'approvedByFio',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 150,
                                        ellipsis: true,
                                    },
                                ];

                                const incorrectOrderedStaticRegularDetailReportColumns = [
                                    {
                                        dataIndex: 'taskId',
                                        slots: { title: 'taskIdColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('results.tableHeaders.taskId') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'taskId',
                                        filterModel: 'taskId',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('taskId') },
                                        scopedSlots: {
                                            customRender: 'taskId',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 156,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'groupName',
                                        slots: { title: 'groupNameColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('results.tableHeaders.productGroup') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'groupName',
                                        filterModel: 'groupName',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('groupName') },
                                        scopedSlots: {
                                            customRender: 'groupName',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 200,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'categoryName',
                                        slots: { title: 'categoryNameColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('results.tableHeaders.productCategory') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'categoryName',
                                        filterModel: 'categoryName',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('categoryName') },
                                        scopedSlots: {
                                            customRender: 'categoryName',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 200,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'subCategoryName',
                                        slots: { title: 'subCategoryNameColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('results.tableHeaders.productSubcategory') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'subCategoryName',
                                        filterModel: 'subCategoryName',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('subCategoryName') },
                                        scopedSlots: {
                                            customRender: 'subCategoryName',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 200,
                                        onFilter: () => true,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'formatName',
                                        slots: { title: 'formatNameColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('results.tableHeaders.formatChannel') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'formatName',
                                        filterModel: 'formatName',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('formatName') },
                                        scopedSlots: {
                                            customRender: 'formatName',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 200,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'regionName',
                                        slots: { title: 'regionNameColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('results.tableHeaders.storeRegion') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'regionName',
                                        filterModel: 'regionName',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('regionName') },
                                        scopedSlots: {
                                            customRender: 'regionName',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 200,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'clusterName',
                                        slots: { title: 'clusterNameColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('results.tableHeaders.storeCluster') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'clusterName',
                                        filterModel: 'clusterName',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('clusterName') },
                                        scopedSlots: {
                                            customRender: 'clusterName',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 200,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'productSegmentName',
                                        slots: { title: 'productSegmentNameColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('results.tableHeaders.productSegment') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'productSegmentName',
                                        filterModel: 'productSegmentName',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('productSegmentName') },
                                        scopedSlots: {
                                            customRender: 'productSegmentName',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 200,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'batchNumber',
                                        slots: { title: 'batchNumberColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('results.tableHeaders.batchNumber') as string,
                                        },
                                        sorter: true,
                                        scopedSlots: {
                                            customRender: 'batchNumber',
                                        },
                                        width: 160,
                                        ellipsis: true,
                                    },
                                    // {
                                    //     dataIndex: 'recipeAttribute', // must fetch from Backend as for Promo
                                    //     title: this.$t('resultView.columns.prc') as string,
                                    //     sorter: true,
                                    //     scopedSlots: {
                                    //         customRender: 'recipeAttribute'
                                    //     },
                                    //     width: 80,
                                    //     filterMultiple: true,
                                    //     ellipsis: true
                                    // }
                                ];

                                const dynamicRegularDetailReportColumns: any[] = [];

                                this.detailUserFields.forEach((detailField) => {
                                    if (detailField.permanentlyHidden) {
                                        return;
                                    }

                                    const reportField = this.allDetailReportFields.find((v) => v.key === detailField.key)
                                    if (reportField == null) {
                                      this.$log.debug('notFound', detailField.key);
                                    } else {
                                        this.tableFilterOptions[detailField.key] = this.getFilters(detailField.key);

                                        const dynamicRegularDetailReportColumn: any = {
                                            dataIndex: detailField.key,
                                            slots: { title: `${detailField.key}ColumnTitle` }, // dataIndex + 'ColumnTitle'
                                            slotColumnTitleData: {
                                                text: reportField.label,
                                            },
                                            sorter: true,
                                            scopedSlots: {
                                                customRender: detailField.key,
                                            },
                                            ellipsis: true,
                                            width: this.getColumnWidth(detailField.key),
                                        }

                                        if (columnsWithFiltersArray.includes(detailField.key)) {
                                            dynamicRegularDetailReportColumn.filterOptionsKey = detailField.key;
                                            dynamicRegularDetailReportColumn.filterModel = detailField.key;
                                            dynamicRegularDetailReportColumn.showRange = columnsWithRangeInFilter.includes(detailField.key);
                                            dynamicRegularDetailReportColumn.onFilterDropdownVisibleChange = () => { this.filterDropdownVisibleChange(detailField.key) };
                                            dynamicRegularDetailReportColumn.scopedSlots = {
                                                customRender: detailField.key,
                                                filterDropdown: singleFilters.includes(detailField.key) ? "filterRadioButtons" : "filterCheckboxes",
                                                filterIcon: "filterIcon",
                                            };
                                        }

                                        dynamicRegularDetailReportColumns.push(dynamicRegularDetailReportColumn);
                                    }
                                });

                                // ordering columns
                                const orderedRegularDetailReportColumns = [...correctOrderedStaticRegularDetailReportColumns];

                                const notOrderedRegularDetailReportColumns = [...incorrectOrderedStaticRegularDetailReportColumns, ...dynamicRegularDetailReportColumns]

                                orderOfFields.forEach(dataIndex => {
                                    const index = notOrderedRegularDetailReportColumns.findIndex(column => column.dataIndex === dataIndex);

                                    if (index !== -1) {
                                        orderedRegularDetailReportColumns.push(notOrderedRegularDetailReportColumns.splice(index, 1)[0]);
                                    }
                                })

                                this.regularDetailReport = [...orderedRegularDetailReportColumns, ...notOrderedRegularDetailReportColumns];
                            }
                        }
                    },
                )
                .catch((e) => {
                    this.$log.error(e)
                    this.showError(this.$t('results.messages.errorLoadDetailFields') as string);
                });
        }

        setSelectedDetailField(columnName: string, columnValue: string, change: boolean) {
            if (change) {
                this.detailColumnsListForAddFields.push({key: columnName, label: columnValue})

                const index = this.detailColumnsListForDeleteFields.findIndex((field) => {
                    return field.key === columnName
                });
                if (index !== -1) {
                    this.detailColumnsListForDeleteFields.splice(index, 1)
                }
            } else {
                this.detailColumnsListForDeleteFields.push({key: columnName, label: ''})

                const index = this.detailColumnsListForAddFields.findIndex((field) => {
                    return field.key === columnName
                });
                if (index !== -1) {
                    this.detailColumnsListForAddFields.splice(index, 1)
                }
            }
        }

        isSelectedDetailField(fieldName: string): boolean {
            const index = this.detailUserFields.findIndex((field) => {
                return field.key === fieldName
            });
            return index !== -1;
        }

        saveDetailColumnsStatus() {
            const params: ReportDetailColumnsForAddOrDelete = {
                detailColumnsForAdd: this.detailColumnsListForAddFields,
                detailColumnsForDelete: this.detailColumnsListForDeleteFields,
            }

            this.httpChangeReportDetailColumnsStatus(this.reportType, params)
                .then((r: any) => {
                        this.detailColumnsListForAddFields = [];
                        this.detailColumnsListForDeleteFields = [];
                        this.getReportDetailFieldsByUserId();
                        this.showInfo(this.$t('results.messages.infoColumnsChanged') as string);
                    },
                )
                .catch((e: any) => {
                    this.showError(this.$t('results.messages.errorSaveDetailFields') as string + e);
                });
        }

        beforeDestroy() {
            EventBus.$off('calc', this.onTaskEventReceived)
            EventBus.$off('ftpDownloadProgress', this.onFtpDownloadProgressReceived);
        }

        onTaskEventReceived(task: TaskData) {
            if (this.taskData != null && this.taskData.id === task.id) {
                this.taskData.status = task.status;
                this.taskData.taskNote = task.taskNote;
                
                this.checkAndShowPartialRejectionNote();
                
                if (this.taskData.status === 'WriteToFileComplete' || 
                    this.taskData.status === 'OnApproval' || 
                    this.taskData.status === 'Rejected' || 
                    this.taskData.status === 'Approved') {
                    this.changesPrices = [];
                    this.hasUnsavedRegularPrices = false;
                    this.hasUnsavedPromoPrices = false;
                    this.refreshHeaderTable();
                    this.refreshDetailTable();
                    this.hideActiveStatusMessage();
                } else if (this.taskData.status === 'PartiallyApproved' || 
                           this.taskData.status === 'PartiallyRejected') {
                    this.refreshHeaderTable();
                    this.refreshDetailTable();
                    this.hideActiveStatusMessage();
                }
            }
        }

        @Watch('taskData')
        onTaskDataChanged(taskData: TaskAndFile | null, oldValue: TaskAndFile | null) {
            this.calcTaskData(taskData, oldValue);

            this.fetchCommonFilterOptions();
            
            // Check if we need to show partial rejection note
            this.checkAndShowPartialRejectionNote();
        }

        @Watch('showSortingModal')
        onShowSortingModalChange(newVal: boolean) {
            if (newVal) {
                this.sortedColumns = [...this.columnsForManageModal];
            }
        }

        handleApplyClick() {
            const columnsOrder = [...this.sortedColumns.map(column => column.dataIndex)];

            if (this.tableColumnsOrder.toString() !== columnsOrder.toString()) {
                this.tableColumnsOrder = columnsOrder;

                const columnsOrderVariable = (() => {
                    switch (this.reportType) {
                        case 'promo':
                            return 'skuDetailPromoColumnsOrder';
                        case 'sales':
                            return 'skuDetailSalesColumnsOrder';
                        default:
                            return 'skuDetailRegularColumnsOrder';
                    }
                })();

                localStorage.setItem(columnsOrderVariable, this.tableColumnsOrder.toString());
            }

            if (this.detailColumnsListForAddFields.length !== 0 || this.detailColumnsListForDeleteFields.length !== 0) {
                this.saveDetailColumnsStatus();
            } else {
                this.showInfo(this.$t('results.messages.infoColumnsOrderChanged') as string);
            }

            this.showSortingModal = false;
        }

        handleCancel() {
            this.showSortingModal = false;
        }

        isHidePossibility(dataIndex: string) {
            return !['internalCode', 'skuName', 'isApproved', 'approvedByFio', 'taskId',
                'groupName', 'categoryName', 'subCategoryName', 'formatName', 'regionName',
                'clusterName', 'productSegmentName', 'batchNumber'].includes(dataIndex);
        }

        isAllowDrag(dataIndex: string) {
            return !['internalCode', 'skuName'].includes(dataIndex);
        }

        calcTaskData(taskData: TaskAndFile | null, oldValue: TaskAndFile | null) {
            this.fetchAllGeneralSubTasksTableHeaders(true, (items) => {})
            this.fetchAllGeneralSubTasksTableHeadersSize(true, (items) => {})

            if (taskData == null) {
                this.clearCalcAllData();
                this.clearPromoAllData();
            } else {
                if (taskData.status !== 'WriteToFileComplete' && 
                    taskData.status !== 'OnApproval' && 
                    taskData.status !== 'Rejected' && 
                    taskData.status !== 'Approved' &&
                    taskData.status !== 'SentToFinalApproval' &&
                    taskData.status !== 'PartiallyApproved' && 
                    taskData.status !== 'PartiallyRejected') {
                    this.showActiveStatusMessage();
                    return;
                }
                if (oldValue == null || taskData.id !== oldValue.id) {
                    if ([TaskType.PROMO, TaskType.PACKAGE_PROMO, TaskType.PACKAGE_GENERAL_PROMO, TaskType.PACKAGE_PROMOTION, TaskType.PACKAGE_GENERAL_PROMOTION].includes(taskData.type)) {
                        this.reportType = 'promo';
                    } else if (taskData.type === TaskType.SALES || taskData.type === TaskType.PACKAGE_SALES || taskData.type === TaskType.PACKAGE_GENERAL_SALES || taskData.type === TaskType.PACKAGE_GENERAL_AGGREGATE_SALES) {
                        this.reportType = 'sales';
                    } else if (taskData.type === TaskType.REGULAR_PRICE_EXP || taskData.type === TaskType.SCHEDULED_PRICE_EXP) {
                        this.reportType = 'price-exp';
                    } else {
                        this.reportType = 'regular';
                    }

                    this.isPackageOrScheduleReport = taskData.type === TaskType.PACKAGE_REGULAR || taskData.type === TaskType.PACKAGE_SCHEDULE || taskData.type === TaskType.PACKAGE_SCENARIO || taskData.type === TaskType.PACKAGE_EVENTS || taskData.type === TaskType.SCHEDULED_PRICE_EXP;
                    this.isPackagePromoReport = taskData.type === TaskType.PACKAGE_PROMO;

                    if (this.reportType === 'promo') {
                        this.detailTableIdName = 'resultDetailPromoReport';
                    } else if (this.reportType === 'sales') {
                        this.detailTableIdName = 'resultDetailSalesReport';
                    }

                    this.reportType === 'promo' || this.reportType === 'sales' ? this.clearPromoAllData() : this.clearCalcAllData();

                    if (taskData.type === TaskType.PACKAGE_GENERAL || taskData.type === TaskType.PACKAGE_GENERAL_SCENARIO || taskData.type === TaskType.PACKAGE_EVENTS_GENERAL || taskData.type === TaskType.PACKAGE_GENERAL_KVI_CARTS) {
                        this.isGeneralRegularPackage = true
                        this.showGeneralComparableBlock = false
                    }

                    this.loadHeaders();
                    this.loadDetails();
                    this.getReportDetailFieldsByUserId();
                    this.tryFindParams(taskData.id);
                }
            }
        }

        tryFindParams(taskId: number) {
            if (this.isPackageOrScheduleReport || this.isPackagePromoReport) {
                this.loadPackageCommonParams(taskId);
                if (this.isPackagePromoReport) {
                    this.loadPackagePromoParams(taskId);
                }
            }
        }

        loadPackageCommonParams(taskId: number) {
            this.httpFindPackageBaseParams(taskId)
                .then((r) => {
                    this.applyPackageParamsInDetailReportCalcFilters(this.$packageParamsInDetailReport, r.data);
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('results.messages.errorLoadPackageParams') as string);
                    this.$log.error('Error occurred [load package base filters]', e);
                });
        }

        loadPackagePromoParams(taskId: number) {
            this.httpFindPackagePromoParams(taskId)
                .then((r) => {
                        this.applyPackageParamsInDetailReportPromoFilters(this.$packageParamsInDetailReport, r.data);
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('results.messages.errorLoadPackagePromoParams') as string);
                    this.$log.error('Error occurred [load package promo filters]', e);
                });
        }

        showDeleteButton(item: ResultTableHeaders): boolean {
          return item.status != TaskStatus.APPROVED
        }

        showRecalculateButton(): boolean {
          return !this.isTaskStatusApproved()
        }

        showActiveStatusMessage() {
            (this.$refs['statusModal'] as BModal).show();
        }

        hideActiveStatusMessage() {
            (this.$refs['statusModal'] as BModal).hide();
        }

        showVetMedicineColumns(row: ResultTableDetailReports): boolean {
            return !row.vetProductWithoutExtraChargePc && !row.vetProductWithoutProducerAndRegistrationPrice;
        }

        setCorrectedRegularPrice(row: ResultTableDetailReports, priceInput: string | number | null) {
            let price: number | null
            if (priceInput == null) {
                price = null
            } else if (typeof priceInput === 'number') {
                price = priceInput
            } else {
                const value = priceInput.replace(/^(-)|[^0-9.,]+/g, '$1').replace(',', '.');
                price = parseFloat(value)
            }
            const index = this.changesPrices.findIndex((item) => {
                return item.taskId === row.taskId
            });
            if (row.correctedRegularPrice == null) {
                if (price == null || isNaN(price)) {
                    if (index !== -1) {
                        this.changesPrices.splice(index, 1);
                    }
                } else {
                    if (index === -1) {
                        const chPrice = new ChangesPrices();
                        chPrice.taskId = row.taskId
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = price
                        chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                        this.changesPrices.push(chPrice)
                    } else {
                        const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                            return item.internalCode === row.internalCode
                        });
                        if (innerIndex !== -1) {
                            this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = price
                        } else {
                            const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                            internalCodesWithCorrPrices.internalCode = row.internalCode
                            internalCodesWithCorrPrices.correctedPrice = price
                            this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                        }
                    }
                }
            } else {
                if (price == null || isNaN(price)) {
                    if (index === -1) {
                        const chPrice = new ChangesPrices();
                        chPrice.taskId = row.taskId
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = null
                        chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                        this.changesPrices.push(chPrice)
                    } else {
                        const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                            return item.internalCode === row.internalCode
                        });
                        if (innerIndex !== -1) {
                            this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = null
                        } else {
                            const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                            internalCodesWithCorrPrices.internalCode = row.internalCode
                            internalCodesWithCorrPrices.correctedPrice = null
                            this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                        }
                    }
                } else {
                    if (index === -1) {
                        const chPrice = new ChangesPrices();
                        chPrice.taskId = row.taskId
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = price
                        chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                        this.changesPrices.push(chPrice)
                    } else {
                        const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                            return item.internalCode === row.internalCode
                        });
                        if (innerIndex !== -1) {
                            this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = price
                        } else {
                            const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                            internalCodesWithCorrPrices.internalCode = row.internalCode
                            internalCodesWithCorrPrices.correctedPrice = price
                            this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                        }
                    }
                }
            }
            this.hasUnsavedRegularPrices = this.changesPrices.length !== 0;
        }

        setCorrectedPromoPrice(row: ResultTableDetailReports, priceInput: string | number | null) {
            let price: number | null
            if (priceInput == null) {
                price = null
            } else if (typeof priceInput === 'number') {
                price = priceInput
                if (price >= row.newPrice || isNaN(price)) {
                    price = null
                    row.correctedPromoPrice = null
                }
            } else {
                const value = priceInput.replace(/^(-)|[^0-9.,]+/g, '$1').replace(',', '.');
                price = parseFloat(value)
                if (price >= row.newPrice || isNaN(price)) {
                    price = null
                    row.correctedPromoPrice = null
                }
            }
            const index = this.changesPrices.findIndex((item) => {
                return item.taskId === row.taskId
            });
            if (row.correctedPromoPrice == null) {
                // tslint:disable-next-line: no-non-null-assertion
                if (isNaN(price!!)) {
                    if (index !== -1) {
                        this.changesPrices.splice(index, 1);
                    }
                } else {
                    if (index === -1) {
                        const chPrice = new ChangesPrices();
                        chPrice.taskId = row.taskId
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = price
                        chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                        this.changesPrices.push(chPrice)
                    } else {
                        const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                            return item.internalCode === row.internalCode
                        });
                        if (innerIndex !== -1) {
                            this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = price
                        } else {
                            const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                            internalCodesWithCorrPrices.internalCode = row.internalCode
                            internalCodesWithCorrPrices.correctedPrice = price
                            this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                        }
                    }
                }
            } else {
                if (price == null || isNaN(price)) {
                    if (index === -1) {
                        const chPrice = new ChangesPrices();
                        chPrice.taskId = row.taskId
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = null
                        chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                        this.changesPrices.push(chPrice)
                    } else {
                        const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                            return item.internalCode === row.internalCode
                        });
                        if (innerIndex !== -1) {
                            this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = null
                        } else {
                            const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                            internalCodesWithCorrPrices.internalCode = row.internalCode
                            internalCodesWithCorrPrices.correctedPrice = null
                            this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                        }
                    }
                } else {
                    if (index === -1) {
                        const chPrice = new ChangesPrices();
                        chPrice.taskId = row.taskId
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = price
                        chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                        this.changesPrices.push(chPrice)
                    } else {
                        const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                            return item.internalCode === row.internalCode
                        });
                        if (innerIndex !== -1) {
                            this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = price
                        } else {
                            const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                            internalCodesWithCorrPrices.internalCode = row.internalCode
                            internalCodesWithCorrPrices.correctedPrice = price
                            this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                        }
                    }
                }
            }
            // tslint:disable-next-line: no-non-null-assertion
            this.hasUnsavedPromoPrices = this.changesPrices.length !== 0;
        }

        getCorrectedRegularPrice(row: ResultTableDetailReports): number | null {
            const changePriceRow = this.changesPrices.find((value, index) => value.taskId === row.taskId);
            if (changePriceRow !== undefined) {
                const innerIndex = changePriceRow.codeWithPrices.findIndex((item) => {
                    return item.internalCode === row.internalCode
                });
                if (innerIndex !== -1) {
                    return changePriceRow.codeWithPrices[innerIndex].correctedPrice;
                }
            }
            if (row.correctedRegularPrice == null) {
                return null
            } else {
                return parseFloat(String(row.correctedRegularPrice).replace(/^(-)|[^0-9.,]+/g, '$1').replace(',', '.'));
            }
        }

        getPriceExperimentForSku(row: ResultTableDetailReports): boolean | null {
            // Пытаемся получить из данных строки (если приходит с бэкенда)
            if ((row as any).priceExperiment !== undefined) {
                return (row as any).priceExperiment;
            }
            // Пытаемся получить из индивидуальных параметров, если доступны
            if (this.$calc && this.$calc.individualCommonParams && this.$calc.individualCommonParams[row.internalCode]) {
                const individualConfig = this.$calc.individualCommonParams[row.internalCode];
                if (individualConfig.priceExperiment !== undefined) {
                    return individualConfig.priceExperiment;
                }
            }
            return null;
        }

        getPriceExperimentSampleSizeForSku(row: ResultTableDetailReports): number | null {
            const rowAny = row as any;
            // Пытаемся получить из данных строки (если приходит с бэкенда)
            if (rowAny.priceExperimentSampleSize != null) {
                console.log('priceExperimentSampleSize из row:', rowAny.priceExperimentSampleSize, 'для SKU:', row.internalCode);
                return rowAny.priceExperimentSampleSize;
            }
            // Пытаемся получить из индивидуальных параметров, если доступны
            if (this.$calc && this.$calc.individualCommonParams && this.$calc.individualCommonParams[row.internalCode]) {
                const individualConfig = this.$calc.individualCommonParams[row.internalCode];
                const configAny = individualConfig as any;
                if (configAny.priceExperimentSampleSize != null) {
                    console.log('priceExperimentSampleSize из individualParams:', configAny.priceExperimentSampleSize, 'для SKU:', row.internalCode);
                    return configAny.priceExperimentSampleSize;
                }
            }
            console.log('priceExperimentSampleSize не найдено для SKU:', row.internalCode, 'rowAny:', rowAny);
            return null;
        }

        getPriceExperimentDiscountRangeFromForSku(row: ResultTableDetailReports): number | null {
            const rowAny = row as any;
            // Пытаемся получить из данных строки (если приходит с бэкенда)
            if (rowAny.priceExperimentDiscountRangeFrom != null) {
                console.log('priceExperimentDiscountRangeFrom из row:', rowAny.priceExperimentDiscountRangeFrom, 'для SKU:', row.internalCode);
                return rowAny.priceExperimentDiscountRangeFrom;
            }
            // Пытаемся получить из индивидуальных параметров, если доступны
            if (this.$calc && this.$calc.individualCommonParams && this.$calc.individualCommonParams[row.internalCode]) {
                const individualConfig = this.$calc.individualCommonParams[row.internalCode];
                const configAny = individualConfig as any;
                if (configAny.priceExperimentDiscountRangeFrom != null) {
                    console.log('priceExperimentDiscountRangeFrom из individualParams:', configAny.priceExperimentDiscountRangeFrom, 'для SKU:', row.internalCode);
                    return configAny.priceExperimentDiscountRangeFrom;
                }
            }
            console.log('priceExperimentDiscountRangeFrom не найдено для SKU:', row.internalCode);
            return null;
        }

        getPriceExperimentDiscountRangeToForSku(row: ResultTableDetailReports): number | null {
            const rowAny = row as any;
            // Пытаемся получить из данных строки (если приходит с бэкенда)
            if (rowAny.priceExperimentDiscountRangeTo != null) {
                console.log('priceExperimentDiscountRangeTo из row:', rowAny.priceExperimentDiscountRangeTo, 'для SKU:', row.internalCode);
                return rowAny.priceExperimentDiscountRangeTo;
            }
            // Пытаемся получить из индивидуальных параметров, если доступны
            if (this.$calc && this.$calc.individualCommonParams && this.$calc.individualCommonParams[row.internalCode]) {
                const individualConfig = this.$calc.individualCommonParams[row.internalCode];
                const configAny = individualConfig as any;
                if (configAny.priceExperimentDiscountRangeTo != null) {
                    console.log('priceExperimentDiscountRangeTo из individualParams:', configAny.priceExperimentDiscountRangeTo, 'для SKU:', row.internalCode);
                    return configAny.priceExperimentDiscountRangeTo;
                }
            }
            console.log('priceExperimentDiscountRangeTo не найдено для SKU:', row.internalCode);
            return null;
        }

        getPriceExperimentStepForSku(row: ResultTableDetailReports): number | null {
            const rowAny = row as any;
            // Пытаемся получить из данных строки (если приходит с бэкенда)
            if (rowAny.priceExperimentStep != null) {
                return rowAny.priceExperimentStep;
            }
            // Пытаемся получить из индивидуальных параметров, если доступны
            if (this.$calc && this.$calc.individualCommonParams && this.$calc.individualCommonParams[row.internalCode]) {
                const individualConfig = this.$calc.individualCommonParams[row.internalCode];
                const configAny = individualConfig as any;
                if (configAny.priceExperimentStep != null) {
                    return configAny.priceExperimentStep;
                }
            }
            // Используем общий параметр из packageParams, если доступен
            const packageParamsInDetailReport: any = this.$packageParamsInDetailReport as any;
            if (packageParamsInDetailReport && packageParamsInDetailReport.priceExperimentStep != null) {
                return packageParamsInDetailReport.priceExperimentStep;
            }
            return null;
        }

        formatDate(date: string | null): string {
            if (!date) {
                return '';
            }
            try {
                const moment = (window as any).moment;
                if (moment) {
                    return moment(date).format('DD.MM.YYYY');
                }
                // Fallback если moment недоступен
                const dateObj = new Date(date);
                return dateObj.toLocaleDateString('ru-RU');
            } catch (e) {
                return date;
            }
        }

        getCorrectedPromoPrice(row: ResultTableDetailReports): number | null {
            const changePriceRow = this.changesPrices.find((value, index) => value.taskId === row.taskId);
            if (changePriceRow !== undefined) {
                const innerIndex = changePriceRow.codeWithPrices.findIndex((item) => {
                    return item.internalCode === row.internalCode
                });
                if (innerIndex !== -1) {
                    return changePriceRow.codeWithPrices[innerIndex].correctedPrice;
                }
            }
            if (row.correctedPromoPrice == null) {
                return null
            } else {
                return parseFloat(String(row.correctedPromoPrice).replace(/^(-)|[^0-9.,]+/g, '$1').replace(',', '.'));
            }
        }

        clearDetailTableFilters() {
            this.resetTableSortingField();
            this.resetAllFiltersFields()
            this.sortingField = null;
            this.refreshDetailTable()
        }

        updateTaskIdsForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectTaskIdForDetailTable = [];
                    } else {
                        this.selectTaskIdForDetailTable = list;
                    }
                } else {
                    this.selectTaskIdForDetailTable = list;
                }
            }
        }

        updateGroupNamesForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectGroupNameForDetailTable = [];
                    } else {
                        this.selectGroupNameForDetailTable = list;
                    }
                } else {
                    this.selectGroupNameForDetailTable = list;
                }
            }
        }

        updateCategoryNamesForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectCategoryNameForDetailTable = [];
                    } else {
                        this.selectCategoryNameForDetailTable = list;
                    }
                } else {
                    this.selectCategoryNameForDetailTable = list;
                }
            }
        }

        updateSubCategoryNamesForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectSubcategoryNamesForDetailTable = [];
                    } else {
                        this.selectSubcategoryNamesForDetailTable = list;
                    }
                } else {
                    this.selectSubcategoryNamesForDetailTable = list;
                }
            }
        }

        updateFormatNamesForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectFormatNameForDetailTable = [];
                    } else {
                        this.selectFormatNameForDetailTable = list;
                    }
                } else {
                    this.selectFormatNameForDetailTable = list;
                }
            }
        }

        updateRegionNamesForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectRegionNameForDetailTable = [];
                    } else {
                        this.selectRegionNameForDetailTable = list;
                    }
                } else {
                    this.selectRegionNameForDetailTable = list;
                }
            }
        }

        updateClusterNamesForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectClusterNameForDetailTable = [];
                    } else {
                        this.selectClusterNameForDetailTable = list;
                    }
                } else {
                    this.selectClusterNameForDetailTable = list;
                }
            }
        }

        updateSegmentNamesForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectSegmentNameForDetailTable = [];
                    } else {
                        this.selectSegmentNameForDetailTable = list;
                    }
                } else {
                    this.selectSegmentNameForDetailTable = list;
                }
            }
        }

        updateInternalCodeForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectInternalCodeForDetailTable = [];
                    } else {
                        this.selectInternalCodeForDetailTable = list;
                    }
                } else {
                    this.selectInternalCodeForDetailTable = list;
                }
            }
        }

        updateBatchNumberForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectBatchNumberForDetailTable = [];
                    } else {
                        this.selectBatchNumberForDetailTable = list;
                    }
                } else {
                    this.selectBatchNumberForDetailTable = list;
                }
            }
        }

        updateSkuNameForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectSkuNameForDetailTable = [];
                    } else {
                        this.selectSkuNameForDetailTable = list;
                    }
                } else {
                    this.selectSkuNameForDetailTable = list;
                }
            }

            // Сбрасываем пагинацию на первую страницу при изменении фильтра
            this.pagination.current = 1;
        }

        updateCtmBrandForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectCtmBrandForDetailTable = [];
                    } else {
                        this.selectCtmBrandForDetailTable = list;
                    }
                } else {
                    this.selectCtmBrandForDetailTable = list;
                }
            }
        }

        updateCtmPriceGapForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectCtmPriceGapForDetailTable = [];
                    } else {
                        this.selectCtmPriceGapForDetailTable = list;
                    }
                } else {
                    this.selectCtmPriceGapForDetailTable = list;
                }
            }
        }

        updateMinRetailPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMinRetailPriceForDetailTable = [];
                    } else {
                        this.selectMinRetailPriceForDetailTable = list;
                    }
                } else {
                    this.selectMinRetailPriceForDetailTable = list;
                }
            }
        }

        updateMaxRetailPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMaxRetailPriceForDetailTable = [];
                    } else {
                        this.selectMaxRetailPriceForDetailTable = list;
                    }
                } else {
                    this.selectMaxRetailPriceForDetailTable = list;
                }
            }
        }

        updateKeyProduct1ForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectKeyProduct1ForDetailTable = [];
                    } else {
                        this.selectKeyProduct1ForDetailTable = list;
                    }
                } else {
                    this.selectKeyProduct1ForDetailTable = list;
                }
            }
        }

        updateKeyProduct2ForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectKeyProduct2ForDetailTable = [];
                    } else {
                        this.selectKeyProduct2ForDetailTable = list;
                    }
                } else {
                    this.selectKeyProduct2ForDetailTable = list;
                }
            }
        }

        updateRecipeAttributeForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectRecipeAttributeForDetailTable = [];
                    } else {
                        this.selectRecipeAttributeForDetailTable = list;
                    }
                } else {
                    this.selectRecipeAttributeForDetailTable = list;
                }
            }
        }

        updateTreatmentAttributeForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectTreatmentAttributeForDetailTable = [];
                    } else {
                        this.selectTreatmentAttributeForDetailTable = list;
                    }
                } else {
                    this.selectTreatmentAttributeForDetailTable = list;
                }
            }
        }

        updateProducerPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectProducerPriceForDetailTable = [];
                    } else {
                        this.selectProducerPriceForDetailTable = list;
                    }
                } else {
                    this.selectProducerPriceForDetailTable = list;
                }
            }
        }

        updateExtraChargePcForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectExtraChargePcForDetailTable = [];
                    } else {
                        this.selectExtraChargePcForDetailTable = list;
                    }
                } else {
                    this.selectExtraChargePcForDetailTable = list;
                }
            }
        }

        updateRegistrationPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectRegistrationPriceForDetailTable = [];
                    } else {
                        this.selectRegistrationPriceForDetailTable = list;
                    }
                } else {
                    this.selectRegistrationPriceForDetailTable = list;
                }
            }
        }

        updatePriceSegmentsForDetailTable(list: ReportDetailSegments[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item.name === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item.name === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectSegmentPriceForDetailTable = [];
                    } else {
                        this.selectSegmentPriceForDetailTable = list;
                    }
                } else {
                    this.selectSegmentPriceForDetailTable = list;
                }
            }
        }

        updateSkuLineForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectSkuLineForDetailTable = [];
                    } else {
                        this.selectSkuLineForDetailTable = list;
                    }
                } else {
                    this.selectSkuLineForDetailTable = list;
                }
            }

            // Сбрасываем пагинацию на первую страницу при изменении фильтра
            this.pagination.current = 1;
        }

        updatePurchasePriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectPurchasePriceForDetailTable = [];
                    } else {
                        this.selectPurchasePriceForDetailTable = list;
                    }
                } else {
                    this.selectPurchasePriceForDetailTable = list;
                }
            }
        }
        updatePromoPurchasePriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectPromoPurchasePriceForDetailTable = [];
                    } else {
                        this.selectPromoPurchasePriceForDetailTable = list;
                    }
                } else {
                    this.selectPromoPurchasePriceForDetailTable = list;
                }
            }
        }

        updateAvgRegularPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectAvgRegularPriceForDetailTable = [];
                    } else {
                        this.selectAvgRegularPriceForDetailTable = list;
                    }
                } else {
                    this.selectAvgRegularPriceForDetailTable = list;
                }
            }
        }

        updateAvgCashPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectAvgCashPriceForDetailTable = [];
                    } else {
                        this.selectAvgCashPriceForDetailTable = list;
                    }
                } else {
                    this.selectAvgCashPriceForDetailTable = list;
                }
            }
        }

        updateAvgCheckPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectAvgCheckPriceForDetailTable = [];
                    } else {
                        this.selectAvgCheckPriceForDetailTable = list;
                    }
                } else {
                    this.selectAvgCheckPriceForDetailTable = list;
                }
            }
        }

        updateRegularPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectRegularPriceForDetailTable = [];
                    } else {
                        this.selectRegularPriceForDetailTable = list;
                    }
                } else {
                    this.selectRegularPriceForDetailTable = list;
                }
            }
        }

        updateMarginLastPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMarginLastPriceForDetailTable = [];
                    } else {
                        this.selectMarginLastPriceForDetailTable = list;
                    }
                } else {
                    this.selectMarginLastPriceForDetailTable = list;
                }
            }
        }

        updateMinCompetitorPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMinCompetitorPriceForDetailTable = [];
                    } else {
                        this.selectMinCompetitorPriceForDetailTable = list;
                    }
                } else {
                    this.selectMinCompetitorPriceForDetailTable = list;
                }
            }
        }

        updateMinCompetitorNameForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectMinCompetitorNameForDetailTable = [];
                    } else {
                        this.selectMinCompetitorNameForDetailTable = list;
                    }
                } else {
                    this.selectMinCompetitorNameForDetailTable = list;
                }
            }
        }

        updateMinCompetitorCodeForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectMinCompetitorCodeForDetailTable = [];
                    } else {
                        this.selectMinCompetitorCodeForDetailTable = list;
                    }
                } else {
                    this.selectMinCompetitorCodeForDetailTable = list;
                }
            }
        }

        updateMaxCompetitorPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMaxCompetitorPriceForDetailTable = [];
                    } else {
                        this.selectMaxCompetitorPriceForDetailTable = list;
                    }
                } else {
                    this.selectMaxCompetitorPriceForDetailTable = list;
                }
            }
        }

        updateMaxCompetitorNameForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectMaxCompetitorNameForDetailTable = [];
                    } else {
                        this.selectMaxCompetitorNameForDetailTable = list;
                    }
                } else {
                    this.selectMaxCompetitorNameForDetailTable = list;
                }
            }
        }

        updateMaxCompetitorCodeForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectMaxCompetitorCodeForDetailTable = [];
                    } else {
                        this.selectMaxCompetitorCodeForDetailTable = list;
                    }
                } else {
                    this.selectMaxCompetitorCodeForDetailTable = list;
                }
            }
        }

        updateAvgCompetitorPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectAvgCompetitorPriceForDetailTable = [];
                    } else {
                        this.selectAvgCompetitorPriceForDetailTable = list;
                    }
                } else {
                    this.selectAvgCompetitorPriceForDetailTable = list;
                }
            }
        }

        updateLastCompetitorPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectLastCompetitorPriceForDetailTable = [];
                    } else {
                        this.selectLastCompetitorPriceForDetailTable = list;
                    }
                } else {
                    this.selectLastCompetitorPriceForDetailTable = list;
                }
            }
        }
        updateMinPromoCompetitorPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMinPromoCompetitorPriceForDetailTable = [];
                    } else {
                        this.selectMinPromoCompetitorPriceForDetailTable = list;
                    }
                } else {
                    this.selectMinPromoCompetitorPriceForDetailTable = list;
                }
            }
        }
        updateMinPromoCompetitorNameForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectMinPromoCompetitorNameForDetailTable = [];
                    } else {
                        this.selectMinPromoCompetitorNameForDetailTable = list;
                    }
                } else {
                    this.selectMinPromoCompetitorNameForDetailTable = list;
                }
            }
        }

        updateMinPromoCompetitorCodeForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectMinPromoCompetitorCodeForDetailTable = [];
                    } else {
                        this.selectMinPromoCompetitorCodeForDetailTable = list;
                    }
                } else {
                    this.selectMinPromoCompetitorCodeForDetailTable = list;
                }
            }
        }
        updateMaxPromoCompetitorPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMaxPromoCompetitorPriceForDetailTable = [];
                    } else {
                        this.selectMaxPromoCompetitorPriceForDetailTable = list;
                    }
                } else {
                    this.selectMaxPromoCompetitorPriceForDetailTable = list;
                }
            }
        }
        updateMaxPromoCompetitorNameForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectMaxPromoCompetitorNameForDetailTable = [];
                    } else {
                        this.selectMaxPromoCompetitorNameForDetailTable = list;
                    }
                } else {
                    this.selectMaxPromoCompetitorNameForDetailTable = list;
                }
            }
        }

        updateMaxPromoCompetitorCodeForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectMaxPromoCompetitorCodeForDetailTable = [];
                    } else {
                        this.selectMaxPromoCompetitorCodeForDetailTable = list;
                    }
                } else {
                    this.selectMaxPromoCompetitorCodeForDetailTable = list;
                }
            }
        }
        updateMedianPromoCompetitorPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMedianPromoCompetitorPriceForDetailTable = [];
                    } else {
                        this.selectMedianPromoCompetitorPriceForDetailTable = list;
                    }
                } else {
                    this.selectMedianPromoCompetitorPriceForDetailTable = list;
                }
            }
        }
        updateLastPromoCompetitorPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectLastPromoCompetitorPriceForDetailTable = [];
                    } else {
                        this.selectLastPromoCompetitorPriceForDetailTable = list;
                    }
                } else {
                    this.selectLastPromoCompetitorPriceForDetailTable = list;
                }
            }
        }
        updatePiForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectPiForDetailTable = [];
                    } else {
                        this.selectPiForDetailTable = list;
                    }
                } else {
                    this.selectPiForDetailTable = list;
                }
            }
        }
        updateActualSalesForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectActualSalesForDetailTable = [];
                    } else {
                        this.selectActualSalesForDetailTable = list;
                    }
                } else {
                    this.selectActualSalesForDetailTable = list;
                }
            }
        }
        updateActualRevenueForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectActualRevenueForDetailTable = [];
                    } else {
                        this.selectActualRevenueForDetailTable = list;
                    }
                } else {
                    this.selectActualRevenueForDetailTable = list;
                }
            }
        }
        updateActualMarginForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectActualMarginForDetailTable = [];
                    } else {
                        this.selectActualMarginForDetailTable = list;
                    }
                } else {
                    this.selectActualMarginForDetailTable = list;
                }
            }
        }
        updateActualMarginPercentForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectActualMarginPercentForDetailTable = [];
                    } else {
                        this.selectActualMarginPercentForDetailTable = list;
                    }
                } else {
                    this.selectActualMarginPercentForDetailTable = list;
                }
            }
        }
        updateComparableSalesForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectComparableSalesForDetailTable = [];
                    } else {
                        this.selectComparableSalesForDetailTable = list;
                    }
                } else {
                    this.selectComparableSalesForDetailTable = list;
                }
            }
        }
        updateComparableRevenueForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectComparableRevenueForDetailTable = [];
                    } else {
                        this.selectComparableRevenueForDetailTable = list;
                    }
                } else {
                    this.selectComparableRevenueForDetailTable = list;
                }
            }
        }
        updateComparableMarginForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectComparableMarginForDetailTable = [];
                    } else {
                        this.selectComparableMarginForDetailTable = list;
                    }
                } else {
                    this.selectComparableMarginForDetailTable = list;
                }
            }
        }
        updateComparableMarginPcForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectComparableMarginPcForDetailTable = [];
                    } else {
                        this.selectComparableMarginPcForDetailTable = list;
                    }
                } else {
                    this.selectComparableMarginPcForDetailTable = list;
                }
            }
        }
        updateNewPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectNewPriceForDetailTable = [];
                    } else {
                        this.selectNewPriceForDetailTable = list;
                    }
                } else {
                    this.selectNewPriceForDetailTable = list;
                }
            }
        }
        updateNewPromoPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectNewPromoPriceForDetailTable = [];
                    } else {
                        this.selectNewPromoPriceForDetailTable = list;
                    }
                } else {
                    this.selectNewPromoPriceForDetailTable = list;
                }
            }
        }
        updateCorrectedRegularPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectCorrectedRegularPriceForDetailTable = [];
                    } else {
                        this.selectCorrectedRegularPriceForDetailTable = list;
                    }
                } else {
                    this.selectCorrectedRegularPriceForDetailTable = list;
                }
            }
        }
        updateCorrectedPromoPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectCorrectedPromoPriceForDetailTable = [];
                    } else {
                        this.selectCorrectedPromoPriceForDetailTable = list;
                    }
                } else {
                    this.selectCorrectedPromoPriceForDetailTable = list;
                }
            }
        }
        updateNewMarginPcForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectNewMarginPcForDetailTable = [];
                    } else {
                        this.selectNewMarginPcForDetailTable = list;
                    }
                } else {
                    this.selectNewMarginPcForDetailTable = list;
                }
            }
        }
        updateNewPIForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectNewPIForDetailTable = [];
                    } else {
                        this.selectNewPIForDetailTable = list;
                    }
                } else {
                    this.selectNewPIForDetailTable = list;
                }
            }
        }
        updateDeltaDiffPriceForDetailTable(list: Array<number | string>) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectDeltaDiffPriceForDetailTable = [];
                    } else {
                        this.selectDeltaDiffPriceForDetailTable = list;
                    }
                } else {
                    this.selectDeltaDiffPriceForDetailTable = list;
                }
            }
        }
        updatePriceDiffPcForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectPriceDiffPcForDetailTable = [];
                    } else {
                        this.selectPriceDiffPcForDetailTable = list;
                    }
                } else {
                    this.selectPriceDiffPcForDetailTable = list;
                }
            }
        }
        updateMarginDiffForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMarginDiffForDetailTable = [];
                    } else {
                        this.selectMarginDiffForDetailTable = list;
                    }
                } else {
                    this.selectMarginDiffForDetailTable = list;
                }
            }
        }
        updateChangedPIForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectChangedPIForDetailTable = [];
                    } else {
                        this.selectChangedPIForDetailTable = list;
                    }
                } else {
                    this.selectChangedPIForDetailTable = list;
                }
            }
        }
        updateDiscountDepthForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectDiscountDepthForDetailTable = [];
                    } else {
                        this.selectDiscountDepthForDetailTable = list;
                    }
                } else {
                    this.selectDiscountDepthForDetailTable = list;
                }
            }
        }
        updateDiscountDurationForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectDiscountDurationForDetailTable = [];
                    } else {
                        this.selectDiscountDurationForDetailTable = list;
                    }
                } else {
                    this.selectDiscountDurationForDetailTable = list;
                }
            }
        }
        updateExitSegmentForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectExitSegmentForDetailTable = [];
                    } else {
                        this.selectExitSegmentForDetailTable = list;
                    }
                } else {
                    this.selectExitSegmentForDetailTable = list;
                }
            }
        }
        updateCoeffElasticityForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectCoeffElasticityForDetailTable = [];
                    } else {
                        this.selectCoeffElasticityForDetailTable = list;
                    }
                } else {
                    this.selectCoeffElasticityForDetailTable = list;
                }
            }
        }
        updatePromoCoeffElasticityForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectPromoCoeffElasticityForDetailTable = [];
                    } else {
                        this.selectPromoCoeffElasticityForDetailTable = list;
                    }
                } else {
                    this.selectPromoCoeffElasticityForDetailTable = list;
                }
            }
        }
        updateSalesForecastForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectSalesForecastForDetailTable = [];
                    } else {
                        this.selectSalesForecastForDetailTable = list;
                    }
                } else {
                    this.selectSalesForecastForDetailTable = list;
                }
            }
        }
        updateRevenueForecastForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectRevenueForecastForDetailTable = [];
                    } else {
                        this.selectRevenueForecastForDetailTable = list;
                    }
                } else {
                    this.selectRevenueForecastForDetailTable = list;
                }
            }
        }
        updateMarginForecastForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMarginForecastForDetailTable = [];
                    } else {
                        this.selectMarginForecastForDetailTable = list;
                    }
                } else {
                    this.selectMarginForecastForDetailTable = list;
                }
            }
        }
        updateMarginForecastPcForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMarginForecastPcForDetailTable = [];
                    } else {
                        this.selectMarginForecastPcForDetailTable = list;
                    }
                } else {
                    this.selectMarginForecastPcForDetailTable = list;
                }
            }
        }
        updateChangeSalesForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectChangeSalesForDetailTable = [];
                    } else {
                        this.selectChangeSalesForDetailTable = list;
                    }
                } else {
                    this.selectChangeSalesForDetailTable = list;
                }
            }
        }
        updateChangeRevenueForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectChangeRevenueForDetailTable = [];
                    } else {
                        this.selectChangeRevenueForDetailTable = list;
                    }
                } else {
                    this.selectChangeRevenueForDetailTable = list;
                }
            }
        }
        updateChangeMarginForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectChangeMarginForDetailTable = [];
                    } else {
                        this.selectChangeMarginForDetailTable = list;
                    }
                } else {
                    this.selectChangeMarginForDetailTable = list;
                }
            }
        }
        updateSalesDiffPcForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectSalesDiffPcForDetailTable = [];
                    } else {
                        this.selectSalesDiffPcForDetailTable = list;
                    }
                } else {
                    this.selectSalesDiffPcForDetailTable = list;
                }
            }
        }
        updateRevenueDiffPcForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectRevenueDiffPcForDetailTable = [];
                    } else {
                        this.selectRevenueDiffPcForDetailTable = list;
                    }
                } else {
                    this.selectRevenueDiffPcForDetailTable = list;
                }
            }
        }
        updateMarginDiffPcForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMarginDiffPcForDetailTable = [];
                    } else {
                        this.selectMarginDiffPcForDetailTable = list;
                    }
                } else {
                    this.selectMarginDiffPcForDetailTable = list;
                }
            }
        }
        updateMarginDiffSecondForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMarginDiffSecondForDetailTable = [];
                    } else {
                        this.selectMarginDiffSecondForDetailTable = list;
                    }
                } else {
                    this.selectMarginDiffSecondForDetailTable = list;
                }
            }
        }
        updateIndividualPromoTypeForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectIndividualPromoTypeForDetailTable = [];
                    } else {
                        this.selectIndividualPromoTypeForDetailTable = list;
                    }
                } else {
                    this.selectIndividualPromoTypeForDetailTable = list;
                }
            }
        }
        updateIndividualPromoLiftForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectIndividualPromoLiftForDetailTable = [];
                    } else {
                        this.selectIndividualPromoLiftForDetailTable = list;
                    }
                } else {
                    this.selectIndividualPromoLiftForDetailTable = list;
                }
            }
        }
        updateSalesForecastByRegularPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectSalesForecastByRegularPriceForDetailTable = [];
                    } else {
                        this.selectSalesForecastByRegularPriceForDetailTable = list;
                    }
                } else {
                    this.selectSalesForecastByRegularPriceForDetailTable = list;
                }
            }
        }
        updateRevenueForecastByRegularPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectRevenueForecastByRegularPriceForDetailTable = [];
                    } else {
                        this.selectRevenueForecastByRegularPriceForDetailTable = list;
                    }
                } else {
                    this.selectRevenueForecastByRegularPriceForDetailTable = list;
                }
            }
        }
        updateMarginForecastByRegularPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMarginForecastByRegularPriceForDetailTable = [];
                    } else {
                        this.selectMarginForecastByRegularPriceForDetailTable = list;
                    }
                } else {
                    this.selectMarginForecastByRegularPriceForDetailTable = list;
                }
            }
        }
        updateMarginForecastByRegularPricePcForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMarginForecastByRegularPricePcForDetailTable = [];
                    } else {
                        this.selectMarginForecastByRegularPricePcForDetailTable = list;
                    }
                } else {
                    this.selectMarginForecastByRegularPricePcForDetailTable = list;
                }
            }
        }
        updateChangeSalesByRegularPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectChangeSalesByRegularPriceForDetailTable = [];
                    } else {
                        this.selectChangeSalesByRegularPriceForDetailTable = list;
                    }
                } else {
                    this.selectChangeSalesByRegularPriceForDetailTable = list;
                }
            }
        }
        updateChangeRevenueByRegularPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectChangeRevenueByRegularPriceForDetailTable = [];
                    } else {
                        this.selectChangeRevenueByRegularPriceForDetailTable = list;
                    }
                } else {
                    this.selectChangeRevenueByRegularPriceForDetailTable = list;
                }
            }
        }
        updateChangeMarginByRegularPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectChangeMarginByRegularPriceForDetailTable = [];
                    } else {
                        this.selectChangeMarginByRegularPriceForDetailTable = list;
                    }
                } else {
                    this.selectChangeMarginByRegularPriceForDetailTable = list;
                }
            }
        }
        updateSalesDiffPcByRegularPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectSalesDiffPcByRegularPriceForDetailTable = [];
                    } else {
                        this.selectSalesDiffPcByRegularPriceForDetailTable = list;
                    }
                } else {
                    this.selectSalesDiffPcByRegularPriceForDetailTable = list;
                }
            }
        }
        updateRevenueDiffPcByRegularPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectRevenueDiffPcByRegularPriceForDetailTable = [];
                    } else {
                        this.selectRevenueDiffPcByRegularPriceForDetailTable = list;
                    }
                } else {
                    this.selectRevenueDiffPcByRegularPriceForDetailTable = list;
                }
            }
        }
        updateMarginDiffPcByRegularPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMarginDiffPcByRegularPriceForDetailTable = [];
                    } else {
                        this.selectMarginDiffPcByRegularPriceForDetailTable = list;
                    }
                } else {
                    this.selectMarginDiffPcByRegularPriceForDetailTable = list;
                }
            }
        }
        updateMarginDiffSecondByRegularPriceForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectMarginDiffSecondByRegularPriceForDetailTable = [];
                    } else {
                        this.selectMarginDiffSecondByRegularPriceForDetailTable = list;
                    }
                } else {
                    this.selectMarginDiffSecondByRegularPriceForDetailTable = list;
                }
            }
        }
        updateIndividualPriceOptStrategyForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectIndividualPriceOptStrategyForDetailTable = [];
                    } else {
                        this.selectIndividualPriceOptStrategyForDetailTable = list;
                    }
                } else {
                    this.selectIndividualPriceOptStrategyForDetailTable = list;
                }
            }
        }
        updateIndividualPriceIncreaseLimitForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectIndividualPriceIncreaseLimitForDetailTable = [];
                    } else {
                        this.selectIndividualPriceIncreaseLimitForDetailTable = list;
                    }
                } else {
                    this.selectIndividualPriceIncreaseLimitForDetailTable = list;
                }
            }
        }
        updateIndividualPeriodPriceIncreaseLimitForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectIndividualPeriodPriceIncreaseLimitForDetailTable = [];
                    } else {
                        this.selectIndividualPeriodPriceIncreaseLimitForDetailTable = list;
                    }
                } else {
                    this.selectIndividualPeriodPriceIncreaseLimitForDetailTable = list;
                }
            }
        }
        updateIndividualPeriodForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectIndividualPeriodForDetailTable = [];
                    } else {
                        this.selectIndividualPeriodForDetailTable = list;
                    }
                } else {
                    this.selectIndividualPeriodForDetailTable = list;
                }
            }
        }
        updateIndividualMarginalProfitForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectIndividualMarginalProfitForDetailTable = [];
                    } else {
                        this.selectIndividualMarginalProfitForDetailTable = list;
                    }
                } else {
                    this.selectIndividualMarginalProfitForDetailTable = list;
                }
            }
        }
        updateIndividualKviStrategyForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectIndividualKviStrategyForDetailTable = [];
                    } else {
                        this.selectIndividualKviStrategyForDetailTable = list;
                    }
                } else {
                    this.selectIndividualKviStrategyForDetailTable = list;
                }
            }
        }
        updateIndividualPercentCorrectionForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectIndividualPercentCorrectionForDetailTable = [];
                    } else {
                        this.selectIndividualPercentCorrectionForDetailTable = list;
                    }
                } else {
                    this.selectIndividualPercentCorrectionForDetailTable = list;
                }
            }
        }
        updateIndividualNewProductPriceStrategyForDetailTable(list: string[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === 'All'
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === 'All'
                    });
                    if (index2 !== -1) {
                        this.selectIndividualNewProductPriceStrategyForDetailTable = [];
                    } else {
                        this.selectIndividualNewProductPriceStrategyForDetailTable = list;
                    }
                } else {
                    this.selectIndividualNewProductPriceStrategyForDetailTable = list;
                }
            }
        }
        updateIndividualPriceGapPercentForDetailTable(list: number[]) {
            if (list.length > 0) {
                const index = list.findIndex((item) => {
                    return item === -1
                });

                if (index !== -1) {
                    list.shift()
                    const index2 = list.findIndex((item) => {
                        return item === -1
                    });
                    if (index2 !== -1) {
                        this.selectIndividualPriceGapPercentForDetailTable = [];
                    } else {
                        this.selectIndividualPriceGapPercentForDetailTable = list;
                    }
                } else {
                    this.selectIndividualPriceGapPercentForDetailTable = list;
                }
            }
        }

        downloadFile() {
            if (this.taskData != null) {
                const taskId = this.taskData.id
                this.$http.get('/api/task/result', {
                    method: 'GET',
                    responseType: 'blob',
                    params: {
                        taskId,
                    },
                })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        // tslint:disable-next-line: no-non-null-assertion
                        link.setAttribute('download', this.taskData!!.fileResult!!);
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch((e) => {
                        this.showError(this.$t('results.messages.errorDownloadReport') as string);
                    });
            }
        }

        downloadFileInPackageSubTask(taskId: number, file: string) {
            this.$http.get('/api/task/result', {
                method: 'GET',
                responseType: 'blob',
                params: {
                    taskId,
                },
            })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((e) => {
                    this.showError(this.$t('results.messages.errorDownloadReport') as string);
                });
        }

        sendFileToFtpServer() {
            if (this.taskData != null) {
                this.httpSendReportToFtpServer([this.taskData.id])
                    .then(() => {
                        this.showInfo(this.$t('results.messages.infoSendForApproval') as string);
                    })
                    .catch((e) => {
                        this.handleSendForApprovalError(e, e.response && e.response.data);
                    });
            }
        }

        sendSubTaskToFtpServer(taskId: number) {
            this.httpSendReportToFtpServer([taskId])
                .then(() => {
                    this.showInfo(this.$t('results.messages.infoSendForApproval') as string);
                })
                .catch((exception) => {
                    this.handleSendForApprovalError(exception, exception.response && exception.response.data && exception.response.data.message);
                });
        }

        fetchResultTableHeaders(ctx: any, callback: (items: any[]) => void) {
            if (this.taskData == null) {
                callback([]);
                return;
            }

            this.showOverlay = true;

            this.httpGetResultTableHeaders(this.taskData.id)
                .then((r) => {
                        this.resultTableHeaders = r.data;
                        this.downloadLastExcelHeaderByFilters = true;
                        callback(r.data);
                        this.showOverlay = false;
                    },
                )
                .catch((e) => {
                    callback([]);
                    this.showOverlay = false;
                });
        }

        fetchAllGeneralSubTasksTableHeaders(ctx: any, callback: (items: any[]) => void) {
            if (this.taskData == null) {
                callback([]);
                return;
            }
            this.httpGetAllSubTasksGeneralPackageHeaders(this.taskData.id, this.subtasksListPerPage, this.subtasksListPerPage * (this.subtasksListCurrentPage - 1))
                .then((r) => {
                        this.resultGeneralSubtasksTableHeaders = r.data;
                        callback(r.data);
                    },
                )
                .catch((e) => {
                    callback([]);
                });
        }

        fetchAllGeneralSubTasksTableHeadersSize(ctx: any, callback: (items: number) => void) {
            if (this.taskData == null) {
                callback(0);
                return;
            }
            this.httpGetAllSubTasksGeneralPackageHeadersSize(this.taskData.id)
                .then((r) => {
                        this.subtasksTotalRows = r.data;
                        callback(r.data);
                    },
                )
                .catch((e) => {
                    callback(0);
                });
        }

        getReportDetailParams(): ReportDetailParams {
            return {
                selectTaskIdFilter: this.selectTaskIdForDetailTable,
                selectGroupFilter: this.selectGroupNameForDetailTable,
                selectCategoryFilter: this.selectCategoryNameForDetailTable,
                selectSubcategoryFilter: this.selectSubcategoryNamesForDetailTable,
                selectFormatFilter: this.selectFormatNameForDetailTable,
                selectRegionFilter: this.selectRegionNameForDetailTable,
                selectClusterFilter: this.selectClusterNameForDetailTable,
                selectSegmentNameFilter: this.selectSegmentNameForDetailTable,
                selectInternalCodeFilter: this.selectInternalCodeForDetailTable,
                selectSkuNameFilter: this.selectSkuNameForDetailTable,
                eventTriggerCondition: this.selectEventTriggerForDetailTable.value,
                kviCondition: this.selectKVIForDetailTable.value,
                ctmCondition: this.selectCTMForDetailTable.value,
                selectCtmBrandFilter: this.selectCtmBrandForDetailTable,
                selectCtmPriceGapFilter: this.selectCtmPriceGapForDetailTable,
                selectMinRetailPriceFilter: this.selectMinRetailPriceForDetailTable,
                selectMaxRetailPriceFilter: this.selectMaxRetailPriceForDetailTable,
                selectKeyProduct1Filter: this.selectKeyProduct1ForDetailTable,
                selectKeyProduct2Filter: this.selectKeyProduct2ForDetailTable,
                selectRecipeAttributeFilter: this.selectRecipeAttributeForDetailTable,
                selectTreatmentAttributeFilter: this.selectTreatmentAttributeForDetailTable,
                selectVitalMedicineFilter: this.selectVitalMedicineForDetailTable.value,
                selectProducerPriceFilter: this.selectProducerPriceForDetailTable,
                selectExtraChargePcFilter: this.selectExtraChargePcForDetailTable,
                selectRegistrationPriceFilter: this.selectRegistrationPriceForDetailTable,
                priceSegmentsForDetailReport: this.selectSegmentPriceForDetailTable,
                selectSkuLineFilter: this.selectSkuLineForDetailTable,
                selectPurchasePriceFilter: this.selectPurchasePriceForDetailTable,
                selectPromoPurchasePriceFilter: this.selectPromoPurchasePriceForDetailTable,
                selectAvgRegularPriceFilter: this.selectAvgRegularPriceForDetailTable,
                selectAvgCashPriceFilter: this.selectAvgCashPriceForDetailTable,
                selectAvgCheckPriceFilter: this.selectAvgCheckPriceForDetailTable,
                selectRegularPriceFilter: this.selectRegularPriceForDetailTable,
                selectMarginLastPriceFilter: this.selectMarginLastPriceForDetailTable,
                selectMinCompetitorPriceFilter: this.selectMinCompetitorPriceForDetailTable,
                selectMinCompetitorNameFilter: this.selectMinCompetitorNameForDetailTable,
                selectMinCompetitorCodeFilter: this.selectMinCompetitorCodeForDetailTable,
                selectMaxCompetitorPriceFilter: this.selectMaxCompetitorPriceForDetailTable,
                selectMaxCompetitorNameFilter: this.selectMaxCompetitorNameForDetailTable,
                selectMaxCompetitorCodeFilter: this.selectMaxCompetitorCodeForDetailTable,
                selectAvgCompetitorPriceFilter: this.selectAvgCompetitorPriceForDetailTable,
                selectLastCompetitorPriceFilter: this.selectLastCompetitorPriceForDetailTable,
                selectMinPromoCompetitorPriceFilter: this.selectMinPromoCompetitorPriceForDetailTable,
                selectMinPromoCompetitorNameFilter: this.selectMinPromoCompetitorNameForDetailTable,
                selectMinPromoCompetitorCodeFilter: this.selectMinPromoCompetitorCodeForDetailTable,
                selectMaxPromoCompetitorPriceFilter: this.selectMaxPromoCompetitorPriceForDetailTable,
                selectMaxPromoCompetitorNameFilter: this.selectMaxPromoCompetitorNameForDetailTable,
                selectMaxPromoCompetitorCodeFilter: this.selectMaxPromoCompetitorCodeForDetailTable,
                selectMedianPromoCompetitorPriceFilter: this.selectMedianPromoCompetitorPriceForDetailTable,
                selectLastPromoCompetitorPriceFilter: this.selectLastPromoCompetitorPriceForDetailTable,
                selectPiFilter: this.selectPiForDetailTable,
                selectActualSalesFilter: this.selectActualSalesForDetailTable,
                selectActualRevenueFilter: this.selectActualRevenueForDetailTable,
                selectActualMarginFilter: this.selectActualMarginForDetailTable,
                selectActualMarginPercentFilter: this.selectActualMarginPercentForDetailTable,
                selectComparableSalesFilter: this.selectComparableSalesForDetailTable,
                selectComparableRevenueFilter: this.selectComparableRevenueForDetailTable,
                selectComparableMarginFilter: this.selectComparableMarginForDetailTable,
                selectComparableMarginPcFilter: this.selectComparableMarginPcForDetailTable,
                selectNewPriceFilter: this.selectNewPriceForDetailTable,
                selectNewPromoPriceFilter: this.selectNewPromoPriceForDetailTable,
                selectCorrectedRegularPriceFilter: this.selectCorrectedRegularPriceForDetailTable,
                selectCorrectedPromoPriceFilter: this.selectCorrectedPromoPriceForDetailTable,
                selectNewMarginPcFilter: this.selectNewMarginPcForDetailTable,
                selectNewPIFilter: this.selectNewPIForDetailTable,
                selectDeltaDiffPriceFilter: this.selectDeltaDiffPriceForDetailTable,
                selectPriceDiffPcFilter: this.selectPriceDiffPcForDetailTable,
                selectMarginDiffFilter: this.selectMarginDiffForDetailTable,
                selectChangedPIFilter: this.selectChangedPIForDetailTable,
                selectDiscountDepthFilter: this.selectDiscountDepthForDetailTable,
                selectDiscountDurationFilter: this.selectDiscountDurationForDetailTable,
                selectExitSegmentFilter: this.selectExitSegmentForDetailTable,
                selectCoeffElasticityFilter: this.selectCoeffElasticityForDetailTable,
                selectPromoCoeffElasticityFilter: this.selectPromoCoeffElasticityForDetailTable,
                selectSalesForecastFilter: this.selectSalesForecastForDetailTable,
                selectRevenueForecastFilter: this.selectRevenueForecastForDetailTable,
                selectMarginForecastFilter: this.selectMarginForecastForDetailTable,
                selectMarginForecastPcFilter: this.selectMarginForecastPcForDetailTable,
                selectChangeSalesFilter: this.selectChangeSalesForDetailTable,
                selectChangeRevenueFilter: this.selectChangeRevenueForDetailTable,
                selectChangeMarginFilter: this.selectChangeMarginForDetailTable,
                selectSalesDiffPcFilter: this.selectSalesDiffPcForDetailTable,
                selectRevenueDiffPcFilter: this.selectRevenueDiffPcForDetailTable,
                selectMarginDiffPcFilter: this.selectMarginDiffPcForDetailTable,
                selectMarginDiffSecondFilter: this.selectMarginDiffSecondForDetailTable,
                selectIndividualPromoTypeFilter: this.selectIndividualPromoTypeForDetailTable,
                selectIndividualPromoLiftFilter: this.selectIndividualPromoLiftForDetailTable,
                selectSalesForecastByRegularPriceFilter: this.selectSalesForecastByRegularPriceForDetailTable,
                selectRevenueForecastByRegularPriceFilter: this.selectRevenueForecastByRegularPriceForDetailTable,
                selectMarginForecastByRegularPriceFilter: this.selectMarginForecastByRegularPriceForDetailTable,
                selectMarginForecastByRegularPricePcFilter: this.selectMarginForecastByRegularPricePcForDetailTable,
                selectChangeSalesByRegularPriceFilter: this.selectChangeSalesByRegularPriceForDetailTable,
                selectChangeRevenueByRegularPriceFilter: this.selectChangeRevenueByRegularPriceForDetailTable,
                selectChangeMarginByRegularPriceFilter: this.selectChangeMarginByRegularPriceForDetailTable,
                selectSalesDiffPcByRegularPriceFilter: this.selectSalesDiffPcByRegularPriceForDetailTable,
                selectRevenueDiffPcByRegularPriceFilter: this.selectRevenueDiffPcByRegularPriceForDetailTable,
                selectMarginDiffPcByRegularPriceFilter: this.selectMarginDiffPcByRegularPriceForDetailTable,
                selectMarginDiffSecondByRegularPriceFilter: this.selectMarginDiffSecondByRegularPriceForDetailTable,
                selectIndividualPriceOptStrategyFilter: this.selectIndividualPriceOptStrategyForDetailTable,
                selectIndividualPriceIncreaseLimitFilter: this.selectIndividualPriceIncreaseLimitForDetailTable,
                selectIndividualPeriodPriceIncreaseLimitFilter: this.selectIndividualPeriodPriceIncreaseLimitForDetailTable,
                selectIndividualPeriodFilter: this.selectIndividualPeriodForDetailTable,
                selectIndividualMarginalProfitFilter: this.selectIndividualMarginalProfitForDetailTable,
                selectIndividualKviStrategyFilter: this.selectIndividualKviStrategyForDetailTable,
                selectIndividualPercentCorrectionFilter: this.selectIndividualPercentCorrectionForDetailTable,
                selectIndividualNewProductPriceStrategyFilter: this.selectIndividualNewProductPriceStrategyForDetailTable,
                selectIndividualPriceGapPercentFilter: this.selectIndividualPriceGapPercentForDetailTable,
                selectBatchNumberFilter: this.selectBatchNumberForDetailTable,
                selectApprovedByFioFilter: this.selectApprovedByFioForDetailTable,
                selectIsApprovedFilter: this.getTransformedApprovalFilter(),
                selectPriceExperimentFilter: this.selectPriceExperimentForDetailTable.value === 'all' ? [] : [this.selectPriceExperimentForDetailTable.value],
                selectProductVerticalLineFilter: this.selectProductVerticalLineForDetailTable,
                selectDetailedStatusFilter: this.selectDetailedStatusForDetailTable,
                selectSalePointsFilter: this.selectSalePointCodesForDetailTable,

                sortingField: this.sortingField,
                detailTableSkuFilter: this.detailTableSkuFilter.trim(),
                // tslint:disable-next-line: no-non-null-assertion
                taskType: this.taskData!!.type,
                selectActiveProductsOnly: this.selectActiveProductsOnly,
            }
        }

        getTransformedApprovalFilter(): string[] {
            const result: string[] = [];
            for (const value of this.selectIsApprovedForDetailTable) {
                if (value === 'APPROVED') {
                    result.push(ApprovalStatus.APPROVED_AUTOMATICALLY);
                    result.push(ApprovalStatus.APPROVED_MANUALLY);
                } else {
                    result.push(value);
                }
            }
            return result;
        }

        loadMoreSku() {
            this.pagination.current += 1;
            this.pagination.pageSize = 50
            this.pagination.pageSize *= this.pagination.current

            this.fetchResultTableDetailReports()
        }

        fetchResultTableDetailReports() {
            if (this.taskData == null) {
                return;
            }
            const offset = (this.pagination.current - 1) * this.pagination.pageSize;
            const params = this.getReportDetailParams();

            this.tableIsLoading = true;

            this.httpGetResultTableDetailReports(this.taskData.id, this.pagination.pageSize, offset, params)
                .then((r) => {
                        this.pagination.total = r.data.totalElements;
                        this.resultTableDetailReports = r.data.content.map(el => ({...el, newPriceHistory: el.newPriceHistory ? el.newPriceHistory: '-'}));
                        this.detailReportTotalRows = r.data.totalElements;
                        this.disableSelectedReports = true;
                })
                .catch((e) => {
                    this.showError(this.$t('results.messages.errorLoadReportNumbers') as string);
                }).finally(() => {
                    this.tableIsLoading = false;
                });

            if (!this.isDownloadAllFiltersName) {
                this.getResultTableDetailAllFiltersNames();
                this.isDownloadAllFiltersName = true
            }
            if (this.segmentPriceOptionsForDetailTable.length === 0) {
                this.getSegmentPriceForDetailReport();
            }

            this.isFilteredSkusDisplayed = this.hasActiveFilters(params);

            if (this.isFilteredSkusDisplayed) {
                this.httpGetAllReportDetailIdsByFilters(this.taskData.id, params)
                    .then((response) => {
                        this.allFilteredSkusUniqueData = new Set(
                            response.data.map((el: UniqSkuData) => `${el.id}::${el.taskId}::${el.internalCode}`)
                        );
                    })
                    .catch((e) => {
                        this.showError(this.$t('results.messages.errorLoadReportNumbers') as string);
                    });
            }
        }

        // метод не используется, предполагаю, что он остался от самых первых версий работы с чекбоксами в таблице
        // selectOrClearAllReports() {
        //     this.allTaskIdWithInternalCodesByFilters.forEach((idAndCode) => {
        //         const taskIdIndex = this.changesPrices.findIndex((item) => {
        //             return item.taskId === idAndCode.taskId
        //         });
        //         if (this.disableSelectedReports) {
        //             if (taskIdIndex === -1) {
        //                 const chPrice = new ChangesPrices();
        //                 chPrice.taskId = idAndCode.taskId
        //                 chPrice.productCodesForDelete.push(idAndCode.internalCode)
        //                 this.changesPrices.push(chPrice)
        //             } else {
        //                 this.changesPrices[taskIdIndex].productCodesForDelete.push(idAndCode.internalCode)
        //             }
        //             if (taskIdIndex !== -1) {
        //                 const addIndex = this.changesPrices[taskIdIndex].productCodesForAdd.findIndex((item) => {
        //                     return item === idAndCode.internalCode
        //                 });
        //                 if (addIndex !== -1) {
        //                     this.changesPrices[taskIdIndex].productCodesForAdd.splice(addIndex, 1);
        //                 }
        //             }
        //         } else {
        //             if (taskIdIndex === -1) {
        //                 const chPrice = new ChangesPrices();
        //                 chPrice.taskId = idAndCode.taskId
        //                 chPrice.productCodesForAdd.push(idAndCode.internalCode)
        //                 this.changesPrices.push(chPrice)
        //             } else {
        //                 this.changesPrices[taskIdIndex].productCodesForAdd.push(idAndCode.internalCode)
        //             }
        //             if (taskIdIndex !== -1) {
        //                 const delIndex = this.changesPrices[taskIdIndex].productCodesForDelete.findIndex((item) => {
        //                     return item === idAndCode.internalCode
        //                 });
        //                 if (delIndex !== -1) {
        //                     this.changesPrices[taskIdIndex].productCodesForDelete.splice(delIndex, 1);
        //                 }
        //             }
        //         }
        //     });
        //     this.disableSelectedReports = !this.disableSelectedReports;
        // }

        getResultTableDetailAllFiltersNames() {
            // tslint:disable-next-line: no-non-null-assertion
            this.httpGetResultTableDetailsFilterNames(this.taskData!!.id, this.taskData!!.type)
                .then((r) => {
                    const result = r.data
                    this.taskIdOptionsForDetailTable = result.taskIds.map((taskId) => {
                        return {value: taskId, label: taskId.toString()};
                    });
                    this.groupNamesOptionsForDetailTable = result.groupNames.map((group) => {
                        return {value: group, label: group};
                    });
                    this.categoryNamesOptionsForDetailTable = result.categoryNames.map((category) => {
                        return {value: category, label: category};
                    });
                    this.subcategoryNamesOptionsForDetailTable = result.subCategoryNames.map((subCat) => {
                        return {value: subCat, label: subCat};
                    });
                    this.formatNamesOptionsForDetailTable = result.formatNames.map((format) => {
                        return {value: format, label: format};
                    });
                    this.regionNamesOptionsForDetailTable = result.regionNames.map((region) => {
                        return {value: region, label: region};
                    });
                    this.clusterNamesOptionsForDetailTable = result.clusterNames.map((cluster) => {
                        return {value: cluster, label: cluster};
                    });
                    this.segmentNamesOptionsForDetailTable = result.segmentNames.map((segmentName) => {
                        return {value: segmentName, label: segmentName};
                    });
                    this.internalCodesOptionsForDetailTable = result.internalCodes.map((internalCode) => {
                        return {value: internalCode, label: internalCode};
                    });
                    this.skuNamesOptionsForDetailTable = result.skuNames.map((skuName) => {
                        return {value: skuName, label: skuName};
                    });
                    this.kviOptions = [
                        {value: -1, label: this.$t('shared.selectBox.all') as string},
                        {value: 1, label: 'KVI'},
                        {value: 0, label: this.$t('shared.selectBox.notKvi') as string},
                    ];
                    this.ctmOptionsForDetailTable = [
                        {value: -1, label: this.$t('shared.selectBox.all') as string},
                        {value: 1, label: 'CTM'},
                        {value: 0, label: this.$t('shared.selectBox.notCtm') as string},
                    ];
                    this.ctmBrandsOptionsForDetailTable = result.ctmBrands.map((ctmBrand) => {
                        return {value: ctmBrand, label: ctmBrand};
                    });
                    this.ctmPriceGapOptionsForDetailTable = result.ctmPriceGaps.map((ctmPriceGap) => {
                        return {value: ctmPriceGap, label: ctmPriceGap.toString()};
                    });
                    this.minRetailPriceOptionsForDetailTable = result.minRetailPrices.map((minRetailPrice) => {
                        return {value: minRetailPrice, label: minRetailPrice.toString()};
                    });
                    this.maxRetailPriceOptionsForDetailTable = result.maxRetailPrices.map((maxRetailPrice) => {
                        return {value: maxRetailPrice, label: maxRetailPrice.toString()};
                    });
                    this.keyProduct1OptionsForDetailTable = result.keyProducts1.map((keyProduct1) => {
                        return {value: keyProduct1, label: keyProduct1};
                    });
                    this.keyProduct2OptionsForDetailTable = result.keyProducts2.map((keyProduct2) => {
                        return {value: keyProduct2, label: keyProduct2};
                    });
                    this.recipeAttributeOptionsForDetailTable = result.recipeAttributes.map((recipeAttribute) => {
                        return {value: recipeAttribute, label: recipeAttribute};
                    });
                    this.treatmentAttributeOptionsForDetailTable = result.treatmentAttributes.map((treatmentAttribute) => {
                        return {value: treatmentAttribute, label: treatmentAttribute.toString()};
                    });
                    this.producerPricesOptionsForDetailTable = result.producerPrices.map((producerPrice) => {
                        return {value: producerPrice, label: producerPrice.toString()};
                    });
                    this.extraChargePcsOptionsForDetailTable = result.extraChargePcs.map((extraChargePc) => {
                        return {value: extraChargePc, label: extraChargePc.toString()};
                    });
                    this.registrationPricesOptionsForDetailTable = result.registrationPrices.map((registrationPrice) => {
                        return {value: registrationPrice, label: registrationPrice.toString()};
                    });
                    this.skuLineOptionsForDetailTable = result.skuLines.map((skuLine) => {
                        return {value: skuLine, label: skuLine};
                    });
                    this.purchasePriceOptionsForDetailTable = result.purchasePrices.map((purchasePrice) => {
                        return {value: purchasePrice, label: purchasePrice.toString()};
                    });
                    this.promoPurchasePriceOptionsForDetailTable = result.promoPurchasePrices.map((promoPurchasePrice) => {
                        return {value: promoPurchasePrice, label: promoPurchasePrice.toString()};
                    });
                    this.avgRegularPriceOptionsForDetailTable = result.avgRegularPrices.map((avgRegularPrice) => {
                        return {value: avgRegularPrice, label: avgRegularPrice.toString()};
                    });
                    this.avgCashPriceOptionsForDetailTable = result.avgCashPrices.map((avgCashPrice) => {
                        return {value: avgCashPrice, label: avgCashPrice.toString()};
                    });
                    this.avgCheckPriceOptionsForDetailTable = result.avgCheckPrices.map((avgCheckPrice) => {
                        return {value: avgCheckPrice, label: avgCheckPrice.toString()};
                    });
                    this.regularPriceOptionsForDetailTable = result.regularPrices.map((regularPrice) => {
                        return {value: regularPrice, label: regularPrice.toString()};
                    });
                    this.marginLastPriceOptionsForDetailTable = result.marginLastPrices.map((marginLastPrice) => {
                        return {value: marginLastPrice, label: marginLastPrice.toString()};
                    });
                    this.minCompetitorPriceOptionsForDetailTable = result.minCompetitorPrices.map((minCompetitorPrice) => {
                        return {value: minCompetitorPrice, label: minCompetitorPrice.toString()};
                    });
                    this.minCompetitorNameOptionsForDetailTable = result.minCompetitorNames.map((minCompetitorName) => {
                        return {value: minCompetitorName, label: minCompetitorName};
                    });
                    this.minCompetitorCodeOptionsForDetailTable = result.minCompetitorCodes ? result.minCompetitorCodes.map((minCompetitorCode: string) => {
                        return {value: minCompetitorCode, label: minCompetitorCode};
                    }) : [];
                    this.maxCompetitorPriceOptionsForDetailTable = result.maxCompetitorPrices.map((maxCompetitorPrice) => {
                        return {value: maxCompetitorPrice, label: maxCompetitorPrice.toString()};
                    });
                    this.maxCompetitorNameOptionsForDetailTable = result.maxCompetitorNames.map((maxCompetitorName) => {
                        return {value: maxCompetitorName, label: maxCompetitorName};
                    });
                    this.maxCompetitorCodeOptionsForDetailTable = result.maxCompetitorCodes ? result.maxCompetitorCodes.map((maxCompetitorCode: string) => {
                        return {value: maxCompetitorCode, label: maxCompetitorCode};
                    }) : [];
                    this.avgCompetitorPriceOptionsForDetailTable = result.avgCompetitorPrices.map((avgCompetitorPrice) => {
                        return {value: avgCompetitorPrice, label: avgCompetitorPrice.toString()};
                    });
                    this.lastCompetitorPriceOptionsForDetailTable = result.lastCompetitorPrices.map((lastCompetitorPrice) => {
                        return {value: lastCompetitorPrice, label: lastCompetitorPrice.toString()};
                    });
                    this.minPromoCompetitorPriceOptionsForDetailTable = result.minPromoCompetitorPrices.map((minPromoCompetitorPrice) => {
                        return {value: minPromoCompetitorPrice, label: minPromoCompetitorPrice.toString()};
                    });
                    this.minPromoCompetitorNameOptionsForDetailTable = result.minPromoCompetitorNames.map((minPromoCompetitorName) => {
                        return {value: minPromoCompetitorName, label: minPromoCompetitorName};
                    });
                    this.minPromoCompetitorCodeOptionsForDetailTable = result.minPromoCompetitorCodes ? result.minPromoCompetitorCodes.map((minPromoCompetitorCode: string) => {
                        return {value: minPromoCompetitorCode, label: minPromoCompetitorCode};
                    }) : [];
                    this.maxPromoCompetitorPriceOptionsForDetailTable = result.maxPromoCompetitorPrices.map((maxPromoCompetitorPrice) => {
                        return {value: maxPromoCompetitorPrice, label: maxPromoCompetitorPrice.toString()};
                    });
                    this.maxPromoCompetitorNameOptionsForDetailTable = result.maxPromoCompetitorNames.map((maxPromoCompetitorName) => {
                        return {value: maxPromoCompetitorName, label: maxPromoCompetitorName};
                    });
                    this.maxPromoCompetitorCodeOptionsForDetailTable = result.maxPromoCompetitorCodes ? result.maxPromoCompetitorCodes.map((maxPromoCompetitorCode: string) => {
                        return {value: maxPromoCompetitorCode, label: maxPromoCompetitorCode};
                    }) : [];
                    this.medianPromoCompetitorPriceOptionsForDetailTable = result.medianPromoCompetitorPrices.map((medianPromoCompetitorPrice) => {
                        return {value: medianPromoCompetitorPrice, label: medianPromoCompetitorPrice.toString()};
                    });
                    this.lastPromoCompetitorPriceOptionsForDetailTable = result.lastPromoCompetitorPrices.map((lastPromoCompetitorPrice) => {
                        return {value: lastPromoCompetitorPrice, label: lastPromoCompetitorPrice.toString()};
                    });
                    this.piOptionsForDetailTable = result.piValues.map((piValue) => {
                        return {value: piValue, label: piValue.toString()};
                    });
                    this.actualSalesOptionsForDetailTable = result.actualSales.map((actualSales) => {
                        return {value: actualSales, label: actualSales.toString()};
                    });
                    this.actualRevenueOptionsForDetailTable = result.actualRevenues.map((actualRevenue) => {
                        return {value: actualRevenue, label: actualRevenue.toString()};
                    });
                    this.actualMarginOptionsForDetailTable = result.actualMargins.map((actualMargin) => {
                        return {value: actualMargin, label: actualMargin.toString()};
                    });
                    this.actualMarginPercentOptionsForDetailTable = result.actualMarginPercents.map((actualMarginPercent) => {
                        return {value: actualMarginPercent, label: actualMarginPercent.toString()};
                    });
                    this.comparableSalesOptionsForDetailTable = result.comparableSales.map((comparableSale) => {
                        return {value: comparableSale, label: comparableSale.toString()};
                    });
                    this.comparableRevenueOptionsForDetailTable = result.comparableRevenues.map((comparableRevenue) => {
                        return {value: comparableRevenue, label: comparableRevenue.toString()};
                    });
                    this.comparableMarginOptionsForDetailTable = result.comparableMargins.map((comparableMargin) => {
                        return {value: comparableMargin, label: comparableMargin.toString()};
                    });
                    this.comparableMarginPcOptionsForDetailTable = result.comparableMarginPcs.map((comparableMarginPc) => {
                        return {value: comparableMarginPc, label: comparableMarginPc.toString()};
                    });
                    this.newPriceOptionsForDetailTable = result.newPrices.map((newPrice) => {
                        return {value: newPrice, label: newPrice.toString()};
                    });
                    this.newPromoPriceOptionsForDetailTable = result.newPromoPrices.map((newPromoPrice) => {
                        return {value: newPromoPrice, label: newPromoPrice.toString()};
                    });
                    this.correctedRegularPriceOptionsForDetailTable = result.correctedRegularPrices.map((correctedRegularPrice) => {
                        return {value: correctedRegularPrice, label: correctedRegularPrice.toString()};
                    });
                    this.correctedPromoPriceOptionsForDetailTable = result.correctedPromoPrices.map((correctedPromoPrice) => {
                        return {value: correctedPromoPrice, label: correctedPromoPrice.toString()};
                    });
                    this.newMarginPcOptionsForDetailTable = result.newMarginPcs.map((newMarginPc) => {
                        return {value: newMarginPc, label: newMarginPc.toString()};
                    });
                    this.newPIOptionsForDetailTable = result.newPIs.map((newPI) => {
                        return {value: newPI, label: newPI.toString()};
                    });
                    this.deltaDiffPriceOptionsForDetailTable = result.deltaDiffPrices.map((deltaDiffPrice) => {
                        return {value: deltaDiffPrice, label: deltaDiffPrice.toString()};
                    });
                    this.priceDiffPcOptionsForDetailTable = result.priceDiffPcs.map((priceDiffPc) => {
                        return {value: priceDiffPc, label: priceDiffPc.toString()};
                    });
                    this.marginDiffOptionsForDetailTable = result.marginDiffs.map((marginDiff) => {
                        return {value: marginDiff, label: marginDiff.toString()};
                    });
                    this.changedPIPcOptionsForDetailTable = result.changedPIs.map((changedPI) => {
                        return {value: changedPI, label: changedPI.toString()};
                    });
                    this.discountDepthOptionsForDetailTable = result.discountDepths.map((discountDepth) => {
                        return {value: discountDepth, label: discountDepth.toString()};
                    });
                    this.discountDurationOptionsForDetailTable = result.discountDurations.map((discountDuration) => {
                        return {value: discountDuration, label: discountDuration.toString()};
                    });
                    this.exitSegmentOptionsForDetailTable = result.exitSegments.map((exitSegment) => {
                        return {value: exitSegment, label: exitSegment};
                    });
                    this.coeffElasticityPcOptionsForDetailTable = result.coeffElasticitys.map((coeffElasticity) => {
                        return {value: coeffElasticity, label: coeffElasticity.toString()};
                    });
                    this.promoCoeffElasticityPcOptionsForDetailTable = result.promoCoeffElasticitys.map((promoCoeffElasticity) => {
                        return {value: promoCoeffElasticity, label: promoCoeffElasticity.toString()};
                    });
                    this.salesForecastOptionsForDetailTable = result.salesForecasts.map((salesForecast) => {
                        return {value: salesForecast, label: salesForecast.toString()};
                    });
                    this.revenueForecastOptionsForDetailTable = result.revenueForecasts.map((revenueForecast) => {
                        return {value: revenueForecast, label: revenueForecast.toString()};
                    });
                    this.marginForecastOptionsForDetailTable = result.marginForecasts.map((marginForecast) => {
                        return {value: marginForecast, label: marginForecast.toString()};
                    });
                    this.marginForecastPcOptionsForDetailTable = result.marginForecastPcs.map((marginForecastPc) => {
                        return {value: marginForecastPc, label: marginForecastPc.toString()};
                    });
                    this.changeSalesOptionsForDetailTable = result.changeSales.map((changeSale) => {
                        return {value: changeSale, label: changeSale.toString()};
                    });
                    this.changeRevenueOptionsForDetailTable = result.changeRevenues.map((changeRevenue) => {
                        return {value: changeRevenue, label: changeRevenue.toString()};
                    });
                    this.changeMarginOptionsForDetailTable = result.changeMargins.map((changeMargin) => {
                        return {value: changeMargin, label: changeMargin.toString()};
                    });
                    this.salesDiffPcOptionsForDetailTable = result.salesDiffPcs.map((salesDiffPc) => {
                        return {value: salesDiffPc, label: salesDiffPc.toString()};
                    });
                    this.revenueDiffPcOptionsForDetailTable = result.revenueDiffPcs.map((revenueDiffPc) => {
                        return {value: revenueDiffPc, label: revenueDiffPc.toString()};
                    });
                    this.marginDiffPcOptionsForDetailTable = result.marginDiffPcs.map((marginDiffPc) => {
                        return {value: marginDiffPc, label: marginDiffPc.toString()};
                    });
                    this.marginDiffSecondOptionsForDetailTable = result.marginDiffSeconds.map((marginDiffSecond) => {
                        return {value: marginDiffSecond, label: marginDiffSecond.toString()};
                    });
                    this.individualPromoTypeOptionsForDetailTable = result.individualPromoTypes.map((individualPromoType) => {
                        return {value: individualPromoType, label: individualPromoType};
                    });
                    this.individualPromoLiftOptionsForDetailTable = result.individualPromoLifts.map((individualPromoLift) => {
                        return {value: individualPromoLift, label: individualPromoLift.toString()};
                    });
                    this.salesForecastByRegularPriceOptionsForDetailTable = result.salesForecastByRegularPrices.map((salesForecastByRegularPrice) => {
                        return {value: salesForecastByRegularPrice, label: salesForecastByRegularPrice.toString()};
                    });
                    this.revenueForecastByRegularPriceOptionsForDetailTable = result.revenueForecastByRegularPrices.map((revenueForecastByRegularPrice) => {
                        return {value: revenueForecastByRegularPrice, label: revenueForecastByRegularPrice.toString()};
                    });
                    this.marginForecastByRegularPriceOptionsForDetailTable = result.marginForecastByRegularPrices.map((marginForecastByRegularPrice) => {
                        return {value: marginForecastByRegularPrice, label: marginForecastByRegularPrice.toString()};
                    });
                    this.marginForecastByRegularPricePcOptionsForDetailTable = result.marginForecastByRegularPricePcs.map((marginForecastByRegularPricePc) => {
                        return {value: marginForecastByRegularPricePc, label: marginForecastByRegularPricePc.toString()};
                    });
                    this.changeSalesByRegularPriceOptionsForDetailTable = result.changeSalesByRegularPrices.map((changeSalesByRegularPrice) => {
                        return {value: changeSalesByRegularPrice, label: changeSalesByRegularPrice.toString()};
                    });
                    this.changeRevenueByRegularPriceOptionsForDetailTable = result.changeRevenueByRegularPrices.map((changeRevenueByRegularPrice) => {
                        return {value: changeRevenueByRegularPrice, label: changeRevenueByRegularPrice.toString()};
                    });
                    this.changeMarginByRegularPriceOptionsForDetailTable = result.changeMarginByRegularPrices.map((changeMarginByRegularPrice) => {
                        return {value: changeMarginByRegularPrice, label: changeMarginByRegularPrice.toString()};
                    });
                    this.salesDiffPcByRegularPriceOptionsForDetailTable = result.salesDiffPcByRegularPrices.map((salesDiffPcByRegularPrice) => {
                        return {value: salesDiffPcByRegularPrice, label: salesDiffPcByRegularPrice.toString()};
                    });
                    this.revenueDiffPcByRegularPriceOptionsForDetailTable = result.revenueDiffPcByRegularPrices.map((revenueDiffPcByRegularPrice) => {
                        return {value: revenueDiffPcByRegularPrice, label: revenueDiffPcByRegularPrice.toString()};
                    });
                    this.marginDiffPcByRegularPriceOptionsForDetailTable = result.marginDiffPcByRegularPrices.map((marginDiffPcByRegularPrice) => {
                        return {value: marginDiffPcByRegularPrice, label: marginDiffPcByRegularPrice.toString()};
                    });
                    this.marginDiffSecondByRegularPriceOptionsForDetailTable = result.marginDiffSecondByRegularPrices.map((marginDiffSecondByRegularPrice) => {
                        return {value: marginDiffSecondByRegularPrice, label: marginDiffSecondByRegularPrice.toString()};
                    });
                    this.individualPriceOptStrategyOptionsForDetailTable = result.individualPriceOptStrategy.map((individualPriceOptStrategy) => {
                        return {value: individualPriceOptStrategy, label: individualPriceOptStrategy};
                    });
                    this.individualPriceIncreaseLimitOptionsForDetailTable = result.individualPriceIncreaseLimits.map((individualPriceIncreaseLimit) => {
                        return {value: individualPriceIncreaseLimit, label: individualPriceIncreaseLimit.toString()};
                    });
                    this.individualPeriodPriceIncreaseLimitOptionsForDetailTable = result.individualPeriodPriceIncreaseLimits.map((individualPeriodPriceIncreaseLimit) => {
                        return {value: individualPeriodPriceIncreaseLimit, label: individualPeriodPriceIncreaseLimit.toString()};
                    });
                    this.individualPeriodOptionsForDetailTable = result.individualPeriods.map((individualPeriod) => {
                        return {value: individualPeriod, label: individualPeriod};
                    });
                    this.individualMarginalProfitOptionsForDetailTable = result.individualMarginalProfits.map((individualMarginalProfit) => {
                        return {value: individualMarginalProfit, label: individualMarginalProfit.toString()};
                    });
                    this.individualKviStrategyOptionsForDetailTable = result.individualKviStrategys.map((individualKviStrategy) => {
                        return {value: individualKviStrategy, label: individualKviStrategy};
                    });
                    this.individualPercentCorrectionOptionsForDetailTable = result.individualPercentCorrections.map((individualPercentCorrection) => {
                        return {value: individualPercentCorrection, label: individualPercentCorrection};
                    });
                    this.individualNewProductPriceStrategyOptionsForDetailTable = result.individualNewProductPriceStrategys.map((individualNewProductPriceStrategy) => {
                        return {value: individualNewProductPriceStrategy, label: individualNewProductPriceStrategy};
                    });
                    this.individualPriceGapPercentOptionsForDetailTable = result.individualPriceGapPercents.map((individualPriceGapPercents) => {
                        return {value: individualPriceGapPercents, label: individualPriceGapPercents.toString()};
                    });
                    this.batchNumberOptionsForDetailTable = result.batchNumbers.map((batchNumbers) => {
                        return {value: batchNumbers, label: batchNumbers};
                    });
                    this.approvedByFioOptionsForDetailTable = result.approvedByFioList.map((approvedByFio) => {
                        return {value: approvedByFio, label: approvedByFio}
                    });
                    
                    // Добавляем опции для фильтрации статусов согласования
                    this.isApprovedOptionsForDetailTable = [
                        {value: 'APPROVED', label: this.$t('results.messages.approved') as string},
                        {value: ApprovalStatus.NOT_APPROVED, label: this.$t('results.messages.notApproved') as string}
                    ];
                    this.priceExperimentOptionsForDetailTable = [
                        {value: 'all', label: this.$t('shared.selectBox.all') as string},
                        {value: 'true', label: this.$t('shared.labels.yes') as string},
                        {value: 'false', label: this.$t('shared.labels.no') as string}
                    ];
                    this.productVerticalLineOptionsForDetailTable = result.productVerticalLines.map((productVerticalLine) => {
                        return {value: productVerticalLine, label: productVerticalLine}
                    });
                    this.detailedStatusOptionsForDetailTable = (result.detailedStatuses || []).map((detailedStatus) => {
                        return {value: detailedStatus, label: detailedStatus};
                    });
                    this.salePointCodeOptionsForDetailTable = result.salePointCodes.map((salePointCode) => {
                        return {value: salePointCode, label: salePointCode.toString()};
                    });

                    const columnsWithEmptyOption = ['keyProduct1', 'keyProduct2', 'skuLine', 'minCompetitorName', 'maxCompetitorName', 'minCompetitorCode', 'maxCompetitorCode', 'minPromoCompetitorName', 'maxPromoCompetitorName', 'minPromoCompetitorCode', 'maxPromoCompetitorCode', 'productVerticalLine', 'deltaDiffPrice'];

                    columnsWithEmptyOption.forEach(columnName => {
                        if ((this as any)[`${columnName}OptionsForDetailTable`]) {
                            (this as any)[`${columnName}OptionsForDetailTable`] = [{value: 'EMPTY_VALUE', label: this.$t('results.messages.emptyValue') as string}, ...(this as any)[`${columnName}OptionsForDetailTable`]]
                        }
                    })

                    setTimeout(() => {
                        const fields = (() => {
                            switch (this.reportType) {
                                case 'promo':
                                    return [...this.promoDetailReport];
                                case 'sales':
                                    return [...this.salesDetailReport];
                                default:
                                    return [...this.regularDetailReport];
                            }
                        })();

                        fields.forEach((item) => {
                            this.tableFilterOptions[item.dataIndex] = this.getFilters(item.dataIndex);
                        });

                        if (this.reportType === 'promo') {
                            this.promoDetailReport = fields;
                        } else if (this.reportType === 'sales') {
                            this.salesDetailReport = fields;
                        } else {
                            this.regularDetailReport = fields;
                        }
                    }, 1000);
                }).catch((err) => {
                    console.log(err)
            });
        }

        resetTableSortingField() {
            this.sortingField = null;
        }

        resetAllFiltersFields() {
            this.selectTaskIdForDetailTable = []
            this.selectGroupNameForDetailTable = []
            this.selectCategoryNameForDetailTable = []
            this.selectSubcategoryNamesForDetailTable = []
            this.selectFormatNameForDetailTable = []
            this.selectRegionNameForDetailTable = []
            this.selectClusterNameForDetailTable = []
            this.selectSegmentNameForDetailTable = []
            this.selectInternalCodeForDetailTable = []
            this.selectSkuNameForDetailTable = []
            this.selectEventTriggerForDetailTable = this.defaultFilterValue;
            this.selectKVIForDetailTable = this.defaultFilterValue;
            this.selectCTMForDetailTable = this.defaultFilterValue;
            this.selectCtmBrandForDetailTable = []
            this.selectCtmPriceGapForDetailTable = []
            this.selectMinRetailPriceForDetailTable = []
            this.selectMaxRetailPriceForDetailTable = []
            this.selectKeyProduct1ForDetailTable = []
            this.selectKeyProduct2ForDetailTable = []
            this.selectRecipeAttributeForDetailTable = []
            this.selectTreatmentAttributeForDetailTable = []
            this.selectVitalMedicineForDetailTable = this.defaultFilterValue;
            this.selectProducerPriceForDetailTable = []
            this.selectExtraChargePcForDetailTable = []
            this.selectRegistrationPriceForDetailTable = []
            this.selectSegmentPriceForDetailTable = []
            this.selectSkuLineForDetailTable = []
            this.selectPurchasePriceForDetailTable = []
            this.selectPromoPurchasePriceForDetailTable = []
            this.selectAvgRegularPriceForDetailTable = []
            this.selectAvgCashPriceForDetailTable = []
            this.selectAvgCheckPriceForDetailTable = []
            this.selectRegularPriceForDetailTable = []
            this.selectMarginLastPriceForDetailTable = []
            this.selectMinCompetitorPriceForDetailTable = []
            this.selectMinCompetitorNameForDetailTable = []
            this.selectMinCompetitorCodeForDetailTable = []
            this.selectMaxCompetitorPriceForDetailTable = []
            this.selectMaxCompetitorNameForDetailTable = []
            this.selectMaxCompetitorCodeForDetailTable = []
            this.selectAvgCompetitorPriceForDetailTable = []
            this.selectLastCompetitorPriceForDetailTable = []
            this.selectMinPromoCompetitorPriceForDetailTable = []
            this.selectMinPromoCompetitorNameForDetailTable = []
            this.selectMinPromoCompetitorCodeForDetailTable = []
            this.selectMaxPromoCompetitorPriceForDetailTable = []
            this.selectMaxPromoCompetitorNameForDetailTable = []
            this.selectMaxPromoCompetitorCodeForDetailTable = []
            this.selectMedianPromoCompetitorPriceForDetailTable = []
            this.selectLastPromoCompetitorPriceForDetailTable = []
            this.selectPiForDetailTable = []
            this.selectActualSalesForDetailTable = []
            this.selectActualRevenueForDetailTable = []
            this.selectActualMarginForDetailTable = []
            this.selectActualMarginPercentForDetailTable = []
            this.selectComparableSalesForDetailTable = []
            this.selectComparableRevenueForDetailTable = []
            this.selectComparableMarginForDetailTable = []
            this.selectComparableMarginPcForDetailTable = []
            this.selectNewPriceForDetailTable = []
            this.selectNewPromoPriceForDetailTable = []
            this.selectCorrectedRegularPriceForDetailTable = []
            this.selectCorrectedPromoPriceForDetailTable = []
            this.selectNewMarginPcForDetailTable = []
            this.selectNewPIForDetailTable = []
            this.selectDeltaDiffPriceForDetailTable = []
            this.selectPriceDiffPcForDetailTable = []
            this.selectMarginDiffForDetailTable = []
            this.selectChangedPIForDetailTable = []
            this.selectDiscountDepthForDetailTable = []
            this.selectDiscountDurationForDetailTable = []
            this.selectExitSegmentForDetailTable = []
            this.selectCoeffElasticityForDetailTable = []
            this.selectPromoCoeffElasticityForDetailTable = []
            this.selectSalesForecastForDetailTable = []
            this.selectRevenueForecastForDetailTable = []
            this.selectMarginForecastForDetailTable = []
            this.selectMarginForecastPcForDetailTable = []
            this.selectChangeSalesForDetailTable = []
            this.selectChangeRevenueForDetailTable = []
            this.selectChangeMarginForDetailTable = []
            this.selectSalesDiffPcForDetailTable = []
            this.selectRevenueDiffPcForDetailTable = []
            this.selectMarginDiffPcForDetailTable = []
            this.selectMarginDiffSecondForDetailTable = []
            this.selectIndividualPromoTypeForDetailTable = []
            this.selectIndividualPromoLiftForDetailTable = []
            this.selectSalesForecastByRegularPriceForDetailTable = []
            this.selectRevenueForecastByRegularPriceForDetailTable = []
            this.selectMarginForecastByRegularPriceForDetailTable = []
            this.selectMarginForecastByRegularPricePcForDetailTable = []
            this.selectChangeSalesByRegularPriceForDetailTable = []
            this.selectChangeRevenueByRegularPriceForDetailTable = []
            this.selectChangeMarginByRegularPriceForDetailTable = []
            this.selectSalesDiffPcByRegularPriceForDetailTable = []
            this.selectRevenueDiffPcByRegularPriceForDetailTable = []
            this.selectMarginDiffPcByRegularPriceForDetailTable = []
            this.selectMarginDiffSecondByRegularPriceForDetailTable = []
            this.selectIndividualPriceOptStrategyForDetailTable = []
            this.selectIndividualPriceIncreaseLimitForDetailTable = []
            this.selectIndividualPeriodPriceIncreaseLimitForDetailTable = []
            this.selectIndividualPeriodForDetailTable = []
            this.selectIndividualMarginalProfitForDetailTable = []
            this.selectIndividualKviStrategyForDetailTable = []
            this.selectIndividualPercentCorrectionForDetailTable = []
            this.selectIndividualNewProductPriceStrategyForDetailTable = []
            this.selectIndividualPriceGapPercentForDetailTable = []
            this.selectApprovedByFioForDetailTable = []
            this.selectIsApprovedForDetailTable = []
            this.selectPriceExperimentForDetailTable = {value: 'all', label: this.$t('shared.selectBox.all') as string}
            this.selectProductVerticalLineForDetailTable = []
            this.selectDetailedStatusForDetailTable = []
            this.selectSalePointCodesForDetailTable = [];
        }

        clearDetailTableFilterDisabled() {
            return !this.detailTableSkuFilter;
        }

        hasActiveFilters(params: ReportDetailParams): boolean {
            // Проверяем текстовый поиск
            if (params.detailTableSkuFilter && params.detailTableSkuFilter.trim() !== '') {
                return true;
            }

            // Проверяем все фильтры в объекте params, используя рефлексию
            const filterKeys = Object.keys(params) as (keyof ReportDetailParams)[];

            for (const key of filterKeys) {
                // Пропускаем служебные поля
                if (['sortingField', 'detailTableSkuFilter', 'taskType', 'selectActiveProductsOnly'].includes(key as string)) {
                    continue;
                }

                const value = params[key];

                // Проверяем массивы
                if (Array.isArray(value) && value.length > 0) {
                    return true;
                }

                // Проверяем булевы значения фильтров (condition поля)
                if (typeof value === 'boolean' || typeof value === 'number') {
                    // Для condition полей: если значение отличается от дефолтного, значит фильтр активен
                    if (key.toString().includes('Condition')) {
                        // Дефолтные значения для condition полей обычно -1 или null
                        if (value !== -1 && value !== null && value !== undefined) {
                            return true;
                        }
                    }
                }
            }

            return false;
        }

        isRowCheckboxChecked(id: string, internalCode: string, taskId: number) {
            const key = `${id}::${taskId}::${internalCode}`;

            if (this.isAllSkusCommonCheckboxSelectedFunctionally) {
                return !this.excludedSkusProperties.has(key);
            } else {
                return this.includedSkusProperties.has(key);
            }
        }

        handleRowCheckboxClicked(item: any, value: boolean) {
            const key = `${item.id}::${item.taskId}::${item.internalCode}`;

            if (this.isAllSkusCommonCheckboxSelectedFunctionally) {
                if (value) {
                    this.removeFromExcludedSkusProperties(key);
                } else {
                    this.addToExcludedSkusProperties(key);

                    if (!item.activeProduct) {
                        this.arrayOfPushedInactiveSkus.push({
                            id: item.id,
                            internalCode: item.internalCode,
                            taskId: item.taskId,
                        });
                    }
                }
            } else {
                if (value) {
                    this.addToIncludedSkusProperties(key);

                    if (!item.activeProduct) {
                        this.arrayOfPushedInactiveSkus.push({
                            id: item.id,
                            internalCode: item.internalCode,
                            taskId: item.taskId,
                        });
                    }
                } else {
                    this.removeFromIncludedSkusProperties(key);
                }
            }
        }

        addChangedProductsToArrays(row: ResultTableDetailReports, selected: boolean) {
            const taskIdIndex = this.changesPrices.findIndex((item) => {
                return item.taskId === row.taskId
            });
            if (selected) {
                if (!row.activeProduct) {
                    if (taskIdIndex === -1) {
                        const chPrice = new ChangesPrices();
                        chPrice.taskId = row.taskId
                        chPrice.productCodesForAdd.push(row.internalCode)
                        this.changesPrices.push(chPrice)
                    } else {
                        this.changesPrices[taskIdIndex].productCodesForAdd.push(row.internalCode)
                    }
                }
                if (taskIdIndex !== -1) {
                    const delIndex = this.changesPrices[taskIdIndex].productCodesForDelete.findIndex((item) => {
                        return item === row.internalCode
                    });
                    if (delIndex !== -1) {
                        this.changesPrices[taskIdIndex].productCodesForDelete.splice(delIndex, 1);
                    }
                }
            } else {
                if (row.activeProduct) {
                    if (taskIdIndex === -1) {
                        const chPrice = new ChangesPrices();
                        chPrice.taskId = row.taskId
                        if (row.priceDiffPc != 0) {
                            chPrice.productCodesForDelete.push(row.internalCode)
                        }
                        this.changesPrices.push(chPrice)
                    } else {
                        if (row.priceDiffPc != 0) {
                            this.changesPrices[taskIdIndex].productCodesForDelete.push(row.internalCode)
                        }
                    }
                }
                if (taskIdIndex !== -1) {
                    const addIndex = this.changesPrices[taskIdIndex].productCodesForAdd.findIndex((item) => {
                        return item === row.internalCode
                    });
                    if (addIndex !== -1) {
                        this.changesPrices[taskIdIndex].productCodesForAdd.splice(addIndex, 1);
                    }
                }
            }
        }

        disableCorrectedPrice(row: ResultTableDetailReports): boolean {
            // Блокируем редактирование для автосогласованных товаров
            if (this.getApprovalStatus(row) === ApprovalStatus.APPROVED_AUTOMATICALLY) {
                return true;
            }
            
            if (this.isTaskStatusApproved() || row.isApproved) {
              return true
            }
            const taskIdIndex = this.changesPrices.findIndex((item) => {
                return item.taskId === row.taskId
            });

            if (taskIdIndex !== -1) {
                let isRowSelected: boolean;
                const key = `${row.id}::${row.taskId}::${row.internalCode}`;

                if (this.isAllSkusCommonCheckboxSelectedFunctionally) {
                    isRowSelected = !this.excludedSkusProperties.has(key);
                } else {
                    isRowSelected = this.includedSkusProperties.has(key);
                }

                return this.disableEdit || !row.activeProduct || !isRowSelected;
            } else {
                return this.disableEdit || !row.activeProduct
            }
        }

        isTaskStatusApproved(): boolean {
          return this.taskData != null && this.taskData.status == TaskStatus.APPROVED
        }

        showRoundPricesWithEqualCompStrategy(): boolean {
            return this.$packageParamsInDetailReport.competitorsPriceStrategy.value === CompetitorsPriceStrategies.EQUALS;
        }

        hideNewProductPricingPanel(): boolean {
            return this.$disallowedModules.includes('newProduct-pricing');
        }

        getPackageParamsDetailFilter(): PackageParamsInDetailReportFilters {
            return {
                coefficientK1: this.$packageParamsInDetailReport.selectCoefficent.value.k1,
                coefficientK2: this.$packageParamsInDetailReport.selectCoefficent.value.k2,
                allCheck: this.$packageParamsInDetailReport.allCheck,
                discountPrise: this.$packageParamsInDetailReport.discountPrice,
                pennies: this.$packageParamsInDetailReport.pennies,
                randomPennies: this.$packageParamsInDetailReport.randomPennies,
                countPriceBySkuWithoutBatches: this.$packageParamsInDetailReport.countPriceBySkuWithoutBatches,
                countByAvgPurchasePrice: this.$packageParamsInDetailReport.countByAvgPurchasePrice,
                calcPurchasePriceByClusters: this.$packageParamsInDetailReport.calcPurchasePriceByClusters,
                useEmptyRemains: this.$packageParamsInDetailReport.useEmptyRemains,
                useArrivalDate: this.$packageParamsInDetailReport.useArrivalDate,
                countAtLastPurchasePrice: this.$packageParamsInDetailReport.countAtLastPurchasePrice,
                countAtFuturePurchasePrice: this.$packageParamsInDetailReport.countAtFuturePurchasePrice,
                allNewPricesWithoutPennies: this.$packageParamsInDetailReport.allNewPricesWithoutPennies,
                allClaster: this.$packageParamsInDetailReport.allClaster,
                xyzChecked: this.$packageParamsInDetailReport.xyzChecked,
                uvwChecked: this.$packageParamsInDetailReport.uvwChecked,
                spreadUVWParams: this.$packageParamsInDetailReport.uvwParams,
                spreadXYZParams: this.$packageParamsInDetailReport.xyzParams,
                intervalOfUltimateElasticity: this.$packageParamsInDetailReport.intervalOfUltimateElasticity,
                calculationDepth: this.$packageParamsInDetailReport.calculationDepth,
                calculationDay: this.$packageParamsInDetailReport.calculationDay,
                competitorsPricesParams: this.$packageParamsInDetailReport.competitorsPrices,
                minProfitKVI: this.$packageParamsInDetailReport.minProfitKVI,
                maxProfitKVI: this.$packageParamsInDetailReport.maxProfitKVI != null ? this.$packageParamsInDetailReport.maxProfitKVI : 100,
                percentageOfCompetitorsPrice: this.$packageParamsInDetailReport.percentageOfCompetitorsPrice,
                marginalProfitability: this.$packageParamsInDetailReport.marginalProfitability,
                marginalProfit: this.$packageParamsInDetailReport.marginalProfit,
                maxMarginalProfit: this.$packageParamsInDetailReport.maxMarginalProfit != null ? this.$packageParamsInDetailReport.maxMarginalProfit : 100,
                marginalPriceDifference: this.$packageParamsInDetailReport.marginalPriceDifference,
                priceIncreaseLimit: this.$packageParamsInDetailReport.priceIncreaseLimit,
                priceDecreaseLimit: this.$packageParamsInDetailReport.priceDecreaseLimit,
                kviPriceDecreaseLimit: this.$packageParamsInDetailReport.kviPriceDecreaseLimit,
                compPriceDecreaseLimit: this.$packageParamsInDetailReport.compPriceDecreaseLimit,
                correlation: this.$packageParamsInDetailReport.correlation,
                highElasticity: this.$packageParamsInDetailReport.highElasticity,
                kviStrategy: this.$packageParamsInDetailReport.kviStrategy.value,
                period: this.$packageParamsInDetailReport.period.value,
                periodPriceIncreaseLimit: this.$packageParamsInDetailReport.periodPriceIncreaseLimit,
                priceCorridor: this.$packageParamsInDetailReport.priceCorridor,
                fixLowerBorder: this.$packageParamsInDetailReport.fixLowerBorder,
                depthToPurchasePrice: this.$packageParamsInDetailReport.depthToPurchasePrice,
                priceFamilies: this.$packageParamsInDetailReport.priceFamilies,
                hardPriceFamilies: this.$packageParamsInDetailReport.hardPriceFamilies,
                changePriceCorridor: this.$packageParamsInDetailReport.changePriceCorridor,
                useCompetitorsPrices: this.$packageParamsInDetailReport.useCompetitorsPrices,
                byPromoPrices: this.$packageParamsInDetailReport.byPromoPrices,
                roundPricesWithEqualCompStrategy: this.$packageParamsInDetailReport.roundPricesWithEqualCompStrategy,
                competitorsPricePeriod: this.$packageParamsInDetailReport.competitorsPricePeriod,
                competitorsPriceMethod: this.$packageParamsInDetailReport.competitorsPriceMethod.value,
                newProductPriceStrategy: this.$packageParamsInDetailReport.newProductPriceStrategy.value,
                priceGap: this.$packageParamsInDetailReport.priceGap,
                priceGapCtmPc: this.$packageParamsInDetailReport.priceGapCtmPc,
                manualPennies: this.$packageParamsInDetailReport.manualPennies,
                competitorsPriceAdjustment: this.$packageParamsInDetailReport.competitorsPriceAdjustment,
                competitorsInfluencesCoef: this.$packageParamsInDetailReport.competitorsInfluencesCoef,
                competitorsMinimumProfit: this.$packageParamsInDetailReport.competitorsMinimumProfit,
                competitorsMaximumProfit: this.$packageParamsInDetailReport.competitorsMaximumProfit != null ? this.$packageParamsInDetailReport.competitorsMaximumProfit : 100,
                competitorsControlParam: this.$packageParamsInDetailReport.competitorsControlParam,
                competitorsPriceStrategy: this.$packageParamsInDetailReport.competitorsPriceStrategy.value,
                roundKviCompetitorPrice: this.$packageParamsInDetailReport.roundKviCompetitorPrice,
                calculateByRegression: this.$packageParamsInDetailReport.calculateByElasticity,
                recalculateCtm: this.$packageParamsInDetailReport.recalculateCtm,
                priceChangeLimit: this.$packageParamsInDetailReport.priceChangeLimit,
                calculatePYR: this.$packageParamsInDetailReport.calculatePYR,
                calculateCompAllowedDeviation: this.$packageParamsInDetailReport.calculateCompAllowedDeviation,
                useCompElasticity: this.$packageParamsInDetailReport.useCompElasticity,
                forecastAccuracy: this.$packageParamsInDetailReport.forecastAccuracy,
                countAtMaxPurchasePrice: this.$packageParamsInDetailReport.countAtMaxPurchasePrice,
                useAllProductBatchNumbers: this.$packageParamsInDetailReport.useAllProductBatchNumbers,
                priceOpt: this.$packageParamsInDetailReport.selectCoefficent.value.enum,
                lift: this.$packageParamsInDetailReport.lift,
                crossCalculation: this.$packageParamsInDetailReport.crossCalculation,
                promoType: this.$packageParamsInDetailReport.promoType.value,
                availableStockDelta: this.$packageParamsInDetailReport.availableStockDelta,
                calculateCommon: this.$packageParamsInDetailReport.calculateCommon,
                intervalOfCorrelationElasticity: this.$packageParamsInDetailReport.intervalOfCorrelationElasticity,
                useDiscountDurationForForecastCalculation: this.$packageParamsInDetailReport.useDiscountDurationForForecastCalculation,
                excludeOutOfStock: this.$packageParamsInDetailReport.excludeOutOfStock,
                backBasketPart: this.$packageParamsInDetailReport.backBasketPart,
                percentileType: this.$packageParamsInDetailReport.percentileType.value,
                checkMarginDeclineProfit: this.$packageParamsInDetailReport.checkMarginDeclineProfit,
                declineProfitabilityPc: this.$packageParamsInDetailReport.declineProfitabilityPc,
                searchPreviousPricesDepth: this.$packageParamsInDetailReport.searchPreviousPricesDepth,
                compensateLowerTargets: this.$packageParamsInDetailReport.compensateLowerTargets,
                spreadByPriceSegments: this.$packageParamsInDetailReport.spreadByPriceSegments
            };
        }

        private clearDetailTableFilter() {
            this.detailTableSkuFilter = '';
            this.resetTableSortingField();
            this.resetAllFiltersFields()
            this.refreshDetailTable()
        }

        private loadHeaders() {
            this.downloadLastExcelHeaderByFilters = true;
            this.refreshHeaderTable();
        }

        private loadDetails() {
            this.downloadLastExcelDetailByFilters = true;
        }

        private refreshDetailTable() {
            const oldRefreshId = this.refreshDetailTableId;
            if (oldRefreshId !== -1) {
                clearTimeout(oldRefreshId);
            }
            const timeoutId = setTimeout(() => {
                if (this.refreshDetailTableId === timeoutId) {
                    const pagination = { ...this.pagination }
                    pagination.current = 1;
                    this.pagination = pagination
                    const detailTable = this.$refs.resultDetailReportRef as any;
                    if (typeof detailTable !== 'undefined') {
                        this.fetchResultTableDetailReports()
                        detailTable.$forceUpdate();
                    }
                    this.refreshDetailTableId = -1;
                }
            }, 300);
            this.refreshDetailTableId = timeoutId;
        }

        private refreshHeaderTable() {
            const oldRefreshId = this.refreshHeaderTableId;
            if (oldRefreshId !== -1) {
                clearTimeout(oldRefreshId);
            }
            const timeoutId = setTimeout(() => {
                if (this.refreshHeaderTableId === timeoutId) {
                    this.skuListCurrentPage = 1;
                    const headerTable = this.$refs.resultHeaderTableRef as any;
                    if (typeof headerTable !== 'undefined' && typeof headerTable.refresh === 'function') {
                        headerTable.refresh();
                    }
                    this.refreshHeaderTableId = -1;
                }
            }, 300);
            this.refreshHeaderTableId = timeoutId;
        }

        getLabel(array: any[], key: string) {
            return array.find((item:any) => key === item.key).label
        }

        private getSegmentPriceForDetailReport() {
            if (this.taskData == null) {
                return
            }
            this.httpGetPriceSegmentsForDetailReport(this.taskData.id, this.taskData.type)
                .then((data) => {
                    this.segmentPriceOptionsForDetailTable = data.data.map((i) => {
                        return {value: i, label: i.name}
                    });
                })
                .catch((e) => {
                    this.showError(this.$t('results.messages.errorSearchPriceSegments') as string)
                })
        }

        private setShowDeletedItems(showDeleted: boolean) {
            this.showDeletedItems = showDeleted
            this.selectActiveProductsOnly = !showDeleted

            if (!showDeleted) {
                const newIncludedSet = new Set(this.includedSkusProperties);
                const newExcludedSet = new Set(this.excludedSkusProperties);
                
                this.arrayOfPushedInactiveSkus.forEach(sku => {
                    const key = `${sku.id}::${sku.taskId}::${sku.internalCode}`;

                    newIncludedSet.delete(key);
                    newExcludedSet.delete(key);
                });

                this.includedSkusProperties = newIncludedSet;
                this.excludedSkusProperties = newExcludedSet;
                this.arrayOfPushedInactiveSkus = [];
            }

            this.refreshDetailTable()
        }

        handleApproveInRowBtnClick(id: number, internalCode: string) {
            Modal.confirm({
                title: this.$t('results.modals.approveItemTitle') as string,
                content: this.$t('results.modals.approveItemContent', { code: internalCode || '-' }) as string,
                centered: true,
                okText: this.$t('results.modals.okApprove') as string,
                cancelText: this.$t('shared.buttons.cancel') as string,
                onOk: () => {
                    if (!this.taskData) {
                        this.showError(this.$t('results.messages.noCalcInfo') as string);

                        return;
                    }

                    this.httpApproveReportDetailLines(
                        this.taskData.id,
                        {
                            isCommonCheckboxSelected: false,
                            includedIds: [id],
                            excludedIds: [],
                        },
                    ).then(() => {
                        this.showInfo(this.$t('results.messages.itemApproved') as string);

                        this.fetchResultTableDetailReports();
                    });
                },
            });
        }

        handleApproveSelectedBtnClick() {
            Modal.confirm({
                title: this.$t('results.modals.approveSelectedTitle') as string,
                content: this.$t('results.modals.approveSelectedContent') as string,
                centered: true,
                okText: this.$t('results.modals.okApprove') as string,
                cancelText: this.$t('shared.buttons.cancel') as string,
                onOk: () => {
                    if (!this.taskData || !this.taskData.id) {
                        this.showError(this.$t('results.messages.noReportInfo') as string)

                        return;
                    }

                    this.tableIsLoading = true;

                    this.httpApproveReportDetailLines(this.taskData.id, {
                        isCommonCheckboxSelected: this.isAllSkusCommonCheckboxSelectedFunctionally,
                        includedIds: this.getIncludedSkusPropertiesArray().map(data => data.id),
                        excludedIds: this.getExcludedSkusPropertiesArray().map(data => data.id),
                    })
                        .then(() => {
                            this.showInfo(this.$t('results.messages.selectedApproved') as string);
                            this.fetchResultTableDetailReports();
                            this.fetchTaskData();
                        })
                        .catch(() => {
                            this.showError(this.$t('results.messages.errorApproveSelected') as string)
                        })
                        .finally(() => {
                            setTimeout(() => {
                                this.tableIsLoading = false;
                            }, 3000);
                        });
                },
            });
        }

        importCorrectedPricesFileAndRecalculate() {
          if (!this.correctedPricesFile) {
            this.showInfo(this.$t('results.messages.selectFile') as string);
            return;
          }

          // Проверяем наличие автосогласованных товаров
          const autoApprovedItems = this.resultTableDetailReports.filter(row => 
            this.getApprovalStatus(row) === ApprovalStatus.APPROVED_AUTOMATICALLY
          );
          
          if (autoApprovedItems.length > 0) {
            this.showInfo(this.$t('results.messages.autoApprovedExcluded', { count: autoApprovedItems.length }) as string);
          }

          this.loadProgress = true;

          const uploadFile = new FormData();
          const size = this.correctedPricesFile.size;
          const taskId = this.taskData && this.taskData.id;
          const taskType = this.taskData && this.taskData.type
          const regularTypes = [
            'PACKAGE_GENERAL',
            'PACKAGE_GENERAL_KVI_CARTS',
            'PACKAGE_GENERAL_SCENARIO',
            'PACKAGE_EVENTS_GENERAL',
            'PACKAGE_GENERAL_FIXED_PRICE',
          ] as const;

          const uploadMode =
              taskType === 'PACKAGE_GENERAL_PROMOTION'
                  ? PriceImportMode.PROMO
                  : taskType === 'PACKAGE_GENERAL' ||
                  taskType === 'PACKAGE_GENERAL_KVI_CARTS' ||
                  taskType === 'PACKAGE_GENERAL_SCENARIO' ||
                  taskType === 'PACKAGE_EVENTS_GENERAL' ||
                  taskType === 'PACKAGE_GENERAL_FIXED_PRICE'
                      ? PriceImportMode.REGULAR
                      : null;

          uploadFile.append(
              'file',
              new Blob([this.correctedPricesFile]),
              this.correctedPricesFile.name
          );

          if (taskId !== null) {
            if (!uploadMode) {
              this.showError(this.$t('results.messages.importNotAvailableForType', { type: (this.taskData && this.taskData.type) || '' }) as string);
              this.loadProgress = false;
              this.progressCounter = 0;
              return;
            }
            this.httpUploadCorrectedPricesFile(taskId, uploadFile, uploadMode)
                .then((r) => {
                  const hasAnySaved = r.data;
                  this.correctedPricesFile = null;
                  this.showInfo(this.$t('results.messages.priceCorrectionsLoaded') as string);
                  if (hasAnySaved) {
                    this.changesPrices = [];
                    this.hasUnsavedRegularPrices = false;
                    this.hasUnsavedPromoPrices = false;
                    this.hasCorrectedPrices = true;
                    this.refreshDetailTable();
                  }
                })
                .catch((e) => {
                  const message = typeof e.response.data === 'string'
                      ? e.response.data
                      : e.message || this.$t('results.messages.unknownError') as string;

                  this.showError(this.$t('results.messages.errorImportCorrectedPrices', { message }) as string);
                })
                .finally(() => {
                  this.loadProgress = false;
                  this.progressCounter = 0;
                });
          } else {
            this.loadProgress = false;
            this.progressCounter = 0;
          }
        }

        getApprovalStatus(data: ResultTableDetailReports): ApprovalStatus {
            return data.approvalStatus || ApprovalStatus.NOT_APPROVED;
        }

        disableApproveButton(data: ResultTableDetailReports): boolean {
          // Блокируем кнопку для автосогласованных товаров
          if (this.getApprovalStatus(data) === ApprovalStatus.APPROVED_AUTOMATICALLY) {
            return true;
          }
          
          return (!!this.taskData && 
                  this.taskData.status != TaskStatus.ONAPPROVAL && 
                  this.taskData.status != TaskStatus.PARTIALLY_APPROVED && 
                  this.taskData.status != 'PartiallyApproved')
              || !this.isRowCheckboxChecked(data.id, data.internalCode, data.taskId);
        }

        get isApproveSelectedBtnDisabled(): boolean {
          return !this.taskData
              || (this.taskData.status != TaskStatus.ONAPPROVAL && 
                  this.taskData.status != TaskStatus.PARTIALLY_APPROVED && 
                  this.taskData.status != 'PartiallyApproved')
              || this.tableIsLoading
              || !this.isTableHasSelectedRows;
        }

        fetchTaskData() {
          if (!this.taskData) {
            return
          }
          this.httpLoadTaskById(this.taskData.id)
              .then((r) => {
                const task = r.data
                this.taskData = {
                  id: task.id,
                  status: task.status,
                  type: task.typeMachine,
                  fileResult: task.fileResult,
                  editable: task.editable,
                  filterNames: this.taskData!!.filterNames,
                  tradingId: task.tradingNetworks.id,
                  taskNote: task.taskNote,
                }
              })
              .catch((e) => {
                this.showError(this.$t('results.messages.errorLoadCalcInfo') as string)
              })
        }

        get columnsForManageModal(): Array<IColumnLight> {
            const columnsLight = (() => {
                const ignoredColumnKeys = this.detailUserFields.filter(field => field.permanentlyHidden).map(field => field.key);

                switch (this.reportType) {
                    case 'promo':
                        return this.promoColumnsForManageModal.filter(column => !ignoredColumnKeys.includes(column.dataIndex));
                    case 'sales':
                        return this.salesColumnsForManageModal.filter(column => !ignoredColumnKeys.includes(column.dataIndex));
                    default:
                        return this.regularColumnsForManageModal
                            .filter(column => !ignoredColumnKeys.includes(column.dataIndex));
                }
            })();

            const adjustedColumns = this.reportType === 'sales'
                ? columnsLight
                    .filter((column) => this.isSalesRealizationReport || !['initialRemains', 'realizationPercent'].includes(column.dataIndex))
                    .map((column) => column.dataIndex === 'remains'
                        ? ({...column, title: this.getSalesRemainsLabel()})
                        : column)
                : columnsLight;

            return this.tableColumnsOrder.length ? this.getOrderedByDataIndexes(adjustedColumns, this.tableColumnsOrder) : adjustedColumns;
        }

        get resultDetailColumns(): any[] {
            const columns = (() => {
                switch (this.reportType) {
                    case 'promo':
                        return this.promoDetailReport;
                    case 'sales':
                        return this.salesDetailReport;
                    default:
                        return this.regularDetailReport;
                }
            })();

            return this.tableColumnsOrder.length ? this.getOrderedByDataIndexes(columns, this.tableColumnsOrder) : columns;
        }

        get disableEdit(): boolean {
            return this.taskData == null || (
                this.taskData.status !== 'WriteToFileComplete' && 
                this.taskData.status !== 'OnApproval' && 
                this.taskData.status !== 'Rejected' && 
                this.taskData.status !== 'Approved' && 
                this.taskData.status !== 'PartiallyApproved' && 
                this.taskData.status !== 'PartiallyRejected'
            );
        }

        get taskId(): string {
            if (this.taskData == null) {
                return ''
            }
            return `${this.taskData.id}`;
        }

        get taskFilters(): string {
            if (this.taskData == null) {
                return ''
            }
            return `${this.taskData.filterNames}`;
        }

        get marginalProfitValidate(): boolean {
            const marginalProfit = this.$packageParamsInDetailReport.marginalProfit;
            if (marginalProfit < 0) {
                this.marginalErrorText = this.$t('results.messages.negativeMarginWarning') as string
            } else {
                this.marginalErrorText = ''
            }
            return marginalProfit.toString() !== '' && marginalProfit < 100;
        }

        get priceIncreaseLimitValidate(): boolean {
            const priceIncreaseLimit = this.$packageParamsInDetailReport.priceIncreaseLimit;
            return priceIncreaseLimit.toString() !== '' && priceIncreaseLimit >= 0;
        }

        get priceDecreaseLimitValidate(): boolean {
            const priceDecreaseLimit = this.$packageParamsInDetailReport.priceDecreaseLimit;
            return priceDecreaseLimit != null && priceDecreaseLimit.toString() !== '' && priceDecreaseLimit >= 0;
        }

        get kviPriceDecreaseLimitValidate(): boolean {
            const kviPriceDecreaseLimit = this.$packageParamsInDetailReport.kviPriceDecreaseLimit;
            return kviPriceDecreaseLimit != null &&  kviPriceDecreaseLimit.toString() !== '' && kviPriceDecreaseLimit >= 0;
        }

        get compPriceDecreaseLimitValidate(): boolean {
            const compPriceDecreaseLimit = this.$packageParamsInDetailReport.compPriceDecreaseLimit;
            return compPriceDecreaseLimit != null && compPriceDecreaseLimit.toString() !== '' && compPriceDecreaseLimit >= 0;
        }

        get priceChangeLimitValidate(): boolean {
            const priceChangeLimit = this.$packageParamsInDetailReport.priceChangeLimit;
            return priceChangeLimit >= 0 && priceChangeLimit < 100;
        }

        get periodPriceIncreaseLimitValidate(): boolean {
            const periodPriceIncreaseLimit = this.$packageParamsInDetailReport.periodPriceIncreaseLimit;
            return periodPriceIncreaseLimit.toString() !== '' && periodPriceIncreaseLimit >= 0;
        }

        get paramsSumXYZ(): boolean {
            const x = this.$packageParamsInDetailReport.xyzParams.x;
            const y = this.$packageParamsInDetailReport.xyzParams.y;
            const z = this.$packageParamsInDetailReport.xyzParams.z;
            if (x.toString().length === 0 || y.toString().length === 0 || z.toString().length === 0) {
                return false;
            }
            const sum = (x + y + z);
            return sum === 100;
        }

        get countPriceSegmentsValidate(): boolean {
            const countSegments = this.countPriceSegments;
            return countSegments.toString() !== '' && countSegments > 0;
        }

        get paramsSum(): boolean {
            const u = this.$packageParamsInDetailReport.uvwParams.u;
            const v = this.$packageParamsInDetailReport.uvwParams.v;
            const w = this.$packageParamsInDetailReport.uvwParams.w;
            if (u.toString().length === 0 || v.toString().length === 0 || w.toString().length === 0) {
                return false;
            }
            const sum = (+v + +u + +w);
            return sum === 100;
        }

        get competitorsPricesValidate(): boolean {
            const competitorsP = this.$packageParamsInDetailReport.competitorsPrices.toString();
            const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);

            return numberPattern.test(competitorsP);
        }

        get minProfitKVIValidate(): boolean {
            const minProfitKvi = this.$packageParamsInDetailReport.minProfitKVI;
            return minProfitKvi.toString() !== '' && minProfitKvi >= -50 && minProfitKvi <= 500;
        }

        get competitorsMinProfitValidate(): boolean {
            const competitorsMinimumProfit = this.$packageParamsInDetailReport.competitorsMinimumProfit;
            return competitorsMinimumProfit.toString() !== '';
        }

        get priceGapValidate(): boolean {
            const priceGap = this.$packageParamsInDetailReport.priceGap;
            return priceGap.toString() !== '' && priceGap >= 0;
        }

        get priceGapCtmPcValidate(): boolean {
            const priceGapCtm = this.$packageParamsInDetailReport.priceGapCtmPc;
            return priceGapCtm !== null && priceGapCtm.toString() !== '' && priceGapCtm >= 0 && priceGapCtm <= 100;
        }

        get calculationDepthValidate(): boolean {
            return isCalculationDepthValid(this.$packageParamsInDetailReport.calculationDepth, this.$packageParamsInDetailReport.calculationDay);
        }

        get calculationDepthInvalidMessage(): string {
            if (!isCalculationDepthInRange(this.$packageParamsInDetailReport.calculationDepth)) {
                return this.$t('results.validationMessages.depthMaxWeeks') as string;
            }
            return this.$t('results.validationMessages.depthNotLessThanPeriod') as string;
        }

        get calculationDayValidate(): boolean {
            return isCalculationDayValid(this.$packageParamsInDetailReport.calculationDay);
        }

        get calculationDayInvalidMessage(): string {
            if (!isCalculationDayInRange(this.$packageParamsInDetailReport.calculationDay)) {
                return this.$t('results.validationMessages.forecastPeriodMaxDays') as string;
            }
            return this.$t('results.validationMessages.numberGreaterThanZero') as string;
        }

        get depthToPurchasePriceValidate(): boolean {
            return isDepthToPurchasePriceValid(this.$packageParamsInDetailReport.depthToPurchasePrice);
        }

        get isDisabledPriceBorder(): boolean {
            return !this.$packageParamsInDetailReport.changePriceCorridor;
        }

        get inputIntervalP(): boolean {
            if (this.isDisabledPriceBorder) {
                return true;
            }
            const lowerI = this.$packageParamsInDetailReport.priceCorridor.min.toString();
            const upperI = this.$packageParamsInDetailReport.priceCorridor.max.toString();
            if (this.$packageParamsInDetailReport.priceCorridor.min >= this.$packageParamsInDetailReport.priceCorridor.max || this.$packageParamsInDetailReport.priceCorridor.min >= this.$packageParamsInDetailReport.priceCorridor.max) {
                return false;
            }
            const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
            if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
                return false;
            }
            return (parseFloat(lowerI) < parseFloat(upperI));
        }

        get highElasticityCheck(): boolean {
            const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
            const highElasticity = this.$packageParamsInDetailReport.highElasticity.toString();
            this.$log.debug(highElasticity.length > 0, numberPattern.test(highElasticity));
            return numberPattern.test(highElasticity);
        }

        get correlationCheck(): boolean {
            const correlation = this.$packageParamsInDetailReport.correlation.toString();
            const cor = parseFloat(correlation);
            return 1 >= cor && cor >= -1;
        }

        get marginalProfitabilityValidate(): boolean {
            const marginalProfitability = this.$packageParamsInDetailReport.marginalProfitability;
            if (marginalProfitability < 0) {
                this.marginalSkuErrorText = this.$t('results.messages.negativeMarginWarning') as string
            } else {
                this.marginalSkuErrorText = ''
            }
            return marginalProfitability < 100;
        }

        get liftPositiveCheck(): boolean {
            return this.$packageParamsInDetailReport.lift >= 0;
        }

        get inputIntervalCorrelation(): boolean {
            const lowerI = this.$packageParamsInDetailReport.intervalOfCorrelationElasticity.lower.toString();
            const upperI = this.$packageParamsInDetailReport.intervalOfCorrelationElasticity.upper.toString();
            const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
            if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
                return false;
            }
            return (parseFloat(lowerI) < parseFloat(upperI));
        }

        get inputInterval(): boolean {
            const lowerI = this.$packageParamsInDetailReport.intervalOfUltimateElasticity.lower.toString();
            const upperI = this.$packageParamsInDetailReport.intervalOfUltimateElasticity.upper.toString();
            const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
            if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
                return false;
            }
            return (parseFloat(lowerI) < parseFloat(upperI));
        }

        get marginalPriceDifferenceValidate(): boolean {
            if (this.$packageParamsInDetailReport.marginalPriceDifference != null) {
                return this.$packageParamsInDetailReport.marginalPriceDifference >= 0 && this.$packageParamsInDetailReport.marginalPriceDifference <= 100;
            }
            return false;
        }

        get enableDepthToPurchasePrice(): boolean {
            return (this.$packageParamsInDetailReport.countByAvgPurchasePrice && this.$packageParamsInDetailReport.useArrivalDate)
                    || (!this.$packageParamsInDetailReport.countByAvgPurchasePrice && !this.$packageParamsInDetailReport.countAtMaxPurchasePrice);
        }

        get backBasketPartValidate(): boolean {
            if (this.$packageParamsInDetailReport.backBasketPart != null) {
                return this.$packageParamsInDetailReport.backBasketPart >= 0 && this.$packageParamsInDetailReport.backBasketPart <= 100;
            }
            return false;
        }

        get marginalProfitDeclinePcValidate(): boolean {
            const declineProfitabilityPc = this.$packageParamsInDetailReport.declineProfitabilityPc;
            return declineProfitabilityPc != null && declineProfitabilityPc < 100;
        }

        get isNotApprovedGeneralReport(): boolean {
          const validTypes = [
            'PACKAGE_GENERAL',
            'PACKAGE_GENERAL_KVI_CARTS',
            'PACKAGE_GENERAL_SCENARIO',
            'PACKAGE_EVENTS_GENERAL',
            'PACKAGE_GENERAL_FIXED_PRICE',
          ];
          return !!(this.taskData && this.taskData.status !== TaskStatus.APPROVED && validTypes.includes(this.taskData.type));
        }

        get isSalesRealizationReport(): boolean {
            return !!this.taskData
                && [TaskType.PACKAGE_GENERAL_SALES, TaskType.PACKAGE_GENERAL_AGGREGATE_SALES].includes(this.taskData.type as TaskType);
        }

        getSalesRemainsLabel(): string {
            return this.$t(this.isSalesRealizationReport ? 'regular.columns.currentDateRemains' : 'salesMonitorTab.tables.reportColumns.remains') as string;
        }

        getSalesDetailFieldLabel(fieldKey: string, defaultLabel: any): any {
            if (fieldKey === 'remains') {
                return this.getSalesRemainsLabel();
            }

            return defaultLabel;
        }

        // for filters
        @Watch("filterValues", {deep: true})
        onFilterValuesChange() {
            Object.keys(this.filterValues).forEach((key) => {
                const filterArray = this.filterValues[key as keyof commonFilters];
                this.updateFilterArray(filterArray);
            });
        }

        updateFilterArray(filterArray: (string | number)[]) {
            if (filterArray.length === 0) {
                filterArray.push("all");
            } else if (filterArray.includes("all") && filterArray.length > 1) {
                filterArray.splice(filterArray.indexOf("all"), 1);
            }
        }

        fetchCommonFilterOptions() {
            this.handleResetFilters(true);

            this.requestFilterOptions("group", "groups");
            this.requestFilterOptions("format", "storeFormat");
        }

        async requestFilterOptions(filterBy: string, keyToChange: keyof commonFilters) {
            const obj: IInfoPayloadData = {
                groups: this.filterValues.groups.filter((item) => item !== "all"),
                categories: this.filterValues.categories.filter((item) => item !== "all"),
                subcategories: this.filterValues.subcategories.filter((item) => item !== "all"),
                storeFormat: this.filterValues.storeFormat.filter((item) => item !== "all"),
                storeRegion: this.filterValues.storeRegion.filter((item) => item !== "all"),
                storeCluster: this.filterValues.storeCluster.filter((item) => item !== "all"),
                tradingId: this.taskData!.tradingId!,
                type: filterBy,
            };

            let payload: any = {
                tradingId: this.taskData!.tradingId,
                type: filterBy,
            };

            Object.keys(obj).filter(key => !['tradingId', 'type'].includes(key)).forEach((optionsType: string) => {
                 payload[optionsType] = (obj[optionsType as keyof IInfoPayloadData] as string[]).map((name: string) => this.filterOptions[optionsType as keyof IFilterOptions]
                    .find((option: {id: string | number, name: string}) => option.name === name)!.id);
            })

            try {
                const response = await this.$http.post("/api/task/info", payload);
                this.filterOptions[keyToChange] = response.data[keyToChange];
            } catch (error) {
                console.error("Error sending POST request:", error);
            }
        }

        fetchHasCorrectedPricesFlag() {
          if (this.taskData == null) {
            this.hasCorrectedPrices = false;
            return;
          }

          const taskId = this.taskData.id;
          const taskType = this.taskData.type;

          this.httpCheckHasCorrectedRegularPrices(taskId, taskType)
              .then((resp) => {
                this.hasCorrectedPrices = resp.data;
              })
              .catch((e) => {
                this.hasCorrectedPrices = false;
                this.showError(this.$t('results.messages.errorLoadCorrectedPricesInfo') as string);
              });
        }

        async handleFilterGroup(elemids: any) {
            this.filterValues.groups = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
            this.filterValues.categories = ["all"];
            this.filterValues.subcategories = ["all"];

            await this.requestFilterOptions("category", "categories");
        }

        async handleFilterCategory(elemids: any) {
            this.filterValues.categories = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
            this.filterValues.subcategories = ["all"];

            await this.requestFilterOptions("subcategory", "subcategories");
        }

        async handleFilterSubcategory(elemids: any) {
            this.filterValues.subcategories = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
        }

        async handleFilterFormat(elemids: any) {
            this.filterValues.storeFormat = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
            this.filterValues.storeRegion = ["all"];
            this.filterValues.storeCluster = ["all"];

            await this.requestFilterOptions("region", "storeRegion");
        }

        async handleFilterRegion(elemids: any) {
            this.filterValues.storeRegion = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
            this.filterValues.storeCluster = ["all"];

            await this.requestFilterOptions("cluster", "storeCluster");
        }

        async handleFilterCluster(elemids: any) {
            this.filterValues.storeCluster = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
        }

        handleApplyFilters(withoutFetch: boolean = false) {
            this.selectGroupNameForDetailTable = this.filterValues.groups.filter((item) => item !== "all");
            this.selectCategoryNameForDetailTable = this.filterValues.categories.filter((item) => item !== "all");
            this.selectSubcategoryNamesForDetailTable = this.filterValues.subcategories.filter((item) => item !== "all");
            this.selectFormatNameForDetailTable = this.filterValues.storeFormat.filter((item) => item !== "all");
            this.selectRegionNameForDetailTable = this.filterValues.storeRegion.filter((item) => item !== "all");
            this.selectClusterNameForDetailTable = this.filterValues.storeCluster.filter((item) => item !== "all");

            // Сбрасываем пагинацию на первую страницу при применении фильтров
            this.pagination.current = 1;

            if (!withoutFetch) {
                this.fetchResultTableDetailReports();
            }
        }

        filterDropdownVisibleChange(filterModel: string) {
            this.filterDropdownsState[filterModel] = !this.filterDropdownsState[filterModel];
        }

        getFilterIconActivity(filterModel: string): boolean {
            const filterValue = (this as any)[this.getForDetailTableVariableName(filterModel)];

            return Array.isArray(filterValue) ?
                !!filterValue.length :
                !!filterValue || filterValue === 0;
        }

        handleCheckboxGroupChanged(filterModel: string, value: string) {
            (this as any)[this.getForDetailTableVariableName(filterModel)] = value;

            // Сбрасываем пагинацию на первую страницу при изменении фильтра
            this.pagination.current = 1;
        }

        handleRadioGroupChanged(filterModel: string, value: number | string) {
            if (filterModel === 'kvi') {
                const index = this.kviOptions.findIndex(item => item.value === value);

                if (index > -1) (this as any)[this.getForDetailTableVariableName(filterModel)] = this.kviOptions[index];
            } else if (filterModel === 'ctm') {
                const index = this.ctmOptionsForDetailTable.findIndex(item => item.value === value);

                if (index > -1) (this as any)[this.getForDetailTableVariableName(filterModel)] = this.ctmOptionsForDetailTable[index];
            } else if (filterModel === 'priceExperiment') {
                const index = this.priceExperimentOptionsForDetailTable.findIndex(item => item.value === value);

                if (index > -1) (this as any)[this.getForDetailTableVariableName(filterModel)] = this.priceExperimentOptionsForDetailTable[index];
            } else {
                (this as any)[this.getForDetailTableVariableName(filterModel)] = value;
            }

            // Сбрасываем пагинацию на первую страницу при изменении фильтра
            this.pagination.current = 1;
        }

        handleAllCheckboxChanged(value: boolean, filterModel: string, filterOptionsKey: string, useRange: boolean = false) {
            this.filterAllCheckboxCheckedState[filterModel] = value;

            const variableName = this.getForDetailTableVariableName(filterModel);

            if (value) {
                (this as any)[variableName] = [
                    ...new Set([
                        ...(this as any)[variableName],
                        ...this.getFilterOptions(filterModel, filterOptionsKey, useRange).map((option: SelectBox<number>) => option.value),
                    ])
                ];
            } else {
                const optionValuesToDeselect = this.getFilterOptions(filterModel, filterOptionsKey, useRange).map((option: SelectBox<number>) => option.value);

                (this as any)[variableName] = (this as any)[variableName].filter((value: string) => !optionValuesToDeselect.includes(value));
            }
        }

        getFilterOptions(filterModel: string, filterOptionsKey: string, useRange: boolean = false) {
            if (useRange) {
                return this.tableFilterOptions[filterOptionsKey].filter((option: SelectBox<number>) => {
                    if ((this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && !(this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                        return option.value >= this.filterDropdownsRange.from[filterModel];
                    } else if (!(this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && (this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                        return option.value <= this.filterDropdownsRange.to[filterModel];
                    } else if ((this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && (this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                        return this.filterDropdownsRange.from[filterModel] <= option.value && option.value <= this.filterDropdownsRange.to[filterModel];
                    } else {
                        return true;
                    }
                })
            } else {
                return this.tableFilterOptions[filterOptionsKey];
            }
        }

        getVariable(variableName: string) {
          return (this as any)[variableName];
        }

        getForDetailTableVariableName(filterModel: string): string {
            let key = filterModel;

            if (key === 'subCategoryName') key = 'subcategoryName'
            if (key === 'productSegmentName') key = 'segmentName'
            if (key === 'segment') key = 'segmentPrice'
            if (key === 'kvi') key = 'KVI'
            if (key === 'ctm') key = 'CTM'

            key = key.charAt(0).toUpperCase() + key.slice(1);

            return (this as any)[`select${key}ForDetailTable`] ? `select${key}ForDetailTable` : `select${key}sForDetailTable`;
        }

        getRadioFilterOptions(filterOptionsKey: string) {
            if (filterOptionsKey === 'priceExperiment') {
                return this.priceExperimentOptionsForDetailTable || [];
            }

            return this.tableFilterOptions[filterOptionsKey] || [];
        }

        handleResetFilters(withoutFetch: boolean = false) {
            this.filterValues = {
                groups: ["all"],
                categories: ["all"],
                subcategories: ["all"],
                storeFormat: ["all"],
                storeRegion: ["all"],
                storeCluster: ["all"],
            };

            // Сбрасываем пагинацию на первую страницу при сбросе фильтров
            this.pagination.current = 1;

            this.handleApplyFilters(withoutFetch);
        }

        prepareDataForPriceHistory(data: any) {
            return data.newPriceHistory.replace('\n', '').split(';').filter((historyItem: string) => historyItem.trim().length).map((historyItem: string) => {
                let resultStr: string = '';
                let value = '';

                resultStr = historyItem.trim();

                if (historyItem.startsWith(this.$t('regular.tooltips.new') as string)) {
                    resultStr = resultStr.slice(6);
                }

                resultStr = resultStr.charAt(0).toUpperCase() + resultStr.slice(1);

                const equalsIndex = resultStr.lastIndexOf(' = ');

                if (equalsIndex !== -1) {
                    value = resultStr.slice(equalsIndex + 3);

                    resultStr = resultStr.slice(0, equalsIndex);
                }

                return {value, resultStr, priceColorClass: resultStr ? this.getPriceColorClass(resultStr) : ''};
            })
        }

    correctionFieldValidate(val: any, required: boolean = false): boolean | null {
        return numberGteZeroState(val, required);
    }

    correctionFieldFeedbackKey(val: any, required: boolean = false): string {
        return numberGteZeroFeedbackKey(val, required);
    }

    competitorsCorrectionsValidate(): boolean {
        const invalid = numberGteZeroState(this.$packageParamsInDetailReport.percentageOfCompetitorsPrice, true) === false
            || numberGteZeroState(this.$packageParamsInDetailReport.competitorsPriceAdjustment, true) === false;

        if (invalid) {
            this.showError(this.$t('regular.validation.competitorsAdjustmentInvalid') as string);
        }

        return !invalid;
    }

    getPriceColorClass(text: string): string {
        const colorClass = Object.keys(this.historyItemsClasses).find(key => {
            return this.historyItemsClasses[key].findIndex((textItem: string) => textItem.toLowerCase() === text.trim().toLowerCase()) > -1;
        })

        return colorClass || '';
    }

    getDetailTableColumnsOrder() {
        const value = (() => {
            switch (this.reportType) {
                case 'promo':
                    return localStorage.getItem('skuDetailPromoColumnsOrder');
                case 'sales':
                    return localStorage.getItem('skuDetailSalesColumnsOrder');
                default:
                    return localStorage.getItem('skuDetailRegularColumnsOrder');
            }
        })();

        this.tableColumnsOrder = value ? value.split(',') : [];
    }

    getOrderedByDataIndexes(arrayForOrder: any[], orderedDataIndexes: string[]) {
        if (!orderedDataIndexes.length) {
            return arrayForOrder;
        }

        const resultArr: any[] = [];

        const objectsWithoutIndexes = arrayForOrder.filter((el: any) => !el.dataIndex);

        resultArr.push(...objectsWithoutIndexes);

        const includedDataIndexes = new Set<string>();

        orderedDataIndexes.forEach(dataIndex => {
            const obj = arrayForOrder.find((obj: any) => obj.dataIndex === dataIndex);

            if (obj) {
                resultArr.push(obj);
                includedDataIndexes.add(dataIndex);
            }
        });

        arrayForOrder.forEach((obj: any) => {
            if (!obj.dataIndex || includedDataIndexes.has(obj.dataIndex)) {
                return;
            }

            const naturalIndex = arrayForOrder.findIndex((el: any) => el.dataIndex === obj.dataIndex);
            let insertAt = resultArr.length;

            for (let i = naturalIndex - 1; i >= 0; i--) {
                const prevDataIndex = arrayForOrder[i].dataIndex;
                if (!prevDataIndex) {
                    continue;
                }

                const prevPos = resultArr.findIndex((el: any) => el.dataIndex === prevDataIndex);
                if (prevPos !== -1) {
                    insertAt = prevPos + 1;
                    break;
                }
            }

            resultArr.splice(insertAt, 0, obj);
            includedDataIndexes.add(obj.dataIndex);
        });

        return resultArr;
    }

    // Partial Rejection Note methods
    hidePartialRejectionNote(): void {
        this.showPartialRejectionNote = false;
    }

    checkAndShowPartialRejectionNote(): void {
        if (!this.taskData) {
            this.showPartialRejectionNote = false;
            return;
        }
        
        const isPartialStatus = this.taskData.status === TaskStatus.PARTIALLY_APPROVED || 
                               this.taskData.status === TaskStatus.PARTIALLY_REJECTED ||
                               this.taskData.status === 'PartiallyApproved' ||
                               this.taskData.status === 'PartiallyRejected';
        
        if (isPartialStatus && this.taskData.taskNote) {
            this.showPartialRejectionNote = true;
            this.partialRejectionMessage = this.taskData.taskNote;
            this.partialRejectionDate = new Date();
            
            if (this.taskData.taskNote.toLowerCase().includes(this.$t('regular.tooltips.newVersion') as string) ||
                this.taskData.taskNote.toLowerCase().includes('new version')) {
                this.partialRejectionReason = 'NEW_VERSION';
            } else if (this.taskData.taskNote.toLowerCase().includes(this.$t('regular.tooltips.validation') as string)) {
                this.partialRejectionReason = 'VALIDATION_ERROR';
            } else if (this.taskData.taskNote.toLowerCase().includes(this.$t('regular.tooltips.error') as string) ||
                      this.taskData.taskNote.toLowerCase().includes('error')) {
                this.partialRejectionReason = 'SYSTEM_ERROR';
            } else {
                this.partialRejectionReason = 'USER_ACTION';
            }
            
            this.partialRejectionAdditionalInfo = this.$t('results.messages.checkDetailsBelow') as string;
        } else {
            this.showPartialRejectionNote = false;
        }
    }
}
